var _defs, _g, _g2, _g3, _g4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGaugeBackgroundRevNew(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "210mm",
    height: "297mm",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 595.28 841.89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0,
    width: 595.28,
    height: 841.89,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d"
  }, /*#__PURE__*/React.createElement("rect", {
    y: -11.6,
    width: 601.93,
    height: 587.51,
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 392.03,
    y1: 1.45,
    x2: 194.6,
    y2: 910.97,
    gradientTransform: "translate(0 839.91) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#0e3a5a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00ab97"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: -98.34,
    y1: 861,
    x2: 379.96,
    y2: 592.08,
    gradientTransform: "translate(0 839.91) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#0e3a5a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#103c5c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00ab97",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 309.78,
    y1: 698.02,
    x2: 175.37,
    y2: 925.94,
    gradientTransform: "translate(0 839.91) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#0e3a5a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00ab97"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 361.64,
    y1: 776.06,
    x2: 308.08,
    y2: 835.27,
    gradientTransform: "translate(0 839.91) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#0e3a5a",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#00ab97",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 690.13,
    y1: 149.83,
    x2: 448.07,
    y2: 809.41,
    gradientTransform: "translate(0 839.91) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#0e3a5a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#006a77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00ab97"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: 1.19,
    y1: 874.07,
    x2: 114.41,
    y2: 134.82,
    gradientTransform: "translate(-188.85 758.07) rotate(27.87) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0e3a5a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#006a77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0e3a5a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: -36.2,
    y1: 444.23,
    x2: 76.89,
    y2: -294.14,
    gradientTransform: "translate(-8.71 432) rotate(27.81) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0e3a5a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0e3a5a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: -158.41,
    y1: 841.97,
    x2: 624.64,
    y2: 124.29,
    gradientTransform: "translate(0 839.91) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0e3a5a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#0e3a5a",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "m"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 468.9,
    y: 47.86,
    width: 88.52,
    height: 56.82,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "n"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 468.9,
    y: 47.86,
    width: 88.52,
    height: 56.82,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "o"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 468.9,
    y: 47.86,
    width: 88.52,
    height: 56.82,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "p"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 468.9,
    y: 47.86,
    width: 88.52,
    height: 56.82,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "q"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 468.9,
    y: 47.86,
    width: 88.52,
    height: 56.82,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "r"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 468.9,
    y: 47.86,
    width: 88.52,
    height: 56.82,
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "s",
    x1: 160.75,
    y1: 53.09,
    x2: 168.27,
    y2: 661.96,
    gradientTransform: "translate(0 839.91) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#0e3a5a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#036b78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#006a77"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "t"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1.75,171.63h315.17c9.88,0,17.9,8.02,17.9,17.9v189.56c0,9.88-8.02,17.9-17.9,17.9H-1.75v-225.37h0Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "u",
    x1: 144.78,
    y1: 368.28,
    x2: 173.92,
    y2: 670.03,
    gradientTransform: "translate(0 839.91) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#0e3a5a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#036b78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#006a77"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "v",
    x1: 153.55,
    y1: 583.85,
    x2: 232.98,
    y2: 462.88,
    gradientTransform: "translate(0 839.91) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#036b78",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#026e7a",
    stopOpacity: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#017a82",
    stopOpacity: 0.43
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#008287",
    stopOpacity: 0.64
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#008589",
    stopOpacity: 0.72
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "w",
    x1: 162.17,
    y1: 620.03,
    x2: 162.17,
    y2: 503.12,
    gradientTransform: "translate(0 839.91) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00ab97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#00ab97",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "x",
    x1: 162.17,
    y1: 610.6,
    x2: 162.17,
    y2: 274.31,
    gradientTransform: "translate(0 839.91) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0e3a5a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#006a77",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "y"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 35.52,
    y: 248.05,
    width: 259.22,
    height: 120.96,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "z"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 40.07,
    y: 252.29,
    width: 250.13,
    height: 116.71,
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aa",
    x1: 172.52,
    y1: 585.19,
    x2: 275.09,
    y2: 461.95,
    gradientTransform: "translate(0 839.91) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#90cb86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#00aa96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#0a6973"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ab",
    x1: 176.62,
    y1: 588.59,
    x2: 279.18,
    y2: 465.35,
    gradientTransform: "translate(0 839.91) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#90cb86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#00aa96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0a6973"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ac",
    x1: 172.67,
    y1: 600.68,
    x2: 275.23,
    y2: 477.45,
    gradientTransform: "translate(0 839.91) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#90cb86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#00aa96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#0a6973"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ad",
    x1: 181.54,
    y1: 592.68,
    x2: 284.1,
    y2: 469.45,
    gradientTransform: "translate(0 839.91) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#90cb86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#00aa96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0a6973"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ae",
    x1: 165.24,
    y1: 579.13,
    x2: 267.81,
    y2: 455.9,
    gradientTransform: "translate(0 839.91) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#90cb86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#00aa96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0a6973"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "af",
    x1: 161.75,
    y1: 15.7,
    x2: 167.35,
    y2: 469.9,
    gradientTransform: "translate(0 839.91) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0e3a5a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#05566b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#006a77"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ag"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 361.15,
    y: 525.64,
    width: 120.74,
    height: 26.67,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ah"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 361.15,
    y: 525.64,
    width: 120.74,
    height: 26.67,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ai"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 361.15,
    y: 525.64,
    width: 120.74,
    height: 26.67,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aj"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 361.15,
    y: 525.64,
    width: 120.74,
    height: 26.67,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ak"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 361.15,
    y: 525.64,
    width: 120.74,
    height: 26.67,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "al"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 361.15,
    y: 525.64,
    width: 120.74,
    height: 26.67,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "am"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 361.15,
    y: 525.64,
    width: 120.74,
    height: 26.67,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "an"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 361.15,
    y: 525.64,
    width: 120.74,
    height: 26.67,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ao"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 361.15,
    y: 525.64,
    width: 120.74,
    height: 26.67,
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ap",
    x1: 171.61,
    y1: 277.61,
    x2: 171.61,
    y2: 250.35,
    gradientTransform: "translate(0 839.91) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#0f2542"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#0c4c65"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aq",
    x1: 171.61,
    y1: 220.56,
    x2: 171.61,
    y2: 193.3,
    gradientTransform: "translate(0 839.91) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#0f2542"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#0c4c65"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ar",
    x1: 170.27,
    y1: 169.43,
    x2: 173.52,
    y2: 122.24,
    gradientTransform: "translate(0 839.91) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0f2744"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#0f2542"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#0c4c65"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "as",
    x1: 169.14,
    y1: 29.68,
    x2: 169.78,
    y2: 81.38,
    gradientTransform: "translate(0 839.91) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0e3a5a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0a6973",
    stopOpacity: 0.7
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "b",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    y: 0,
    width: 595.28,
    height: 841.89,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    y: -11.6,
    width: 601.93,
    height: 861.12,
    fill: "url(#e)"
  }), /*#__PURE__*/React.createElement("rect", {
    y: -11.6,
    width: 601.93,
    height: 430.01,
    fill: "url(#f)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 196,
    cy: -51.05,
    rx: 179.11,
    ry: 134.23,
    fill: "url(#g)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324,56.08c18.48,0,33.47-15.15,33.47-33.84s-14.98-33.84-33.47-33.84-33.47,15.15-33.47,33.84,14.98,33.84,33.47,33.84Z",
    fill: "url(#h)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 569.01,
    cy: 360.03,
    rx: 217.7,
    ry: 451.61,
    fill: "url(#i)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 70.5,
    cy: 418.42,
    rx: 179.54,
    ry: 422.73,
    transform: "translate(-187.42 81.49) rotate(-27.87)",
    fill: "url(#j)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 16.87,
    cy: 454.31,
    rx: 179.82,
    ry: 422.08,
    transform: "translate(-268.78 100.64) rotate(-36.8)",
    fill: "url(#k)",
    isolation: "isolate",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    y: -11.6,
    width: 601.93,
    height: 861.12,
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    y: -11.6,
    width: 601.93,
    height: 430.01,
    fill: "none"
  })), /*#__PURE__*/React.createElement("rect", {
    y: -11.6,
    width: 601.93,
    height: 861.12,
    fill: "url(#l)"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "492.68 83.62 493.48 83.62 513.94 83.8 533.88 83.71 535.21 83.62 492.68 83.62",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#m)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M528.96,102.03c.33,0,1.71.02,3.81-.38.28.53.94,1.55,2.19,2.41,1.42.97,3.48.5,3.48.5,0,0-.82-2.14-2.43-2.9-.45-.21-1.06-.31-1.65-.36.85-.22,1.78-.5,2.76-.86.36.46,1.18,1.35,2.54,1.97,1.54.7,3.45-.09,3.45-.09,0,0-1.17-1.93-2.86-2.4-.48-.13-1.1-.13-1.68-.07.33-.15.67-.3,1.02-.47.54-.24,1.08-.52,1.63-.84.44.39,1.38,1.1,2.78,1.47,1.61.43,3.32-.65,3.32-.65,0,0-1.47-1.67-3.18-1.85-.46-.05-1.04.05-1.57.19.78-.53,1.54-1.12,2.29-1.76.48.3,1.52.85,2.97.98,1.62.15,3.08-1.17,3.08-1.17,0,0-1.71-1.38-3.4-1.26-.5.03-1.09.26-1.62.51.71-.69,1.39-1.43,2.03-2.21.49.21,1.62.6,3.09.48,1.6-.13,2.77-1.64,2.77-1.64,0,0-1.89-1.05-3.5-.66-.52.12-1.11.49-1.6.85.62-.83,1.19-1.7,1.71-2.61.51.12,1.67.31,3.07-.05,1.52-.38,2.38-2.04,2.38-2.04,0,0-2.01-.7-3.49-.06-.47.2-.97.64-1.38,1.06.46-.91.87-1.86,1.21-2.83.52.03,1.66.02,2.95-.55,1.4-.62,1.94-2.36,1.94-2.36,0,0-2.06-.34-3.38.51-.41.27-.81.76-1.13,1.23.28-.98.5-1.98.64-3,.49-.05,1.62-.25,2.77-1.02,1.24-.83,1.46-2.6,1.46-2.6,0,0-2.05,0-3.17,1.05-.36.34-.67.9-.89,1.42.13-1.08.17-2.16.14-3.23.47-.13,1.51-.51,2.48-1.43,1.05-1,.95-2.75.95-2.75,0,0-1.98.35-2.88,1.54-.3.39-.49,1-.62,1.54-.09-1.11-.26-2.2-.5-3.27.41-.19,1.39-.72,2.19-1.82.84-1.14.43-2.81.43-2.81,0,0-1.85.66-2.51,1.96-.24.48-.32,1.21-.33,1.8-.31-1.15-.69-2.25-1.14-3.32.34-.22,1.23-.9,1.83-2.14.61-1.24-.08-2.78-.08-2.78,0,0-1.67.94-2.07,2.3-.16.55-.08,1.34.02,1.93-.52-1.14-1.11-2.21-1.76-3.22.29-.28,1.02-1.08,1.39-2.36.37-1.29-.56-2.67-.56-2.67,0,0-1.45,1.18-1.6,2.56-.06.54.15,1.27.34,1.81-.71-1.03-1.48-1.97-2.28-2.79.23-.31.8-1.21.92-2.51.13-1.31-1.01-2.48-1.01-2.48,0,0-1.19,1.38-1.09,2.74.04.56.4,1.27.69,1.77-.29-.28-.58-.54-.87-.78-.66-.59-1.31-1.11-1.94-1.58.14-.27.6-1.27.48-2.63-.11-1.28-1.42-2.23-1.42-2.23,0,0-.9,1.53-.57,2.82.16.61.75,1.35,1.13,1.77-1.19-.85-2.32-1.49-3.31-1.99.08-.26.36-1.31,0-2.64-.33-1.22-1.76-1.92-1.76-1.92,0,0-.6,1.62-.05,2.81.28.6,1.06,1.26,1.49,1.59-.68-.33-1.29-.58-1.8-.77-.14-.2-.85-1.13-1.77-1.35-.74-.17-2.03.21-2.03.21,0,0,.55.83,1.74,1.32.8.33,1.73,0,2.01-.1.62.25,1.39.6,2.25,1.06-.52-.12-1.58-.33-2.26-.16-1.31.32-2.26,1.78-2.26,1.78,0,0,1.45.65,2.65.15,1.28-.54,1.96-1.39,2.13-1.62.97.53,2.06,1.21,3.19,2.08-.54-.22-1.43-.52-2.07-.48-1.37.1-2.59,1.4-2.59,1.4,0,0,1.34.9,2.64.6,1.32-.3,2.14-.99,2.41-1.23.5.4,1.01.83,1.52,1.3.46.4.91.83,1.35,1.3-.5-.31-1.35-.78-2.02-.85-1.4-.14-2.86.97-2.86.97,0,0,1.18,1.14,2.54,1.06,1.39-.08,2.35-.64,2.65-.83.79.88,1.55,1.88,2.24,2.96-.45-.39-1.15-.92-1.74-1.08-1.38-.38-3.05.48-3.05.48,0,0,.98,1.34,2.36,1.5,1.35.15,2.39-.2,2.77-.36.59.99,1.14,2.05,1.61,3.17-.38-.45-.92-1.01-1.43-1.25-1.32-.62-3.16-.04-3.16-.04,0,0,.73,1.52,2.09,1.91,1.28.37,2.35.22,2.8.12.42,1.08.76,2.21,1.03,3.37-.3-.52-.74-1.16-1.21-1.49-1.21-.85-3.17-.58-3.17-.58,0,0,.46,1.65,1.75,2.28,1.22.59,2.32.62,2.79.6.22,1.16.36,2.35.4,3.55-.21-.58-.54-1.34-.96-1.76-1.06-1.06-3.07-1.13-3.07-1.13,0,0,.16,1.74,1.35,2.59,1.12.8,2.23,1.02,2.7,1.08,0,1.11-.1,2.24-.29,3.36-.11-.6-.29-1.33-.62-1.79-.88-1.24-2.88-1.66-2.88-1.66,0,0-.16,1.77.88,2.83.96.97,2,1.39,2.48,1.54-.19,1.08-.47,2.13-.82,3.15,0-.62-.06-1.38-.29-1.89-.65-1.4-2.59-2.16-2.59-2.16,0,0-.49,1.76.36,2.99.77,1.13,1.73,1.72,2.19,1.96-.38.98-.83,1.92-1.33,2.83.1-.6.17-1.31.03-1.83-.4-1.52-2.21-2.61-2.21-2.61,0,0-.81,1.68-.18,3.07.56,1.24,1.38,1.99,1.81,2.32-.54.88-1.13,1.71-1.75,2.5.2-.57.38-1.23.34-1.75-.12-1.59-1.74-3.01-1.74-3.01,0,0-1.12,1.55-.75,3.05.33,1.32,1,2.21,1.38,2.63-.71.82-1.46,1.57-2.24,2.26.32-.55.65-1.23.71-1.78.17-1.62-1.2-3.32-1.2-3.32,0,0-1.41,1.37-1.31,2.94.09,1.41.63,2.44.92,2.91-.86.7-1.75,1.32-2.64,1.85.43-.5.9-1.14,1.06-1.7.47-1.6-.59-3.54-.59-3.54,0,0-1.67,1.13-1.86,2.73-.17,1.42.18,2.54.39,3.07-.34.18-.68.34-1.02.49-.61.29-1.21.55-1.79.78.5-.42,1.02-.94,1.27-1.44.76-1.53.05-3.66.05-3.66,0,0-1.89.85-2.37,2.42-.42,1.37-.29,2.54-.18,3.12-1.06.36-2.05.61-2.93.79.57-.33,1.18-.76,1.51-1.21,1.05-1.41.72-3.67.72-3.67,0,0-2.05.53-2.82,2.03-.67,1.3-.76,2.48-.75,3.09-1.46.22-2.47.23-2.88.23",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.46,101.21h-.2c-.41.01-1.42,0-2.88-.22,0-.61-.08-1.79-.75-3.09-.77-1.5-2.82-2.03-2.82-2.03,0,0-.33,2.26.72,3.67.34.45.95.88,1.52,1.21-.88-.18-1.87-.44-2.93-.8.12-.58.24-1.74-.18-3.11-.48-1.58-2.37-2.43-2.37-2.43,0,0-.71,2.13.05,3.66.25.5.77,1.02,1.27,1.43-.58-.23-1.18-.48-1.79-.78-.34-.15-.68-.31-1.02-.49.21-.53.56-1.64.39-3.07-.19-1.6-1.86-2.73-1.86-2.73,0,0-1.06,1.94-.59,3.54.16.56.63,1.2,1.06,1.7-.89-.53-1.77-1.15-2.64-1.85.3-.47.83-1.49.92-2.91.1-1.57-1.31-2.94-1.31-2.94,0,0-1.37,1.7-1.2,3.32.06.56.39,1.23.71,1.78-.77-.69-1.52-1.45-2.24-2.27.38-.41,1.05-1.31,1.38-2.63.38-1.5-.75-3.05-.75-3.05,0,0-1.62,1.41-1.74,3.01-.04.52.13,1.18.33,1.75-.63-.79-1.21-1.62-1.75-2.5.43-.33,1.26-1.09,1.81-2.32.63-1.39-.18-3.07-.18-3.07,0,0-1.81,1.1-2.21,2.61-.14.52-.07,1.24.03,1.83-.5-.91-.95-1.85-1.33-2.83.46-.24,1.42-.83,2.19-1.96.85-1.24.36-2.99.36-2.99,0,0-1.94.76-2.59,2.16-.24.51-.3,1.27-.29,1.89-.35-1.02-.62-2.07-.82-3.15.48-.15,1.52-.56,2.48-1.54,1.04-1.06.88-2.83.88-2.83,0,0-2.01.41-2.88,1.66-.32.46-.51,1.19-.62,1.79-.19-1.12-.28-2.25-.28-3.36.47-.06,1.58-.28,2.7-1.08,1.19-.85,1.35-2.59,1.35-2.59,0,0-2.01.07-3.07,1.13-.43.42-.76,1.18-.96,1.76.04-1.2.18-2.39.4-3.55.47.02,1.57-.01,2.79-.6,1.3-.62,1.75-2.28,1.75-2.28,0,0-1.95-.26-3.16.58-.47.33-.91.97-1.21,1.49.26-1.16.61-2.29,1.03-3.37.45.1,1.52.25,2.8-.12,1.36-.39,2.09-1.91,2.09-1.91,0,0-1.84-.57-3.16.04-.51.24-1.05.79-1.44,1.25.47-1.11,1.01-2.17,1.61-3.17.38.16,1.42.51,2.77.36,1.38-.15,2.36-1.5,2.36-1.5,0,0-1.67-.86-3.05-.48-.6.16-1.29.69-1.74,1.09.69-1.08,1.44-2.08,2.23-2.96.3.2,1.26.75,2.65.83,1.36.08,2.54-1.06,2.54-1.06,0,0-1.46-1.1-2.86-.96-.67.07-1.52.54-2.02.85.44-.47.89-.9,1.35-1.3.51-.47,1.02-.9,1.52-1.3.27.25,1.09.93,2.41,1.23,1.3.3,2.64-.6,2.64-.6,0,0-1.22-1.3-2.59-1.4-.64-.05-1.53.26-2.07.48,1.13-.86,2.22-1.54,3.19-2.08.17.24.85,1.09,2.13,1.62,1.2.5,2.65-.15,2.65-.15,0,0-.95-1.46-2.26-1.78-.68-.17-1.75.04-2.26.16.87-.46,1.63-.81,2.25-1.06.28.11,1.21.43,2.01.1,1.19-.49,1.74-1.32,1.74-1.32,0,0-1.29-.38-2.03-.21-.92.22-1.63,1.15-1.77,1.35-.51.19-1.12.44-1.8.77.43-.33,1.22-.99,1.49-1.59.55-1.19-.05-2.82-.05-2.82,0,0-1.43.7-1.76,1.92-.36,1.33-.07,2.38,0,2.64-.99.49-2.11,1.14-3.31,1.99.38-.42.98-1.16,1.13-1.77.33-1.29-.57-2.82-.57-2.82,0,0-1.31.95-1.42,2.23-.12,1.36.34,2.35.48,2.63-.64.47-1.29.99-1.94,1.58-.29.25-.58.51-.87.78.29-.5.65-1.21.69-1.77.1-1.36-1.09-2.74-1.09-2.74,0,0-1.14,1.17-1.01,2.48.12,1.3.69,2.19.92,2.51-.8.82-1.57,1.76-2.28,2.79.2-.55.4-1.27.34-1.82-.15-1.38-1.6-2.56-1.6-2.56,0,0-.93,1.38-.56,2.67.36,1.28,1.1,2.08,1.39,2.36-.65,1-1.24,2.08-1.76,3.22.1-.58.18-1.38.02-1.93-.41-1.36-2.07-2.3-2.07-2.3,0,0-.68,1.54-.08,2.78.6,1.23,1.5,1.91,1.83,2.14-.45,1.06-.83,2.17-1.14,3.31-.01-.58-.09-1.31-.33-1.79-.66-1.3-2.51-1.96-2.51-1.96,0,0-.4,1.67.43,2.81.81,1.1,1.79,1.63,2.19,1.82-.24,1.07-.41,2.16-.5,3.27-.13-.54-.32-1.15-.62-1.54-.9-1.19-2.88-1.54-2.88-1.54,0,0-.1,1.74.95,2.75.97.93,2.01,1.3,2.48,1.43-.03,1.07,0,2.15.14,3.23-.23-.51-.53-1.08-.89-1.41-1.12-1.04-3.17-1.06-3.17-1.06,0,0,.22,1.77,1.46,2.6,1.16.77,2.28.97,2.77,1.02.14,1.02.36,2.02.64,3-.32-.47-.72-.96-1.13-1.23-1.32-.86-3.38-.52-3.38-.52,0,0,.55,1.74,1.94,2.36,1.28.57,2.43.58,2.95.55.34.98.75,1.92,1.21,2.83-.41-.42-.9-.86-1.38-1.06-1.48-.64-3.49.06-3.49.06,0,0,.87,1.66,2.38,2.04,1.4.35,2.56.17,3.07.05.52.91,1.09,1.79,1.71,2.61-.49-.36-1.08-.72-1.6-.85-1.61-.39-3.5.66-3.5.66,0,0,1.17,1.51,2.77,1.64,1.47.12,2.61-.27,3.09-.48.65.79,1.33,1.53,2.03,2.21-.53-.25-1.12-.47-1.62-.51-1.69-.11-3.4,1.26-3.4,1.26,0,0,1.46,1.32,3.09,1.17,1.45-.13,2.49-.68,2.97-.98.75.65,1.51,1.24,2.29,1.76-.53-.14-1.11-.24-1.57-.19-1.71.18-3.18,1.85-3.18,1.85,0,0,1.71,1.08,3.31.65,1.4-.37,2.34-1.08,2.78-1.47.54.31,1.09.59,1.63.83.34.17.68.32,1.02.47-.58-.05-1.21-.06-1.68.07-1.69.47-2.86,2.4-2.86,2.4,0,0,1.91.79,3.45.09,1.36-.62,2.18-1.51,2.54-1.98.98.37,1.9.65,2.75.86-.58.05-1.2.15-1.65.36-1.61.76-2.43,2.9-2.43,2.9,0,0,2.07.47,3.48-.5,1.25-.85,1.91-1.88,2.19-2.41,2.1.39,3.48.38,3.81.38",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "513.8 47.86 512.98 50.07 513.8 51.2 513.8 47.86",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "513.8 47.86 513.8 51.2 514.61 50.07 513.8 47.86",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "516.97 50.18 514.62 50.08 513.8 51.2 516.97 50.18",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "516.97 50.18 515.12 51.63 513.8 51.2 516.97 50.18",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "510.63 50.16 512.47 51.62 513.8 51.2 510.63 50.16",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "510.63 50.16 512.98 50.07 513.8 51.2 510.63 50.16",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "515.75 53.91 515.12 51.63 513.8 51.2 515.75 53.91",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "515.75 53.91 513.79 52.59 513.8 51.2 515.75 53.91",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "511.81 53.88 513.79 52.59 513.8 51.2 511.81 53.88",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "511.81 53.88 512.47 51.62 513.8 51.2 511.81 53.88",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "519.35 51.66 519.77 52.25 519.77 50.52 519.35 51.66",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "519.77 52.25 520.2 51.66 519.77 50.52 519.77 52.25",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "519.77 52.25 521.42 51.72 520.2 51.67 519.77 52.25",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "519.77 52.25 520.46 52.47 521.42 51.72 519.77 52.25",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "519.09 52.47 519.77 52.25 518.13 51.71 519.09 52.47",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "518.13 51.71 519.77 52.25 519.35 51.66 518.13 51.71",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "520.78 53.65 520.46 52.47 519.77 52.25 520.78 53.65",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "520.78 53.65 519.77 52.97 519.77 52.25 520.78 53.65",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "518.75 53.64 519.77 52.97 519.77 52.25 518.75 53.64",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "518.75 53.64 519.09 52.46 519.77 52.25 518.75 53.64",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "507.37 51.66 507.8 52.25 507.8 50.52 507.37 51.66",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "507.8 52.25 508.22 51.66 507.8 50.52 507.8 52.25",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "507.8 52.25 509.44 51.72 508.22 51.67 507.8 52.25",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "507.8 52.25 508.48 52.47 509.44 51.72 507.8 52.25",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "507.11 52.47 507.8 52.25 506.15 51.71 507.11 52.47",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "506.15 51.71 507.8 52.25 507.37 51.66 506.15 51.71",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "508.81 53.65 508.48 52.47 507.8 52.25 508.81 53.65",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "508.81 53.65 507.79 52.97 507.8 52.25 508.81 53.65",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "506.77 53.64 507.79 52.97 507.8 52.25 506.77 53.64",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "506.77 53.64 507.11 52.46 507.8 52.25 506.77 53.64",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#n)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M495.63,87.95h.53v3.17h-.53v-3.17Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.81,88.72h.51v.35c.14-.21.33-.39.66-.39.46,0,.74.32.74.84v1.61h-.52v-1.46c0-.34-.15-.53-.43-.53s-.45.2-.45.53v1.46h-.51v-2.4h0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499.28,88.72h.51v.35c.14-.21.33-.39.66-.39.46,0,.74.32.74.84v1.61h-.52v-1.46c0-.34-.15-.53-.43-.53s-.45.2-.45.53v1.46h-.51v-2.4h0Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M501.64,89.94v-.04c0-.71.47-1.23,1.11-1.23s1.1.52,1.1,1.23v.04c0,.71-.47,1.23-1.1,1.23s-1.11-.52-1.11-1.23ZM503.34,89.94v-.03c0-.45-.25-.79-.59-.79-.36,0-.59.34-.59.78v.03c0,.45.25.79.6.79s.59-.34.59-.78h-.01Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504.13,88.72h.54l.54,1.75.54-1.75h.53l-.83,2.42h-.48l-.84-2.42h0Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M506.32,90.43v-.03c0-.51.35-.77.86-.77.22,0,.39.04.55.1v-.1c0-.32-.19-.49-.52-.49-.23,0-.42.07-.58.14l-.15-.41c.23-.11.47-.19.79-.19s.55.09.71.24c.16.16.24.4.24.7v1.49h-.5v-.29c-.14.2-.35.34-.67.34-.4,0-.74-.27-.74-.73h.01ZM507.73,90.31v-.25c-.12-.04-.27-.08-.44-.08-.29,0-.47.15-.47.4h0c0,.25.16.38.39.39.29,0,.52-.2.52-.47h0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.88,90.53v-1.38h-.26v-.44h.26v-.65h.52v.65h.54v.44h-.54v1.28c0,.19.09.26.25.26.1,0,.19-.02.28-.06v.42c-.12.06-.25.1-.43.1-.35,0-.62-.15-.62-.62Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.41,87.86h.54v.5h-.54v-.5ZM510.42,88.72h.52v2.4h-.52v-2.4Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.36,88.72h.54l.54,1.75.54-1.75h.53l-.83,2.42h-.48l-.84-2.42h0Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M513.65,89.94v-.03c0-.72.44-1.24,1.02-1.24.65,0,1,.54,1,1.26v.18h-1.5c.05.4.29.62.61.62.23,0,.39-.1.55-.25l.27.32c-.22.23-.48.38-.84.38-.62,0-1.1-.48-1.1-1.23h-.01ZM515.17,89.76c-.02-.39-.19-.66-.49-.66-.28,0-.48.25-.52.66h1.01Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517.22,87.95h1.02c.69,0,1.14.4,1.14,1.05h0c0,.72-.52,1.08-1.17,1.09h-.46v1.03h-.53v-3.17ZM518.21,89.61c.4,0,.64-.24.64-.59h0c0-.39-.24-.6-.64-.6h-.46v1.19s.46,0,.46,0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.8,88.72h.51v.47c.13-.31.36-.52.72-.5v.56h-.02c-.41,0-.7.27-.7.82v1.07h-.51v-2.42Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M521.25,89.94v-.04c0-.71.47-1.23,1.11-1.23s1.1.52,1.1,1.23v.04c0,.71-.47,1.23-1.1,1.23s-1.11-.52-1.11-1.23ZM522.95,89.94v-.03c0-.45-.25-.79-.59-.79-.36,0-.59.34-.59.78v.03c0,.45.25.79.6.79s.59-.34.59-.78h0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.58,91.79v-.41h.13c.15,0,.24-.09.24-.29v-2.39h.51v2.43c0,.45-.23.67-.64.67-.1,0-.16,0-.24-.02h0ZM523.94,87.86h.54v.5h-.54v-.5Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.97,89.94v-.03c0-.72.43-1.24,1.02-1.24.65,0,1,.54,1,1.26v.18h-1.5c.04.4.29.62.61.62.23,0,.39-.1.55-.25l.27.32c-.22.23-.48.38-.84.38-.62,0-1.1-.48-1.1-1.23h-.01ZM526.48,89.76c-.02-.39-.2-.66-.49-.66s-.48.25-.52.66h1.01Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.35,89.95v-.05c0-.72.47-1.23,1.1-1.23.34,0,.57.13.77.33l-.29.38c-.13-.13-.27-.24-.49-.24-.33,0-.58.32-.58.78v.02c0,.47.25.78.59.78.21,0,.35-.1.49-.24l.28.34c-.19.21-.43.37-.8.37-.62,0-1.08-.51-1.08-1.22v-.02Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529.73,90.53v-1.38h-.26v-.44h.26v-.65h.52v.65h.53v.44h-.53v1.28c0,.19.09.26.25.26.1,0,.19-.02.28-.06v.42c-.12.06-.25.1-.43.1-.35,0-.62-.15-.62-.62h0Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M497.08,94.48v-.04c0-.71.47-1.23,1.11-1.23s1.1.52,1.1,1.23v.04c0,.71-.47,1.23-1.1,1.23s-1.11-.52-1.11-1.23ZM498.78,94.47v-.03c0-.45-.25-.79-.59-.79-.36,0-.59.34-.59.78v.03c0,.45.25.79.6.79s.59-.34.59-.78h-.01Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499.87,93.69h-.26v-.43h.26v-.19c0-.25.06-.43.18-.55.12-.11.29-.17.5-.17.15,0,.26.02.36.05v.43c-.09-.02-.16-.04-.25-.04-.19,0-.29.1-.29.33v.14h.53v.43h-.53v1.96h-.52v-1.96h.02Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.38,95.07v-1.38h-.26v-.44h.26v-.65h.52v.65h.53v.44h-.53v1.28c0,.19.09.26.25.26.1,0,.19-.02.28-.06v.42c-.12.06-.25.1-.43.1-.35,0-.62-.15-.62-.62Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.9,92.38h.51v1.22c.14-.21.33-.39.66-.39.46,0,.74.32.74.84v1.61h-.52v-1.46c0-.34-.15-.53-.43-.53s-.45.2-.45.53v1.46h-.51v-3.27h0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.26,94.47v-.03c0-.72.44-1.24,1.02-1.24.65,0,1,.54,1,1.26v.18h-1.5c.05.4.29.62.61.62.23,0,.39-.1.55-.25l.27.32c-.22.23-.48.38-.84.38-.62,0-1.1-.48-1.1-1.23h0ZM507.78,94.29c-.02-.39-.19-.66-.49-.66-.28,0-.48.25-.52.66h1.01,0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.62,94.39l-1.06-1.91h.6l.74,1.37.74-1.37h.58l-1.06,1.9v1.27h-.53v-1.26h0Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M512.04,94.47v-.03c0-.72.43-1.24,1.02-1.24.65,0,1,.54,1,1.26v.18h-1.5c.04.4.29.62.61.62.23,0,.39-.1.55-.25l.27.32c-.22.23-.48.38-.84.38-.62,0-1.1-.48-1.1-1.23h-.01ZM513.56,94.29c-.02-.39-.2-.66-.49-.66s-.48.25-.52.66h1.01Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514.39,94.96v-.03c0-.51.35-.77.86-.77.22,0,.39.04.55.1v-.1c0-.32-.19-.49-.52-.49-.23,0-.42.07-.58.14l-.15-.41c.23-.11.47-.19.79-.19s.55.09.71.24c.16.16.24.4.24.7v1.49h-.5v-.29c-.14.2-.35.34-.67.34-.4,0-.74-.27-.74-.73h.01ZM515.81,94.85v-.25c-.12-.04-.27-.08-.44-.08-.29,0-.47.15-.47.4h0c0,.25.16.38.39.39.29,0,.52-.2.52-.47h0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.85,93.25h.51v.47c.13-.31.36-.52.72-.5v.56h-.02c-.41,0-.7.27-.7.82v1.07h-.51v-2.42Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.42,95.23l.97-1.03c.35-.37.49-.57.49-.82,0-.29-.2-.45-.46-.45s-.43.14-.63.4l-.34-.32c.26-.37.57-.57,1.02-.57.56,0,.95.35.95.89h0c0,.44-.2.7-.66,1.16l-.64.69h1.31v.48h-2.01v-.42h0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.88,94.09v-.05c0-.96.47-1.62,1.21-1.62s1.2.65,1.2,1.61v.05c0,.96-.48,1.62-1.21,1.62s-1.2-.65-1.2-1.61ZM523.74,94.09v-.04c0-.71-.27-1.15-.67-1.15s-.66.43-.66,1.14v.04c0,.71.26,1.15.67,1.15s.66-.44.66-1.14Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.69,95.23l.97-1.03c.35-.37.49-.57.49-.82,0-.29-.2-.45-.46-.45s-.43.14-.63.4l-.34-.32c.26-.37.57-.57,1.02-.57.56,0,.95.35.95.89h0c0,.44-.2.7-.66,1.16l-.64.69h1.31v.48h-2.01v-.42h0Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M527.04,95.3l.3-.39c.21.19.42.3.67.3.33,0,.57-.23.57-.57h0c0-.34-.25-.54-.58-.54-.19,0-.34.05-.48.12l-.31-.2.09-1.54h1.68v.48h-1.23l-.05.76c.12-.05.25-.07.42-.07.54,0,.99.31.99.98h0c0,.67-.45,1.09-1.08,1.09-.39,0-.72-.16-.98-.4v-.02Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.15,60.13l-.65,1.04c-1.12-.65-2.83-1.09-3.95-.21-.58.46-.84,1.38-.3,1.95.49.51,2.31,1.15,3.05,1.49,1.04.48,2.18.92,2.46,2.16.36,1.56-.52,2.93-1.91,3.58-1.59.74-3.51.61-5.03-.24-.15-.08-.62-.37-.71-.47l.64-1.07c1.1,1.07,3.74,1.5,4.84.2.84-.98.37-2.12-.74-2.56-1.8-.72-4.71-1.17-4.59-3.74.09-2.08,2.08-3.19,4.07-3.05.97.07,1.95.52,2.82.91",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.14,75.83h-4.23l3.69-.43c-.63-2.58-3.95-3.56-5.76-1.55-2.2,2.44.08,6.34,3.3,5.59,1.57-.37,1.9-1.48,2.86-2.52.74-.8,1.57-1.57,2.81-1.59h38.18v.39h-37.77c-1.28-.01-1.52.34-2.07.74-1.52,1.11-1.8,2.91-3.86,3.41-3.57.85-6.3-3.39-3.93-6.17,1.77-2.07,5.12-1.76,6.38.74.22.45.44.89.42,1.39",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.16,68.52s-.42.35-.68.5c-1.89,1.1-4.34-.1-4.09-2.48.12-1.2,1.24-1.75,2.76-1.74,1.01,0,2-.03,2.01-.01v3.72h0ZM513.92,66.82c.03-1.4.06-3.29.02-4.44-.09-3.04-3.77-3.71-6.42-2.5-.09.04-.91.36-.91.38l.4.99c1.28-.62,3-1.2,4.28-.3.52.37.81.85.86,1.49.03.34,0,.84,0,1.2h-2.39c-.95,0-1.84.1-2.53.52-2.36,1.45-2.19,4.76.21,5.98,1.49.76,3.84.33,5.24-.49.22-.13,1.18-.81,1.24-1.01,0,0-.03-.76,0-1.83",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.73,60.55c.5-.11,1.07-.07,1.48.16,1.46.84,1.34,2.98,1.33,2.99,0,.03-4.74,0-4.74,0,.13-1.42.53-2.89,1.93-3.16M524.06,68.54c-.09.03-1.41.75-2.76.85-1.05.08-2.06-.18-2.91-1.56-.7-1.15-.56-3.03-.56-3.03l6.6.03c-.05-1.85-.44-4.12-2.29-5.01-1.08-.52-2.61-.51-3.7,0-1.23.57-1.91,1.75-2.25,3-.99,3.66.33,7.96,4.75,7.74,1.27-.06,2.37-.39,3.55-1.18l-.42-.84h-.01Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529.99,60.55c.5-.11,1.07-.07,1.48.16,1.46.84,1.34,2.98,1.33,2.99,0,.03-4.74,0-4.74,0,.13-1.42.53-2.89,1.93-3.16M534.32,68.54c-.09.03-1.41.75-2.76.85-1.05.08-2.06-.18-2.91-1.56-.7-1.15-.56-3.03-.56-3.03l6.6.03c-.05-1.85-.44-4.12-2.29-5.01-1.08-.52-2.61-.51-3.7,0-1.23.57-1.91,1.75-2.25,3-.99,3.66.33,7.96,4.75,7.74,1.27-.06,2.37-.39,3.55-1.18l-.42-.84h-.01Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.53,80.42c.21,0,.4-.03.58-.1s.38-.18.57-.33l-.18-.29c-.07.04-.12.07-.17.09-.04.02-.08.05-.12.07-.1.06-.2.1-.29.13s-.2.04-.32.04c-.17,0-.31-.06-.42-.18-.11-.12-.2-.28-.26-.46s-.09-.38-.1-.6c0-.22.02-.42.08-.6s.15-.34.26-.46c.12-.12.27-.18.45-.18.12,0,.24.01.36.04.11.03.24.09.37.17l.18-.29c-.15-.1-.3-.18-.46-.22s-.33-.07-.51-.07c-.22,0-.4.04-.56.14-.16.09-.29.22-.4.38-.1.16-.18.33-.24.52-.06.19-.08.38-.09.56,0,.18.02.36.07.56.05.19.13.37.24.54.11.16.24.3.4.4.16.11.34.16.55.16h0v-.02ZM500.8,77.54c.14,0,.26.04.37.11s.2.17.27.28c.07.12.13.25.16.4.04.15.05.29.05.44,0,.16-.02.32-.06.48-.04.15-.09.29-.17.41-.07.12-.16.22-.27.29s-.23.11-.36.11-.26-.04-.37-.11-.2-.17-.27-.29c-.07-.12-.13-.26-.17-.41-.04-.16-.06-.32-.06-.48,0-.15.02-.29.05-.44.04-.14.09-.28.16-.39.07-.12.16-.21.27-.28s.23-.11.37-.11h.03ZM501.39,80.28c.17-.1.31-.23.43-.39.12-.16.2-.34.26-.54.06-.2.08-.39.08-.59s-.03-.39-.09-.58-.15-.36-.26-.51c-.12-.15-.26-.27-.43-.36-.17-.09-.36-.14-.58-.14s-.41.05-.58.14c-.17.09-.31.22-.43.37s-.2.32-.26.51-.09.38-.09.58.03.39.09.59.14.38.26.54.26.29.43.39c.17.1.37.15.59.15s.42-.05.59-.15M505.13,80.39h.43v-3.16h-.35v2.43l-1.7-2.5-.35.12v3.11h.35v-2.38l1.62,2.38h0ZM508.37,77.58l.18-.35h-1.82v3.16h.45v-1.52h.86l.18-.35h-1.05v-.94h1.2ZM511.11,77.58l.18-.35h-1.82v3.17h1.76v-.35h-1.3v-1.17h.86l.18-.35h-1.04v-.94h1.19,0ZM513.49,77.69c.13.08.23.18.3.3s.12.27.15.42c.03.16.04.32.04.48,0,.14-.02.28-.05.42-.03.14-.08.27-.15.38s-.15.2-.26.27c-.1.07-.22.11-.36.11-.09,0-.18-.02-.26-.06-.09-.04-.16-.08-.22-.12v-2.31h.33c.2,0,.36.04.49.11M513.22,80.43c.2,0,.37-.05.53-.14.16-.09.29-.21.4-.36.11-.15.19-.31.25-.5s.09-.38.09-.57-.02-.38-.07-.58c-.05-.19-.12-.37-.22-.53s-.23-.29-.39-.39c-.16-.1-.35-.15-.57-.15h-1.03v2.8c.06.05.13.09.2.14s.16.09.24.13c.09.04.18.07.28.09.1.02.2.04.3.04h0v.02ZM517.14,77.58l.18-.35h-1.82v3.17h1.75v-.35h-1.3v-1.17h.86l.18-.35h-1.04v-.94h1.19ZM519.55,77.63c.06.03.11.07.16.12s.08.1.11.16c.03.06.04.12.04.19,0,.15-.05.27-.14.37-.09.1-.22.15-.37.15h-.51v-1.03h.51c.07,0,.13.01.2.04M520.37,80.39l-.83-1.43c.11-.01.21-.04.31-.08.09-.05.17-.11.24-.18.07-.08.12-.16.16-.26s.06-.21.06-.32c0-.12-.02-.24-.07-.35s-.11-.2-.19-.28-.18-.14-.29-.19-.23-.07-.36-.07h-1.01v3.16h.45v-1.43h.17l.82,1.43h.54ZM522.33,77.87l.41,1.24h-.87l.46-1.24ZM523.17,80.39h.49l-1.08-3.24-.42.13-1.14,3.1h.38l.35-.95h1.1l.32.95h0ZM525.43,77.57h.89v-.34h-2.13l-.17.34h.94v2.82h.46v-2.82h0ZM527.29,80.39h.46v-3.24l-.46.16s0,3.08,0,3.08ZM529.92,77.54c.14,0,.26.04.37.11s.2.17.27.28c.07.12.13.25.16.4.04.15.05.29.05.44,0,.16-.02.32-.06.48-.04.15-.09.29-.17.41-.07.12-.16.22-.27.29-.11.07-.23.11-.36.11s-.26-.04-.37-.11-.2-.17-.27-.29-.13-.26-.17-.41c-.04-.16-.06-.32-.06-.48,0-.15.02-.29.05-.44.04-.14.09-.28.16-.39.07-.12.16-.21.27-.28.11-.07.23-.11.37-.11h.03ZM530.52,80.28c.17-.1.31-.23.43-.39.12-.16.2-.34.26-.54.06-.2.08-.39.08-.59s-.03-.39-.09-.58-.15-.36-.26-.51c-.12-.15-.26-.27-.43-.36-.17-.09-.36-.14-.58-.14s-.41.05-.58.14c-.17.09-.31.22-.43.37s-.2.32-.26.51-.09.38-.09.58.03.39.09.59.14.38.26.54c.11.16.26.29.43.39s.37.15.59.15.42-.05.59-.15M534.31,80.39h.43v-3.16h-.35v2.43l-1.7-2.5-.35.12v3.11h.35v-2.38l1.62,2.38Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.99,72.65c-.09-.12-.17-.2-.31-.2s-.23.1-.23.21c0,.09.05.18.15.26.31.23.54.39.54.66,0,.23-.2.45-.47.45-.23,0-.38-.13-.5-.35l.14-.09c.1.18.22.28.35.28.17,0,.31-.13.31-.28,0-.18-.17-.29-.55-.59-.08-.06-.14-.19-.14-.32,0-.23.18-.39.4-.39.2,0,.33.12.44.27l-.13.1h0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.59,73.37c0,.27.2.49.48.49s.48-.22.48-.49-.22-.5-.48-.5-.48.23-.48.5M498.71,73.37c0,.35-.27.64-.64.64s-.64-.29-.64-.64.27-.65.64-.65.64.3.64.65",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499.89,72.75h.17v.64c0,.41-.19.62-.54.62s-.54-.21-.54-.62v-.64h.17v.6c0,.13,0,.24.03.31.06.12.19.2.34.2.11,0,.21-.04.28-.11.1-.1.09-.22.09-.4,0,0,0-.6,0-.6Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "500.55 72.29 500.55 72.75 500.33 72.75 500.33 72.89 500.55 72.89 500.55 73.98 500.7 73.98 500.7 72.89 500.96 72.89 500.96 72.75 500.7 72.75 500.7 72.29 500.55 72.29",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#o)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M501.19,72.28h.16v.69c.13-.17.28-.25.46-.25.27,0,.45.19.45.56v.71h-.16v-.67c0-.29-.09-.45-.33-.45-.13,0-.24.06-.32.17-.09.12-.11.24-.11.43v.52h-.16v-1.7h0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.64,73.24c-.06-.25-.25-.37-.46-.37s-.38.12-.46.37h.92,0ZM502.7,73.38c0,.28.2.49.46.49s.38-.15.47-.29l.13.07c-.12.25-.32.37-.58.37-.41,0-.64-.31-.64-.64s.25-.65.63-.65c.35,0,.63.25.64.66h-1.11Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504.21,72.93c.09-.13.19-.21.32-.21.07,0,.11.02.14.04l-.08.13s-.05-.02-.08-.02c-.12,0-.22.1-.27.27-.02.08-.03.2-.03.37v.47h-.17v-1.23h.17v.18h0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.01,72.97c.13-.17.28-.25.46-.25.27,0,.46.19.46.57v.69h-.16v-.67c0-.29-.09-.45-.33-.45-.13,0-.24.06-.32.17-.09.12-.11.24-.11.43v.52h-.16v-1.23h.16v.22Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M507.58,72.67l-.29.6h.57l-.28-.6ZM507.61,72.32l.78,1.66h-.18l-.26-.55h-.72l-.26.55h-.19l.79-1.66h.04Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#p)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M508.69,72.56c0-.2.05-.32.25-.32.07,0,.13.02.18.03v.16s-.08-.04-.15-.04c-.13,0-.12.08-.12.19v.17h.26v.14h-.26v1.09h-.16v-1.09h-.16v-.14h.16v-.19Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.44,72.93c.09-.13.19-.21.32-.21.07,0,.11.02.14.04l-.08.13s-.05-.02-.08-.02c-.12,0-.22.1-.27.27-.02.08-.03.2-.03.37v.47h-.17v-1.23h.17v.18h0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.11,72.75h.16v1.23h-.16v-1.23ZM510.31,72.38c0,.07-.06.13-.13.13s-.13-.06-.13-.13.06-.13.13-.13.13.06.13.13",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.78,73.73c-.12.18-.33.28-.58.28-.4,0-.68-.29-.68-.63,0-.36.28-.66.69-.66.24,0,.45.1.56.29l-.13.08c-.11-.14-.26-.21-.44-.21-.31,0-.52.23-.52.49s.2.5.52.5c.18,0,.33-.07.44-.22l.13.08h0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.19,73.37c0,.27.21.5.48.5.25,0,.49-.19.49-.49s-.21-.5-.49-.5-.49.23-.49.49M513.16,72.75h.15v1.23h-.15v-.21c-.13.16-.3.24-.49.24-.36,0-.63-.3-.63-.65s.28-.64.63-.64c.2,0,.37.08.49.26v-.22h0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513.82,72.97c.13-.17.28-.25.46-.25.27,0,.46.19.46.57v.69h-.16v-.67c0-.29-.09-.45-.33-.45-.13,0-.24.06-.32.17-.09.12-.11.24-.11.43v.52h-.16v-1.23h.16v.22h0Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "515.75 72.32 515.75 73.98 516.7 73.98 516.7 73.82 515.91 73.82 515.91 73.16 516.7 73.16 516.7 73 515.91 73 515.91 72.48 516.7 72.48 516.7 72.32 515.75 72.32",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#q)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M517.21,72.97c.13-.17.28-.25.46-.25.27,0,.46.19.46.57v.69h-.16v-.67c0-.29-.09-.45-.33-.45-.13,0-.24.06-.32.17-.09.12-.11.24-.11.43v.52h-.16v-1.23h.16v.22h0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.5,73.24c-.06-.25-.25-.37-.46-.37s-.38.12-.46.37h.92ZM518.57,73.38c0,.28.2.49.46.49s.38-.15.47-.29l.13.07c-.12.25-.32.37-.58.37-.41,0-.64-.31-.64-.64s.25-.65.63-.65c.35,0,.63.25.64.66h-1.11Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.07,72.93c.09-.13.19-.21.32-.21.07,0,.11.02.14.04l-.08.13s-.05-.02-.08-.02c-.12,0-.22.1-.27.27-.02.08-.03.2-.03.37v.47h-.17v-1.23h.17v.18h0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.76,73.37c0,.25.17.46.5.46.27,0,.47-.18.47-.47s-.22-.48-.47-.48c-.28,0-.49.21-.49.49M521.88,73.73c0,.2-.01.37-.11.5-.1.14-.29.23-.52.23-.35,0-.53-.14-.63-.38h.17c.09.16.24.24.45.24s.35-.07.43-.21c.05-.09.05-.17.05-.27v-.09c-.12.15-.3.23-.49.23-.34,0-.63-.26-.63-.62s.3-.64.63-.64c.22,0,.36.09.49.24v-.21h.16v.98h0Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "522.14 72.75 522.3 72.75 522.73 73.7 523.14 72.75 523.3 72.75 522.57 74.43 522.4 74.43 522.64 73.89 522.14 72.75",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "524.18 72.32 524.18 73.98 525.13 73.98 525.13 73.82 524.34 73.82 524.34 73.16 525.13 73.16 525.13 73 524.34 73 524.34 72.48 525.13 72.48 525.13 72.32 524.18 72.32",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#r)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M525.46,72.56c0-.2.05-.32.25-.32.07,0,.13.02.18.03v.16s-.08-.04-.15-.04c-.13,0-.12.08-.12.19v.17h.26v.14h-.26v1.09h-.16v-1.09h-.16v-.14h.16v-.19Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.79,72.75h.16v1.23h-.16v-1.23ZM526.23,72.67c0-.29.14-.43.37-.43.2,0,.34.13.35.31h-.16c-.02-.1-.08-.16-.19-.16-.15,0-.2.1-.2.28v.08h.25v.14h-.25v1.09h-.17v-1.09h-.16v-.14h.16s0-.08,0-.08Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.47,73.73c-.12.18-.33.28-.58.28-.4,0-.68-.29-.68-.63,0-.36.28-.66.69-.66.24,0,.45.1.56.29l-.13.08c-.11-.14-.26-.21-.44-.21-.31,0-.52.23-.52.49s.2.5.52.5c.18,0,.33-.07.44-.22l.13.08h.01Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.76,72.75h.16v1.23h-.16v-1.23ZM528.97,72.38c0,.07-.06.13-.13.13s-.13-.06-.13-.13.06-.13.13-.13.13.06.13.13",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530.28,73.24c-.06-.25-.25-.37-.46-.37s-.38.12-.46.37h.92ZM529.34,73.38c0,.28.2.49.46.49s.38-.15.47-.29l.13.07c-.12.25-.32.37-.58.37-.41,0-.64-.31-.64-.64s.25-.65.63-.65c.35,0,.63.25.64.66h-1.11Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530.99,72.97c.13-.17.28-.25.46-.25.27,0,.46.19.46.57v.69h-.16v-.67c0-.29-.09-.45-.33-.45-.13,0-.24.06-.32.17-.09.12-.11.24-.11.43v.52h-.16v-1.23h.16v.22h0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M533.44,73.73c-.12.18-.33.28-.58.28-.4,0-.68-.29-.68-.63,0-.36.28-.66.69-.66.24,0,.45.1.56.29l-.13.08c-.11-.14-.26-.21-.44-.21-.31,0-.52.23-.52.49s.2.5.52.5c.18,0,.33-.07.44-.22l.13.08h.01Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "533.61 72.75 533.78 72.75 534.2 73.7 534.61 72.75 534.78 72.75 534.05 74.43 533.88 74.43 534.12 73.89 533.61 72.75",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M-1.75,171.63h315.17c9.88,0,17.9,8.02,17.9,17.9v558.54c0,9.88-8.02,17.9-17.9,17.9H-1.75V171.63h0Z",
    fill: "url(#s)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#t)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: -11.2,
    y: 171.63,
    width: 350.51,
    height: 200.85,
    fill: "url(#u)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -11.2,
    y: 171.63,
    width: 350.51,
    height: 200.85,
    fill: "url(#v)"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 162.17,
    cy: 369.93,
    r: 129.78,
    fill: "url(#w)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 162.17,
    cy: 371.24,
    r: 129.78,
    fill: "url(#x)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#y)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M237.74,394.31l34.72,11.32c1.85-5.69,3.28-11.6,4.25-17.7s1.45-12.16,1.46-18.14l-36.54-.04c0,8.57-1.37,16.82-3.89,24.55h0Z",
    fill: "#91cb87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.63,369.76l36.54.04c.03-12.4-1.94-24.47-5.63-35.85l-34.75,11.25c2.49,7.71,3.84,15.94,3.84,24.48v.08Z",
    fill: "#378e43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.46,259.32c-11.63,3.77-22.54,9.35-32.34,16.46l21.43,29.57c6.68-4.85,14.14-8.68,22.15-11.28l-11.25-34.75h.01Z",
    fill: "#ee4338"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.91,463.45c9.67,7.05,20.53,12.67,32.32,16.5l11.32-34.72c-8.01-2.61-15.46-6.46-22.13-11.32l-21.51,29.54Z",
    fill: "#91cb87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.83,405.4c3.77,11.63,9.35,22.54,16.46,32.34l29.57-21.43c-4.85-6.68-8.68-14.14-11.28-22.15l-34.75,11.25h0Z",
    fill: "#91cb87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.23,479.95c5.69,1.85,11.6,3.28,17.7,4.25s12.16,1.45,18.14,1.46l.04-36.54c-8.57,0-16.82-1.37-24.55-3.89l-11.32,34.72h0Z",
    fill: "#91cb87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.86,416.31l-29.57,21.43c7.11,9.8,15.74,18.5,25.62,25.7l21.51-29.54c-6.73-4.91-12.66-10.85-17.56-17.6h0Z",
    fill: "#91cb87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.1,449.12l-.04,36.54c12.4.03,24.47-1.94,35.85-5.63l-11.25-34.75c-7.71,2.49-15.94,3.84-24.48,3.84h-.08Z",
    fill: "#91cb87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.96,437.96c7.05-9.67,12.67-20.53,16.5-32.32l-34.72-11.32c-2.61,8.01-6.46,15.46-11.32,22.13l29.54,21.51h0Z",
    fill: "#91cb87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.91,480.03c11.63-3.77,22.54-9.35,32.34-16.46l-21.43-29.57c-6.68,4.85-14.14,8.68-22.15,11.28l11.25,34.75h-.01Z",
    fill: "#91cb87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.82,434l21.43,29.57c9.8-7.11,18.5-15.74,25.7-25.62l-29.54-21.51c-4.91,6.73-10.85,12.66-17.6,17.56h.01Z",
    fill: "#91cb87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.74,369.59l-36.54-.04c-.03,12.4,1.94,24.47,5.63,35.85l34.75-11.25c-2.49-7.71-3.84-15.94-3.84-24.48,0-.03,0-.06,0-.08Z",
    fill: "#91cb87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.47,275.91c-9.67-7.05-20.53-12.67-32.32-16.5l-11.32,34.72c8.01,2.61,15.46,6.46,22.13,11.32l21.51-29.54h0Z",
    fill: "#fcd401"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.54,333.95c-3.77-11.63-9.35-22.54-16.46-32.34l-29.57,21.43c4.85,6.68,8.68,14.14,11.28,22.15l34.75-11.25h0Z",
    fill: "#66bb6a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.51,323.04l29.57-21.43c-7.11-9.8-15.74-18.5-25.62-25.7l-21.51,29.54c6.73,4.91,12.66,10.85,17.56,17.6h0Z",
    fill: "#fcd401"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.27,290.23l.04-36.54c-12.4-.03-24.47,1.94-35.85,5.63l11.25,34.75c7.71-2.49,15.94-3.84,24.48-3.84h.08Z",
    fill: "#ee4338"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.15,259.41c-5.69-1.85-11.6-3.28-17.7-4.25-6.1-.97-12.16-1.45-18.14-1.46l-.04,36.54c8.57,0,16.82,1.37,24.55,3.89l11.32-34.72h0Z",
    fill: "#fcd401"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.92,333.72c-1.85,5.69-3.28,11.6-4.25,17.7s-1.45,12.16-1.46,18.14l36.54.04c0-8.57,1.37-16.82,3.89-24.55l-34.72-11.32h0Z",
    fill: "#ee4338"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.42,301.4c-7.05,9.67-12.67,20.53-16.5,32.32l34.72,11.32c2.61-8.01,6.46-15.46,11.32-22.13l-29.54-21.51Z",
    fill: "#ee4338"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.56,305.35l-21.43-29.57c-9.8,7.11-18.5,15.74-25.7,25.62l29.54,21.51c4.91-6.73,10.85-12.66,17.6-17.56h0Z",
    fill: "#ee4338"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#z)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M238.95,369.73c0,8.27-1.33,16.23-3.76,23.69l33.5,10.92c1.78-5.49,3.17-11.19,4.1-17.07.94-5.88,1.4-11.73,1.41-17.5l-35.26-.04h0Z",
    fill: "#91cb87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.95,369.73l35.26.04c.03-11.96-1.87-23.61-5.43-34.59l-33.53,10.86c2.41,7.44,3.71,15.38,3.71,23.62v.08h-.01Z",
    fill: "url(#aa)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.82,263.17c-11.22,3.64-21.75,9.03-31.2,15.88l20.68,28.53c6.44-4.68,13.64-8.38,21.38-10.88,0,0-10.86-33.53-10.86-33.53Z",
    fill: "#f5f5f6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.41,460.13c9.33,6.8,19.81,12.23,31.19,15.92l10.92-33.5c-7.73-2.52-14.92-6.23-21.35-10.93l-20.76,28.5h0Z",
    fill: "#91cb87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.81,404.13c3.64,11.22,9.03,21.75,15.88,31.2l28.53-20.68c-4.68-6.44-8.38-13.64-10.88-21.38,0,0-33.53,10.86-33.53,10.86Z",
    fill: "#91cb87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.59,476.05c5.49,1.78,11.19,3.17,17.07,4.1,5.88.94,11.73,1.4,17.5,1.41l.04-35.26c-8.27,0-16.23-1.33-23.69-3.76l-10.92,33.5h0Z",
    fill: "#91cb87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.22,414.65l-28.53,20.68c6.86,9.46,15.19,17.85,24.72,24.8l20.76-28.5c-6.5-4.74-12.22-10.47-16.94-16.98h-.01Z",
    fill: "#91cb87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.21,446.31l-.04,35.26c11.96.03,23.61-1.87,34.59-5.43l-10.86-33.53c-7.44,2.41-15.38,3.71-23.62,3.71h-.08,0Z",
    fill: "#91cb87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.77,435.54c6.8-9.33,12.23-19.81,15.92-31.19l-33.5-10.92c-2.52,7.73-6.23,14.92-10.93,21.35l28.5,20.76h0Z",
    fill: "#91cb87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.76,476.14c11.22-3.64,21.75-9.03,31.2-15.88l-20.68-28.53c-6.44,4.68-13.64,8.38-21.38,10.88l10.86,33.53Z",
    fill: "#91cb87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.29,431.72l20.68,28.53c9.46-6.86,17.85-15.19,24.8-24.72l-28.5-20.76c-4.74,6.5-10.47,12.22-16.98,16.94h0Z",
    fill: "#91cb87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.63,369.57l-35.26-.04c-.03,11.96,1.87,23.61,5.43,34.59l33.53-10.86c-2.41-7.44-3.71-15.38-3.71-23.62v-.08h0Z",
    fill: "#91cb87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.17,279.17c-9.33-6.8-19.81-12.23-31.19-15.92l-10.92,33.5c7.73,2.52,14.92,6.23,21.35,10.93l20.76-28.5h0Z",
    fill: "url(#ab)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.77,335.18c-3.64-11.22-9.03-21.75-15.88-31.2l-28.53,20.68c4.68,6.44,8.38,13.64,10.88,21.38l33.53-10.86Z",
    fill: "url(#ac)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.36,324.66l28.53-20.68c-6.86-9.46-15.19-17.85-24.72-24.8l-20.76,28.5c6.5,4.74,12.22,10.47,16.94,16.98h0Z",
    fill: "url(#ad)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.37,292.99l.04-35.26c-11.96-.03-23.61,1.87-34.59,5.43l10.86,33.53c7.44-2.41,15.38-3.71,23.62-3.71h.08,0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.99,263.25c-5.49-1.78-11.19-3.17-17.07-4.1-5.88-.94-11.73-1.4-17.5-1.41l-.04,35.26c8.27,0,16.23,1.33,23.69,3.76l10.92-33.5h0Z",
    fill: "url(#ae)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.89,334.96c-1.78,5.49-3.17,11.19-4.1,17.07-.94,5.88-1.4,11.73-1.41,17.5l35.26.04c0-8.27,1.33-16.23,3.76-23.69l-33.5-10.92h-.01Z",
    fill: "#e2e3e4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.81,303.77c-6.8,9.33-12.23,19.81-15.92,31.19l33.5,10.92c2.52-7.73,6.23-14.92,10.93-21.35l-28.5-20.76h-.01Z",
    fill: "#e8e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.29,307.58l-20.68-28.53c-9.46,6.86-17.85,15.19-24.8,24.72l28.5,20.76c4.74-6.5,10.47-12.22,16.98-16.94h0Z",
    fill: "#eeefef"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M162.17,439.86c37.99,0,68.79-30.8,68.79-68.79s-30.8-68.79-68.79-68.79-68.79,30.8-68.79,68.79,30.8,68.79,68.79,68.79",
    fill: "#006a77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1.75,365.98h333.07v424.26c0,9.88-8.02,17.9-17.9,17.9H-1.75v-442.16h0Z",
    fill: "url(#af)"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 58.71,
    y: 48.16,
    width: 1.34,
    height: 53.49,
    fill: "#03ac96"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70.29,
    y: 54.84,
    width: 1.34,
    height: 40.12,
    fill: "#03ac96"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81.87,
    y: 61.53,
    width: 1.34,
    height: 26.74,
    fill: "#03ac96"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35.55,
    y: 61.53,
    width: 1.34,
    height: 26.74,
    fill: "#03ac96"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 47.13,
    y: 54.84,
    width: 1.34,
    height: 40.12,
    fill: "#03ac96"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M63.11,74.9c0,2.07-1.67,3.74-3.74,3.74s-3.74-1.67-3.74-3.74,1.67-3.74,3.74-3.74,3.74,1.67,3.74,3.74",
    fill: "#026b78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.95,74.9c0,2.07-1.67,3.74-3.74,3.74s-3.74-1.67-3.74-3.74,1.67-3.74,3.74-3.74,3.74,1.67,3.74,3.74",
    fill: "#03ac96"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.96,71.49c-1.81,0-3.27-1.47-3.27-3.27s1.47-3.27,3.27-3.27,3.27,1.47,3.27,3.27-1.47,3.27-3.27,3.27",
    fill: "#03ac96"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.96,84.86c-1.81,0-3.27-1.47-3.27-3.27s1.47-3.27,3.27-3.27,3.27,1.46,3.27,3.27-1.47,3.27-3.27,3.27",
    fill: "#026b78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.38,64.33c-1.81,0-3.27-1.47-3.27-3.27s1.47-3.27,3.27-3.27,3.27,1.46,3.27,3.27-1.46,3.27-3.27,3.27",
    fill: "#03ac96"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.38,92.01c-1.81,0-3.27-1.47-3.27-3.27s1.47-3.27,3.27-3.27,3.27,1.46,3.27,3.27-1.46,3.27-3.27,3.27",
    fill: "#03ac96"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.28,74.9c0,2.07-1.67,3.74-3.74,3.74s-3.74-1.67-3.74-3.74,1.67-3.74,3.74-3.74,3.74,1.67,3.74,3.74",
    fill: "#03ac96"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.57,48.16c0-1.55,1.25-2.8,2.8-2.8s2.8,1.26,2.8,2.8-1.26,2.8-2.8,2.8-2.8-1.26-2.8-2.8",
    fill: "#026b78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.57,101.65c0-1.55,1.25-2.8,2.8-2.8s2.8,1.26,2.8,2.8-1.26,2.8-2.8,2.8-2.8-1.26-2.8-2.8",
    fill: "#026b78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.15,54.84c0-1.55,1.26-2.8,2.8-2.8s2.8,1.26,2.8,2.8-1.25,2.8-2.8,2.8-2.8-1.26-2.8-2.8",
    fill: "#026b78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.15,94.96c0-1.55,1.26-2.8,2.8-2.8s2.8,1.26,2.8,2.8-1.25,2.8-2.8,2.8-2.8-1.26-2.8-2.8",
    fill: "#026b78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.73,61.53c0-1.55,1.26-2.8,2.8-2.8s2.8,1.26,2.8,2.8-1.25,2.8-2.8,2.8-2.8-1.26-2.8-2.8",
    fill: "#026b78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.41,61.53c0-1.55,1.25-2.8,2.8-2.8s2.8,1.26,2.8,2.8-1.26,2.8-2.8,2.8-2.8-1.26-2.8-2.8",
    fill: "#026b78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.73,88.27c0-1.55,1.26-2.8,2.8-2.8s2.8,1.26,2.8,2.8-1.25,2.8-2.8,2.8-2.8-1.25-2.8-2.8",
    fill: "#026b78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.41,88.27c0-1.55,1.25-2.8,2.8-2.8s2.8,1.26,2.8,2.8-1.26,2.8-2.8,2.8-2.8-1.25-2.8-2.8",
    fill: "#026b78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.8,71.49c-1.81,0-3.27-1.47-3.27-3.27s1.47-3.27,3.27-3.27,3.27,1.47,3.27,3.27-1.47,3.27-3.27,3.27",
    fill: "#026b78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.8,84.86c-1.81,0-3.27-1.47-3.27-3.27s1.47-3.27,3.27-3.27,3.27,1.46,3.27,3.27-1.47,3.27-3.27,3.27",
    fill: "#03ac96"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.99,54.84c0-1.55,1.26-2.8,2.8-2.8s2.8,1.26,2.8,2.8-1.26,2.8-2.8,2.8-2.8-1.26-2.8-2.8",
    fill: "#026b78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.99,94.96c0-1.55,1.26-2.8,2.8-2.8s2.8,1.26,2.8,2.8-1.26,2.8-2.8,2.8-2.8-1.26-2.8-2.8",
    fill: "#026b78"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M114.44,92.47c8.71,0,14.14-3.77,14.14-9.69,0-12.72-20.75-6.42-20.75-14.14,0-2.59,2.53-4.51,7.72-4.51,3.21,0,6.48.68,9.45,2.59l2.53-4.69c-2.84-1.85-7.66-2.96-11.92-2.96-8.4,0-13.65,3.95-13.65,9.82,0,13.03,20.69,6.67,20.69,14.02,0,2.78-2.29,4.45-7.78,4.45-4.26,0-8.71-1.42-11.49-3.4l-2.47,4.69c2.72,2.16,8.09,3.83,13.52,3.83M159.01,59.37l-11.3,26.18-11.42-26.18h-6.18l14.45,32.67-1.05,2.28c-1.61,3.77-3.4,5.06-6.24,5.06-2.22,0-4.26-.86-5.87-2.41l-2.53,4.45c2.04,1.98,5.25,3.03,8.4,3.03,5,0,8.77-2.16,11.67-9.08l15.87-36h-5.81.01ZM186.5,59.06c-5.19,0-9.39,1.91-11.79,5.25v-4.94h-5.68v32.73h5.93v-16.86c0-7.1,4.07-10.87,10.37-10.87,5.62,0,8.83,3.15,8.83,9.57v18.16h5.93v-18.84c0-9.63-5.62-14.2-13.59-14.2M224.96,85.92c-1.23.99-2.9,1.54-4.63,1.54-3.27,0-5.13-1.98-5.13-5.5v-17.72h9.39v-4.88h-9.39v-7.16h-5.93v7.16h-5.56v4.88h5.56v17.97c0,6.61,3.77,10.25,10.37,10.25,2.66,0,5.37-.74,7.16-2.28l-1.85-4.26h.01ZM234.68,53.07c2.35,0,4.01-1.73,4.01-3.95,0-2.1-1.73-3.77-4.01-3.77s-4.01,1.73-4.01,3.89,1.73,3.83,4.01,3.83M231.71,92.1h5.93v-32.73h-5.93v32.73ZM252.17,64.87v-5.49h-5.68v32.73h5.93v-16.3c0-7.16,3.95-11.05,10.31-11.05.43,0,.86,0,1.36.06v-5.74c-5.74,0-9.82,1.98-11.92,5.8M283.19,92.47c9.82,0,16.98-6.98,16.98-16.74s-7.16-16.67-16.98-16.67-17.04,6.92-17.04,16.67,7.23,16.74,17.04,16.74M283.19,87.28c-6.3,0-11.05-4.57-11.05-11.55s4.75-11.49,11.05-11.49,10.99,4.51,10.99,11.49-4.69,11.55-10.99,11.55",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.89,103.9l-1.36-3.5h-1.47l2.14,5.05c-.12.35-.29.61-.51.77-.21.16-.5.24-.86.23v1.25c.67.03,1.22-.12,1.67-.45.45-.34.81-.88,1.08-1.62l1.9-5.22h-1.44l-1.15,3.5h0ZM333.59,100.4h-1.18v-1.46l-1.34.41v1.05h-.91v1.29h.91v2.17c0,.72.19,1.21.57,1.49s1.03.37,1.95.26v-1.22c-.26.01-.47.02-.65,0-.17,0-.31-.06-.4-.14s-.14-.22-.14-.4v-2.17h1.18v-1.29h0ZM329.37,100.4h-1.34v5.21h1.34v-5.21ZM329.29,99.53c.16-.16.24-.36.24-.58s-.08-.42-.24-.58c-.16-.17-.36-.25-.59-.25s-.42.08-.58.25c-.16.17-.24.36-.24.58s.08.42.24.58.36.24.58.24.43-.08.59-.24M326.8,98h-1.35v7.61h1.35v-7.61ZM324.22,100.4h-1.35v5.21h1.35v-5.21ZM324.14,99.53c.16-.16.24-.36.24-.58s-.08-.42-.24-.58c-.16-.17-.36-.25-.59-.25s-.42.08-.58.25c-.16.17-.24.36-.24.58s.08.42.24.58.36.24.58.24.43-.08.59-.24M317.7,103c0-.43.14-.78.41-1.06s.62-.41,1.03-.41.76.14,1.04.41c.27.27.41.63.41,1.06s-.14.78-.41,1.06c-.27.27-.62.41-1.04.41s-.76-.14-1.03-.41c-.27-.28-.41-.63-.41-1.06M317.7,101.01v-2.7h-1.35v7.3h1.35v-.62c.4.51.96.76,1.69.76s1.3-.27,1.8-.8c.5-.53.75-1.18.75-1.95s-.25-1.42-.75-1.95-1.1-.8-1.8-.8-1.29.25-1.69.76M310.9,103c0-.43.14-.78.41-1.06s.61-.41,1.03-.41.76.14,1.04.41c.27.27.41.63.41,1.06s-.14.78-.41,1.06c-.27.27-.62.41-1.04.41s-.76-.14-1.03-.41c-.27-.28-.41-.63-.41-1.06M313.79,101.01c-.4-.51-.97-.76-1.7-.76s-1.29.27-1.79.8c-.5.53-.74,1.18-.74,1.95s.25,1.42.74,1.95c.5.53,1.09.8,1.79.8s1.3-.25,1.7-.76v.62h1.34v-5.21h-1.34v.62h0ZM305.16,100.98v-.58h-1.35v5.21h1.35v-2.82c0-.43.1-.75.31-.97s.49-.32.83-.32c.31,0,.56.09.75.28.19.18.28.45.28.8v3.03h1.35v-3.2c0-.67-.19-1.2-.56-1.58-.37-.38-.84-.57-1.41-.57-.71,0-1.23.24-1.55.73M302.58,100.4h-1.35v5.21h1.35v-5.21ZM302.49,99.53c.16-.16.24-.36.24-.58s-.08-.42-.24-.58c-.16-.17-.36-.25-.59-.25s-.42.08-.58.25c-.16.17-.24.36-.24.58s.08.42.24.58.36.24.58.24.43-.08.59-.24M295.79,103c0-.43.14-.78.41-1.06s.61-.41,1.03-.41.76.14,1.04.41c.27.27.41.63.41,1.06s-.14.78-.41,1.06c-.27.27-.62.41-1.04.41s-.76-.14-1.03-.41c-.27-.28-.41-.63-.41-1.06M298.67,101.01c-.4-.51-.97-.76-1.7-.76s-1.29.27-1.79.8c-.5.53-.74,1.18-.74,1.95s.25,1.42.74,1.95c.5.53,1.09.8,1.79.8s1.3-.25,1.7-.76v.62h1.35v-5.21h-1.35v.62h0ZM293.92,100.4h-1.18v-1.46l-1.34.41v1.05h-.91v1.29h.91v2.17c0,.72.19,1.21.57,1.49s1.03.37,1.95.26v-1.22c-.26.01-.47.02-.65,0-.17,0-.31-.06-.4-.14s-.14-.22-.14-.4v-2.17h1.18v-1.29h0ZM287.71,101.57c.12-.08.26-.11.43-.11.39,0,.67.18.83.53l1.15-.63c-.2-.35-.48-.63-.82-.82-.35-.19-.73-.29-1.16-.29-.56,0-1.03.15-1.41.44-.38.3-.57.7-.57,1.21,0,.34.09.62.28.85.18.23.41.39.67.49s.53.19.79.26.49.15.67.24c.18.09.28.2.28.34,0,.3-.24.45-.72.45-.53,0-.87-.23-1.02-.68l-1.17.66c.39.83,1.12,1.24,2.19,1.24.6,0,1.1-.14,1.5-.43s.6-.7.6-1.23c0-.36-.09-.65-.28-.89-.18-.24-.41-.41-.67-.51s-.53-.18-.79-.25-.49-.14-.67-.23c-.18-.09-.28-.2-.28-.34s.06-.24.17-.31M283.76,103.21c0,.43-.1.75-.31.97-.21.21-.49.32-.83.32-.31,0-.56-.09-.75-.28-.19-.18-.28-.45-.28-.8v-3.03h-1.34v3.2c0,.67.18,1.2.56,1.59.37.38.84.57,1.41.57.71,0,1.23-.24,1.55-.73v.58h1.35v-5.21h-1.35v2.82h-.01ZM276.94,101.57c.12-.08.26-.11.43-.11.39,0,.67.18.83.53l1.15-.63c-.2-.35-.48-.63-.82-.82-.35-.19-.73-.29-1.16-.29-.56,0-1.03.15-1.41.44-.38.3-.57.7-.57,1.21,0,.34.09.62.28.85.18.23.41.39.67.49s.53.19.79.26.49.15.67.24c.18.09.28.2.28.34,0,.3-.24.45-.72.45-.53,0-.87-.23-1.02-.68l-1.17.66c.39.83,1.12,1.24,2.19,1.24.6,0,1.1-.14,1.5-.43s.6-.7.6-1.23c0-.36-.09-.65-.28-.89-.18-.24-.41-.41-.67-.51s-.53-.18-.79-.25-.49-.14-.67-.23c-.18-.09-.28-.2-.28-.34s.06-.24.17-.31",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.24,101.74c.24-.18.54-.28.9-.28.31,0,.58.09.82.26.24.17.4.44.47.79h-2.66c.08-.33.23-.59.47-.78M271.72,103.56c.03-.19.05-.38.05-.55,0-.78-.25-1.43-.75-1.96s-1.13-.79-1.89-.79c-.81,0-1.47.26-1.98.79-.51.52-.77,1.18-.77,1.97s.26,1.45.78,1.97,1.21.78,2.07.78c1,0,1.76-.37,2.27-1.12l-1.08-.63c-.26.35-.65.52-1.17.52-.8,0-1.29-.33-1.47-.98h3.94ZM263.37,104.05l-1.26-3.65h-1.48l1.98,5.21h1.53l1.98-5.21h-1.48l-1.27,3.65ZM259.87,100.4h-1.35v5.21h1.35v-5.21ZM259.78,99.53c.16-.16.24-.36.24-.58s-.08-.42-.24-.58c-.16-.17-.36-.25-.59-.25s-.42.08-.58.25c-.16.17-.24.36-.24.58s.08.42.24.58.36.24.58.24.43-.08.59-.24M257.47,100.4h-1.18v-1.46l-1.35.41v1.05h-.91v1.29h.91v2.17c0,.72.19,1.21.57,1.49s1.03.36,1.96.26v-1.22c-.26.01-.47.02-.65,0-.17-.01-.31-.06-.4-.14s-.13-.22-.13-.4v-2.17h1.18v-1.29h0ZM253.16,100.4h-1.35v5.21h1.35v-5.21ZM253.07,99.53c.16-.16.25-.36.25-.58s-.08-.42-.25-.58c-.16-.17-.36-.25-.59-.25s-.42.08-.58.25-.24.36-.24.58.08.42.24.58.36.24.58.24.43-.08.59-.24M249.13,103.21c0,.43-.1.75-.31.97-.21.21-.49.32-.83.32-.31,0-.56-.09-.75-.28-.19-.18-.28-.45-.28-.8v-3.03h-1.35v3.2c0,.67.19,1.2.56,1.59.37.38.84.57,1.41.57.71,0,1.23-.24,1.55-.73v.58h1.34v-5.21h-1.34v2.82ZM244.56,100.4h-1.18v-1.46l-1.34.41v1.05h-.91v1.29h.91v2.17c0,.72.19,1.21.57,1.49s1.03.36,1.96.26v-1.22c-.26.01-.47.02-.65,0-.17-.01-.31-.06-.4-.14s-.14-.22-.14-.4v-2.17h1.18v-1.29h0ZM236.8,100.98v-.58h-1.35v5.21h1.35v-2.82c0-.43.1-.75.31-.97.21-.22.49-.32.83-.32.31,0,.56.09.75.28.19.18.28.45.28.8v3.03h1.34v-3.2c0-.67-.19-1.2-.56-1.59-.37-.38-.84-.57-1.41-.57-.71,0-1.23.24-1.55.73M234.12,100.4h-1.35v5.21h1.35v-5.21ZM234.03,99.53c.16-.16.24-.36.24-.58s-.08-.42-.24-.58c-.16-.17-.36-.25-.59-.25s-.41.08-.58.25c-.16.17-.24.36-.24.58s.08.42.24.58.36.24.58.24.43-.08.59-.24",
    fill: "#03ac96"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M311.5,59.94l-1.44,2.38-1.45-2.38h-1.03v5.05h1v-3.26l1.42,2.34h.12l1.42-2.35v3.27h.99v-5.05h-1.03ZM303.24,59.94v.95h1.36v4.1h1v-4.1h1.36v-.95h-3.72,0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M53.51,614.48l.57-1.21c.8.73,2.18,1.25,3.57,1.25,1.87,0,2.67-.73,2.67-1.67,0-2.64-6.55-.97-6.55-4.99,0-1.67,1.3-3.09,4.14-3.09,1.27,0,2.58.34,3.48.96l-.51,1.24c-.94-.6-2.01-.88-2.97-.88-1.84,0-2.63.77-2.63,1.72,0,2.64,6.55.99,6.55,4.96,0,1.65-1.33,3.08-4.19,3.08-1.65,0-3.28-.56-4.14-1.36h0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.13,611.62c0-2.44,1.81-4.17,4.27-4.17s4.25,1.73,4.25,4.17-1.79,4.19-4.25,4.19-4.27-1.75-4.27-4.19ZM70.15,611.62c0-1.75-1.17-2.88-2.75-2.88s-2.77,1.13-2.77,2.88,1.19,2.89,2.77,2.89,2.75-1.14,2.75-2.89Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.95,611.62c0-2.44,1.81-4.17,4.33-4.17,1.47,0,2.69.6,3.34,1.75l-1.13.73c-.53-.8-1.33-1.17-2.23-1.17-1.61,0-2.81,1.13-2.81,2.88s1.21,2.89,2.81,2.89c.9,0,1.7-.37,2.23-1.17l1.13.71c-.65,1.14-1.87,1.76-3.34,1.76-2.52,0-4.33-1.75-4.33-4.19v-.02Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.28,604.99c0-.54.43-.97,1-.97s1,.42,1,.94c0,.56-.42.99-1,.99s-1-.42-1-.96ZM82.54,607.52h1.48v8.19h-1.48v-8.19Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.34,610.77v4.95h-1.41v-1.08c-.49.74-1.41,1.17-2.69,1.17-1.85,0-3.03-.99-3.03-2.41,0-1.31.85-2.4,3.29-2.4h2.35v-.29c0-1.25-.73-1.98-2.19-1.98-.97,0-1.96.34-2.6.88l-.62-1.11c.85-.68,2.07-1.05,3.38-1.05,2.24,0,3.51,1.08,3.51,3.32h.01ZM91.86,613.21v-1.14h-2.29c-1.47,0-1.89.57-1.89,1.27,0,.82.68,1.33,1.81,1.33s1.99-.51,2.36-1.45h.01Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.1,604.25h1.48v11.47h-1.48v-11.47Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M62,667.46h1.48v4.22c-1.08.91-2.58,1.38-4.1,1.38-3.32,0-5.77-2.33-5.77-5.53s2.44-5.53,5.8-5.53c1.72,0,3.17.57,4.16,1.67l-.96.96c-.9-.87-1.92-1.25-3.14-1.25-2.5,0-4.31,1.75-4.31,4.16s1.81,4.16,4.3,4.16c.91,0,1.76-.2,2.53-.7v-3.54Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.47,668.83c0-2.44,1.81-4.17,4.27-4.17s4.25,1.73,4.25,4.17-1.79,4.19-4.25,4.19-4.27-1.75-4.27-4.19ZM72.48,668.83c0-1.75-1.17-2.88-2.75-2.88s-2.77,1.13-2.77,2.88,1.19,2.89,2.77,2.89,2.75-1.14,2.75-2.89Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.08,664.74l-3.59,8.19h-1.51l-3.59-8.19h1.55l2.81,6.57,2.88-6.57h1.45Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.63,669.33h-6.65c.19,1.44,1.34,2.4,2.97,2.4.96,0,1.76-.32,2.36-.99l.82.96c-.74.87-1.87,1.33-3.23,1.33-2.64,0-4.41-1.75-4.41-4.19s1.75-4.17,4.11-4.17,4.05,1.7,4.05,4.22c0,.12-.02.31-.03.45h.01ZM84.98,668.26h5.26c-.15-1.38-1.19-2.35-2.63-2.35s-2.47.96-2.63,2.35Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.12,664.66v1.44c-.12-.02-.23-.02-.34-.02-1.59,0-2.58.97-2.58,2.77v4.08h-1.48v-8.19h1.42v1.38c.53-.96,1.55-1.45,2.98-1.45h0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.74,668.22v4.71h-1.48v-4.54c0-1.61-.8-2.4-2.21-2.4-1.58,0-2.6.94-2.6,2.72v4.22h-1.48v-8.19h1.42v1.24c.6-.83,1.65-1.31,2.95-1.31,1.99,0,3.4,1.14,3.4,3.55h0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.99,667.98v4.95h-1.41v-1.08c-.49.74-1.41,1.17-2.69,1.17-1.85,0-3.03-.99-3.03-2.41,0-1.31.85-2.4,3.29-2.4h2.35v-.29c0-1.25-.73-1.98-2.19-1.98-.97,0-1.96.34-2.6.88l-.62-1.11c.85-.68,2.07-1.05,3.38-1.05,2.24,0,3.51,1.08,3.51,3.32h.01ZM115.51,670.43v-1.14h-2.29c-1.47,0-1.89.57-1.89,1.27,0,.82.68,1.33,1.81,1.33s1.99-.51,2.36-1.45h.01Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.52,668.22v4.71h-1.48v-4.54c0-1.61-.8-2.4-2.21-2.4-1.58,0-2.6.94-2.6,2.72v4.22h-1.48v-8.19h1.42v1.24c.6-.83,1.65-1.31,2.95-1.31,1.99,0,3.4,1.14,3.4,3.55h0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.57,668.83c0-2.44,1.81-4.17,4.33-4.17,1.47,0,2.69.6,3.34,1.75l-1.13.73c-.53-.8-1.33-1.17-2.23-1.17-1.61,0-2.81,1.13-2.81,2.88s1.21,2.89,2.81,2.89c.9,0,1.7-.37,2.23-1.17l1.13.71c-.65,1.14-1.87,1.76-3.34,1.76-2.52,0-4.33-1.75-4.33-4.19v-.02Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.42,669.33h-6.65c.19,1.44,1.34,2.4,2.97,2.4.96,0,1.76-.32,2.36-.99l.82.96c-.74.87-1.87,1.33-3.23,1.33-2.64,0-4.41-1.75-4.41-4.19s1.75-4.17,4.11-4.17,4.05,1.7,4.05,4.22c0,.12-.02.31-.03.45h0ZM139.77,668.26h5.26c-.15-1.38-1.19-2.35-2.63-2.35s-2.47.96-2.63,2.35h0Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M70.3,432.33l-2.72-3.87c-.25.02-.52.04-.79.04h-3.12v3.83h-1.8v-12.6h4.92c3.28,0,5.26,1.66,5.26,4.39,0,1.95-1.01,3.35-2.77,3.98l2.99,4.23h-1.97ZM70.25,424.11c0-1.8-1.21-2.83-3.51-2.83h-3.06v5.67h3.06c2.3,0,3.51-1.04,3.51-2.85h0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.3,428.13h-7.74c.22,1.67,1.57,2.79,3.46,2.79,1.12,0,2.05-.38,2.75-1.15l.95,1.12c-.86,1.01-2.18,1.55-3.76,1.55-3.08,0-5.13-2.04-5.13-4.88s2.03-4.86,4.79-4.86,4.72,1.98,4.72,4.92c0,.14-.02.36-.04.52h0ZM75.56,426.89h6.12c-.18-1.6-1.39-2.74-3.06-2.74s-2.88,1.12-3.06,2.74Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.02,426.56v5.76h-1.64v-1.26c-.58.86-1.64,1.37-3.13,1.37-2.16,0-3.53-1.15-3.53-2.81,0-1.53.99-2.79,3.83-2.79h2.74v-.34c0-1.46-.85-2.3-2.56-2.3-1.13,0-2.29.4-3.02,1.03l-.72-1.3c.99-.79,2.41-1.22,3.94-1.22,2.61,0,4.09,1.26,4.09,3.87h0ZM91.29,429.41v-1.33h-2.66c-1.71,0-2.2.67-2.2,1.48,0,.95.79,1.55,2.11,1.55s2.32-.59,2.75-1.69h0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.28,418.97v13.36h-1.66v-1.51c-.77,1.08-2,1.62-3.4,1.62-2.79,0-4.83-1.96-4.83-4.88s2.03-4.86,4.83-4.86c1.35,0,2.54.5,3.33,1.53v-5.26h1.73ZM103.57,427.55c0-2.03-1.39-3.35-3.21-3.35s-3.22,1.31-3.22,3.35,1.39,3.37,3.22,3.37,3.21-1.33,3.21-3.37Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.25,419.83c0-.63.5-1.13,1.17-1.13s1.17.49,1.17,1.1c0,.65-.49,1.15-1.17,1.15s-1.17-.49-1.17-1.12ZM108.55,422.78h1.73v9.54h-1.73v-9.54Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.63,426.83v5.49h-1.73v-5.29c0-1.87-.94-2.79-2.57-2.79-1.84,0-3.02,1.1-3.02,3.17v4.92h-1.73v-9.54h1.66v1.44c.7-.97,1.93-1.53,3.44-1.53,2.32,0,3.96,1.33,3.96,4.14h-.01Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.46,428.13h-7.74c.22,1.67,1.57,2.79,3.46,2.79,1.12,0,2.05-.38,2.75-1.15l.95,1.12c-.86,1.01-2.18,1.55-3.76,1.55-3.08,0-5.13-2.04-5.13-4.88s2.03-4.86,4.79-4.86,4.72,1.98,4.72,4.92c0,.14-.02.36-.04.52h0ZM126.71,426.89h6.12c-.18-1.6-1.39-2.74-3.06-2.74s-2.88,1.12-3.06,2.74Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.68,431.32l.72-1.37c.81.58,2.11.99,3.35.99,1.6,0,2.27-.49,2.27-1.3,0-2.14-6.03-.29-6.03-4.09,0-1.71,1.53-2.86,3.98-2.86,1.24,0,2.65.32,3.48.86l-.74,1.37c-.86-.56-1.82-.76-2.75-.76-1.51,0-2.25.56-2.25,1.31,0,2.25,6.05.41,6.05,4.12,0,1.73-1.58,2.83-4.12,2.83-1.58,0-3.15-.49-3.94-1.12l-.02.02Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.7,431.32l.72-1.37c.81.58,2.11.99,3.35.99,1.6,0,2.27-.49,2.27-1.3,0-2.14-6.03-.29-6.03-4.09,0-1.71,1.53-2.86,3.98-2.86,1.24,0,2.65.32,3.48.86l-.74,1.37c-.86-.56-1.82-.76-2.75-.76-1.51,0-2.25.56-2.25,1.31,0,2.25,6.05.41,6.05,4.12,0,1.73-1.58,2.83-4.12,2.83-1.58,0-3.15-.49-3.94-1.12l-.02.02Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.75,425.95h1.73v4.92c-1.26,1.06-3.01,1.6-4.77,1.6-3.87,0-6.72-2.72-6.72-6.45s2.84-6.45,6.75-6.45c2,0,3.69.67,4.84,1.94l-1.12,1.12c-1.04-1.01-2.23-1.46-3.65-1.46-2.92,0-5.02,2.04-5.02,4.84s2.11,4.84,5.01,4.84c1.06,0,2.05-.23,2.95-.81v-4.11.02Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.22,426.56v5.76h-1.64v-1.26c-.58.86-1.64,1.37-3.13,1.37-2.16,0-3.53-1.15-3.53-2.81,0-1.53.99-2.79,3.83-2.79h2.74v-.34c0-1.46-.85-2.3-2.56-2.3-1.13,0-2.29.4-3.02,1.03l-.72-1.3c.99-.79,2.41-1.22,3.94-1.22,2.61,0,4.09,1.26,4.09,3.87h0ZM179.49,429.41v-1.33h-2.66c-1.71,0-2.2.67-2.2,1.48,0,.95.79,1.55,2.11,1.55s2.32-.59,2.75-1.69h0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.32,422.78v9.54h-1.64v-1.44c-.7.99-1.89,1.55-3.24,1.55-2.47,0-4.11-1.35-4.11-4.16v-5.49h1.73v5.29c0,1.87.94,2.81,2.57,2.81,1.8,0,2.95-1.12,2.95-3.17v-4.93h1.74Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.74,422.78v8.25c0,3.37-1.71,4.9-4.95,4.9-1.75,0-3.51-.49-4.56-1.42l.83-1.33c.88.76,2.27,1.24,3.67,1.24,2.25,0,3.28-1.04,3.28-3.21v-.76c-.83.99-2.07,1.48-3.44,1.48-2.75,0-4.84-1.87-4.84-4.63s2.09-4.61,4.84-4.61c1.42,0,2.72.52,3.53,1.57v-1.48h1.64ZM204.04,427.3c0-1.85-1.37-3.1-3.28-3.1s-3.29,1.24-3.29,3.1,1.37,3.12,3.29,3.12,3.28-1.28,3.28-3.12Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.62,428.13h-7.74c.22,1.67,1.57,2.79,3.46,2.79,1.12,0,2.05-.38,2.75-1.15l.95,1.12c-.86,1.01-2.18,1.55-3.76,1.55-3.08,0-5.13-2.04-5.13-4.88s2.03-4.86,4.79-4.86,4.72,1.98,4.72,4.92c0,.14-.02.36-.04.52h0ZM209.87,426.89h6.12c-.18-1.6-1.39-2.74-3.06-2.74s-2.88,1.12-3.06,2.74Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.98,430.89l.67-1.4c.94.85,2.54,1.46,4.16,1.46,2.18,0,3.12-.85,3.12-1.94,0-3.08-7.63-1.13-7.63-5.82,0-1.94,1.51-3.6,4.83-3.6,1.48,0,3.01.4,4.05,1.12l-.59,1.44c-1.1-.7-2.34-1.03-3.46-1.03-2.14,0-3.06.9-3.06,2,0,3.08,7.63,1.15,7.63,5.78,0,1.93-1.55,3.58-4.88,3.58-1.93,0-3.82-.65-4.83-1.58h0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.18,427.55c0-2.84,2.11-4.86,5.04-4.86,1.71,0,3.13.7,3.89,2.03l-1.31.85c-.61-.94-1.55-1.37-2.59-1.37-1.87,0-3.28,1.31-3.28,3.35s1.4,3.37,3.28,3.37c1.04,0,1.98-.43,2.59-1.37l1.31.83c-.76,1.33-2.18,2.05-3.89,2.05-2.94,0-5.04-2.04-5.04-4.88Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.33,427.55c0-2.84,2.11-4.86,4.97-4.86s4.95,2.02,4.95,4.86-2.09,4.88-4.95,4.88-4.97-2.04-4.97-4.88ZM253.51,427.55c0-2.03-1.37-3.35-3.21-3.35s-3.22,1.31-3.22,3.35,1.39,3.37,3.22,3.37,3.21-1.33,3.21-3.37Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.78,422.69v1.67c-.14-.02-.27-.02-.4-.02-1.85,0-3.01,1.13-3.01,3.22v4.75h-1.73v-9.54h1.66v1.6c.61-1.12,1.8-1.69,3.48-1.69h0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.41,428.13h-7.74c.22,1.67,1.57,2.79,3.46,2.79,1.12,0,2.05-.38,2.75-1.15l.95,1.12c-.86,1.01-2.18,1.55-3.76,1.55-3.08,0-5.13-2.04-5.13-4.88s2.03-4.86,4.79-4.86,4.72,1.98,4.72,4.92c0,.14-.02.36-.04.52h0ZM265.67,426.89h6.12c-.18-1.6-1.39-2.74-3.06-2.74s-2.88,1.12-3.06,2.74Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "403.24 525.83 403.24 533.16 408.28 533.16 408.28 531.98 404.55 531.98 404.55 529.99 407.91 529.99 407.91 528.81 404.55 528.81 404.55 527.01 408.1 527.01 408.1 525.83 403.24 525.83",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "414.87 525.83 414.87 531.27 414.85 531.27 411.3 525.83 409.57 525.83 409.57 533.16 410.87 533.16 410.87 527.54 410.89 527.54 414.52 533.16 416.17 533.16 416.17 525.83 414.87 525.83",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "417.81 525.83 417.81 533.16 422.85 533.16 422.85 531.98 419.11 531.98 419.11 529.99 422.47 529.99 422.47 528.81 419.11 528.81 419.11 527.01 422.66 527.01 422.66 525.83 417.81 525.83",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ag)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M424.13,525.83h2.55c.35,0,.69.03,1.02.1.33.07.62.18.87.34.25.16.46.37.61.64s.23.61.23,1.02c0,.53-.15.98-.44,1.33-.29.36-.71.58-1.26.65l1.95,3.24h-1.57l-1.7-3.1h-.95v3.1h-1.3v-7.33h0ZM426.45,528.93c.19,0,.37,0,.56-.03.19-.02.36-.06.51-.12.15-.07.28-.17.38-.3s.15-.32.15-.56c0-.21-.04-.39-.14-.52-.09-.13-.21-.23-.35-.3-.15-.07-.31-.11-.48-.13-.18-.02-.35-.03-.51-.03h-1.13v1.99h1.01Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.16,532.62c-.9.48-1.92.73-3.03.73-.57,0-1.08-.09-1.56-.27-.47-.18-.88-.44-1.22-.78-.34-.33-.61-.74-.8-1.21-.19-.47-.29-.99-.29-1.56s.1-1.12.29-1.6.46-.89.8-1.23c.34-.34.75-.6,1.22-.78.47-.18.99-.27,1.56-.27s1.08.07,1.57.2c.49.13.93.37,1.31.72l-.96.97c-.24-.23-.52-.4-.85-.53s-.69-.19-1.06-.19-.72.07-1.03.2-.57.32-.79.56-.39.52-.51.83c-.12.32-.18.66-.18,1.02,0,.39.06.75.18,1.09.12.33.29.62.51.86s.48.43.79.57.65.21,1.03.21c.33,0,.64-.03.94-.09.29-.06.55-.16.78-.29v-1.73h-1.5v-1.18h2.81v3.75h-.01Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "443 525.83 441.18 528.74 439.38 525.83 437.74 525.83 440.49 530.02 440.5 533.15 441.8 533.15 441.8 530.02 444.55 525.82 443 525.83",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "366.47 536.37 361.15 536.37 361.15 541.64 361.15 546.9 361.15 552.17 361.15 552.17 376.95 552.17 376.95 546.9 366.47 546.9 366.47 541.64 376.95 541.64 376.95 536.37 366.47 536.37",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ah)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M390.21,525.84h-8.02v5.27h7.93c1.45,0,2.63,1.18,2.63,2.63s-1.18,2.63-2.63,2.63h.03-7.96v15.8h1.35c2.18,0,3.95-1.77,3.95-3.95v-6.58h2.72c4.28-.12,7.81-3.61,7.81-7.9s-3.53-7.77-7.81-7.9",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.1,525.83c-2.18,0-3.95,1.77-3.95,3.95v1.32h15.8v-5.27h-11.85,0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.25,546.96h1.84c.33,0,.61.05.83.14s.39.21.51.35c.12.14.21.3.26.47.05.18.07.34.07.51,0,.16-.02.33-.07.51s-.14.33-.26.47c-.12.14-.3.26-.51.35-.22.09-.49.14-.83.14h-1.13v2.3h-.71v-5.24ZM403.95,549.26h.93c.14,0,.27-.01.41-.03.13-.02.26-.06.36-.12s.19-.14.26-.26c.06-.11.1-.25.1-.43s-.03-.32-.1-.43c-.06-.11-.15-.19-.26-.25s-.23-.1-.36-.12c-.14-.02-.27-.03-.41-.03h-.93v1.68h0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.02,552.31c-.4,0-.76-.07-1.1-.21s-.62-.33-.86-.58-.42-.54-.56-.87c-.13-.34-.2-.7-.2-1.09s.07-.75.2-1.08.32-.62.56-.87.53-.44.86-.58c.34-.14.7-.21,1.1-.21s.76.07,1.1.21c.33.14.62.33.86.58.24.24.43.54.56.87.13.34.2.7.2,1.09s-.07.75-.2,1.09c-.14.33-.32.62-.56.87s-.53.44-.86.58-.7.21-1.1.21M410.02,551.65c.3,0,.57-.06.81-.17s.45-.26.62-.45c.17-.19.31-.41.4-.66s.14-.52.14-.81-.05-.55-.14-.81c-.09-.25-.23-.47-.4-.66-.17-.19-.38-.34-.62-.45s-.51-.17-.81-.17-.57.06-.81.17-.45.26-.62.45c-.17.19-.31.41-.4.66s-.14.52-.14.81.05.56.14.81c.09.25.23.47.4.66.17.19.38.33.62.45s.51.17.81.17",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "419.45 546.95 418.29 551.13 418.28 551.13 417.05 546.95 416.24 546.95 415.01 551.13 414.99 551.13 413.84 546.96 413.1 546.96 414.63 552.18 415.38 552.18 416.63 547.91 416.65 547.91 417.91 552.18 418.66 552.18 420.18 546.95 419.45 546.95",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "420.86 546.95 420.86 552.18 424.37 552.18 424.37 551.51 421.57 551.51 421.57 549.84 424.05 549.84 424.05 549.18 421.57 549.18 421.57 547.62 424.23 547.62 424.23 546.95 420.86 546.95",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ai)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M425.37,546.95h1.84c.33,0,.61.05.83.14s.39.21.51.35c.13.14.21.3.26.47.05.17.07.34.07.51s-.03.33-.09.48c-.06.15-.14.3-.26.42-.11.12-.25.23-.41.32s-.34.14-.53.16l1.48,2.38h-.89l-1.33-2.3h-.79v2.3h-.71v-5.23h.02ZM426.08,549.26h.93c.14,0,.27-.01.41-.03s.26-.06.36-.12c.11-.06.19-.14.26-.26.06-.11.1-.25.1-.43s-.03-.32-.1-.43c-.06-.11-.15-.2-.25-.26-.11-.06-.23-.1-.36-.12-.13-.02-.27-.03-.41-.03h-.93v1.68h-.01Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "429.88 546.95 429.88 552.18 433.39 552.18 433.39 551.51 430.59 551.51 430.59 549.84 433.07 549.84 433.07 549.17 430.59 549.17 430.59 547.62 433.25 547.62 433.25 546.95 429.88 546.95",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aj)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M434.27,546.95h1.82c.37,0,.69.04.97.12s.52.2.72.34.37.3.51.48.24.37.32.56c.08.19.14.38.17.58.03.19.05.37.05.53,0,.33-.06.66-.18.97s-.31.59-.55.83-.54.44-.9.59-.77.22-1.24.22h-1.7v-5.22h0ZM434.98,551.51h.89c.3,0,.58-.04.85-.12.27-.08.5-.2.7-.37.2-.16.36-.37.48-.61.12-.24.18-.53.18-.85,0-.17-.03-.36-.08-.59-.06-.22-.16-.44-.31-.64s-.36-.37-.62-.51c-.27-.14-.61-.21-1.03-.21h-1.06v3.9h0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.91,546.95h1.82c.23,0,.44.03.63.08s.36.13.5.24.25.24.33.41c.08.16.12.36.12.58,0,.3-.08.55-.25.73-.17.19-.38.33-.65.42h0c.16.03.31.07.44.14.14.07.26.16.36.28.1.12.18.25.24.4s.09.32.09.5c0,.24-.05.44-.14.62-.1.18-.23.33-.39.45-.17.12-.36.22-.58.28-.22.06-.46.1-.72.1h-1.79v-5.23h0ZM442.62,549.12h.97c.13,0,.26-.01.38-.04.12-.03.22-.07.31-.14s.16-.14.21-.24.08-.22.08-.36c0-.21-.07-.39-.2-.54-.13-.15-.34-.23-.63-.23h-1.11v1.55h0ZM442.62,551.56h1.04c.11,0,.23-.01.36-.03.13-.02.25-.07.36-.13.11-.07.21-.16.29-.27.08-.11.12-.26.12-.45,0-.31-.1-.54-.3-.7-.2-.15-.47-.23-.82-.23h-1.05v1.82h0Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "449.62 546.95 448.15 549.24 446.72 546.95 445.82 546.95 447.79 549.95 447.79 552.17 448.5 552.17 448.5 549.95 450.48 546.95 449.62 546.95",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ak)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M453.13,546.95h1.84c.33,0,.61.05.83.14s.39.21.51.35c.12.14.21.3.26.47.05.17.07.34.07.51s-.03.33-.09.48c-.06.16-.14.3-.26.42-.11.12-.24.23-.41.32-.16.09-.34.14-.53.16l1.48,2.38h-.89l-1.33-2.3h-.79v2.3h-.71v-5.23h.02ZM453.84,549.25h.93c.14,0,.27-.01.41-.03s.26-.06.36-.12c.11-.06.19-.14.26-.26.06-.11.1-.25.1-.43s-.03-.32-.1-.43c-.06-.11-.15-.2-.26-.26-.11-.06-.23-.1-.36-.12-.13-.02-.27-.03-.41-.03h-.93v1.68h0Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "457.64 546.95 457.64 552.17 461.15 552.17 461.15 551.51 458.35 551.51 458.35 549.83 460.83 549.83 460.83 549.17 458.35 549.17 458.35 547.61 461.01 547.61 461.01 546.95 457.64 546.95",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#al)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M462.3,551.08c.13.19.29.33.49.43.2.09.41.14.62.14.12,0,.24-.02.36-.06s.24-.09.34-.17c.1-.07.18-.16.25-.27.06-.11.1-.23.1-.38,0-.2-.06-.36-.19-.46-.13-.11-.29-.19-.48-.26s-.4-.14-.62-.21-.43-.16-.62-.28c-.19-.12-.35-.28-.48-.48-.13-.2-.19-.47-.19-.81,0-.15.03-.32.1-.49s.17-.33.31-.47c.14-.14.33-.26.55-.36.23-.1.49-.14.81-.14.28,0,.56.04.82.12s.49.24.69.48l-.57.52c-.09-.14-.21-.25-.38-.33-.16-.08-.35-.12-.55-.12s-.36.03-.49.08-.24.12-.31.2c-.08.08-.13.17-.17.26-.03.09-.05.18-.05.26,0,.22.06.39.19.51s.29.21.48.29c.19.07.4.14.62.2s.43.14.62.25.35.25.48.43.19.43.19.74c0,.25-.05.48-.14.68-.1.2-.23.37-.39.51s-.35.24-.58.32c-.22.07-.46.11-.71.11-.33,0-.65-.06-.95-.18-.3-.12-.54-.3-.72-.55l.58-.5h0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.86,546.95v3.2c0,.16.02.33.07.5.04.17.12.34.22.48.1.15.24.27.41.36.17.09.37.14.62.14s.45-.05.62-.14c.17-.09.3-.21.41-.36.1-.15.18-.31.22-.48.05-.17.07-.34.07-.5v-3.2h.71v3.31c0,.31-.05.58-.15.83s-.25.46-.43.65c-.18.18-.4.32-.64.42s-.51.15-.8.15-.55-.05-.8-.15c-.25-.1-.46-.24-.64-.42s-.32-.4-.43-.65c-.1-.25-.15-.53-.15-.83v-3.31h.71-.02Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "471.45 546.95 471.45 552.17 474.56 552.17 474.56 551.51 472.16 551.51 472.16 546.95 471.45 546.95",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "474.01 546.95 474.01 547.61 475.69 547.61 475.69 552.17 476.4 552.17 476.4 547.61 478.08 547.61 478.08 546.95 474.01 546.95",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#am)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M478.99,551.08c.13.19.29.33.49.43.2.09.41.14.62.14.12,0,.24-.02.36-.06s.24-.09.34-.17c.1-.07.18-.16.25-.27.06-.11.1-.23.1-.38,0-.2-.06-.36-.19-.46-.13-.11-.29-.2-.48-.27s-.4-.14-.62-.21-.43-.16-.62-.28c-.19-.12-.35-.28-.48-.48-.13-.2-.19-.47-.19-.81,0-.15.03-.31.1-.49.07-.17.17-.33.31-.47.14-.14.33-.26.55-.36.23-.1.49-.14.81-.14.28,0,.56.04.82.12s.49.24.69.48l-.57.52c-.09-.14-.21-.25-.38-.33-.16-.08-.35-.13-.55-.13s-.36.03-.49.08-.24.12-.31.2c-.08.08-.13.17-.17.26-.03.09-.05.18-.05.26,0,.22.06.39.19.51s.29.21.48.29c.19.07.4.14.62.2s.43.14.62.25.35.25.47.43c.13.18.19.43.19.74,0,.25-.05.48-.14.68-.1.2-.23.37-.39.51s-.35.24-.58.32c-.22.07-.46.11-.71.11-.33,0-.65-.06-.95-.18-.3-.12-.54-.3-.72-.55l.58-.5h0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.24,536.37h2.46c.35,0,.69.03,1.02.1.33.07.62.18.86.35.25.16.45.38.6.65s.22.61.22,1.02c0,.46-.08.84-.24,1.12s-.37.5-.64.66c-.27.16-.58.26-.94.32-.36.06-.73.08-1.11.08h-.93v3.03h-1.3v-7.33ZM405.34,539.55c.19,0,.38,0,.58-.02.2-.01.38-.06.55-.12.17-.07.31-.17.42-.31.11-.14.16-.33.16-.58,0-.23-.05-.41-.15-.54s-.22-.24-.37-.31-.32-.12-.51-.14-.37-.03-.54-.03h-.93v2.06h.79Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M411.17,536.39h1.13l3.16,7.33h-1.49l-.68-1.68h-3.18l-.66,1.68h-1.46l3.19-7.33h-.01ZM412.83,540.92l-1.13-2.98-1.15,2.98h2.28Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#an)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M416.28,536.39h2.55c.35,0,.69.03,1.02.1.33.07.62.18.87.34.26.16.46.37.61.64s.23.61.23,1.02c0,.53-.15.98-.44,1.34-.29.36-.71.58-1.26.65l1.95,3.24h-1.57l-1.7-3.11h-.95v3.11h-1.3v-7.33h0ZM418.59,539.49c.19,0,.37,0,.56-.03.19-.02.36-.06.51-.12.16-.06.28-.16.38-.3.1-.13.15-.32.15-.56,0-.21-.05-.39-.14-.52-.09-.13-.21-.23-.35-.3s-.31-.11-.48-.13c-.18-.02-.35-.03-.51-.03h-1.13v1.99h1.01Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "424.11 537.57 421.87 537.57 421.87 536.39 427.66 536.39 427.66 537.57 425.42 537.57 425.42 543.72 424.11 543.72 424.11 537.57",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "428.55 536.39 430.28 536.39 433.83 541.83 433.85 541.83 433.85 536.39 435.15 536.39 435.16 543.71 433.5 543.71 429.88 538.09 429.85 538.09 429.86 543.71 428.55 543.71 428.55 536.39",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "436.79 536.39 441.64 536.38 441.64 537.56 438.09 537.57 438.1 539.37 441.46 539.37 441.46 540.55 438.1 540.55 438.1 542.53 441.83 542.53 441.83 543.71 436.79 543.71 436.79 536.39",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ao)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M443.11,536.38h2.55c.35,0,.69.03,1.02.1.33.07.62.18.87.34.26.16.46.37.61.64s.23.61.23,1.02c0,.53-.15.98-.44,1.34-.29.36-.71.58-1.26.65l1.95,3.24h-1.57l-1.7-3.11h-.95v3.11h-1.3v-7.33h0ZM445.43,539.49c.19,0,.37,0,.56-.03.19-.02.36-.06.51-.12.15-.07.28-.17.38-.3s.15-.32.15-.56c0-.21-.04-.39-.14-.52-.09-.13-.21-.23-.35-.3-.15-.07-.31-.11-.48-.13-.18-.02-.35-.03-.51-.03h-1.13v1.99h1.01Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.23,537.96c-.14-.2-.32-.35-.55-.44-.23-.09-.47-.14-.73-.14-.15,0-.3.02-.44.05-.14.03-.27.09-.38.17-.11.08-.21.17-.27.29-.07.12-.1.26-.1.43,0,.25.09.44.26.57s.39.24.64.34c.26.1.53.19.84.28.3.09.58.21.84.37.25.16.47.37.64.63s.26.61.26,1.05c0,.39-.07.74-.22,1.03-.14.3-.34.54-.58.73-.25.19-.53.34-.85.43-.32.1-.67.15-1.02.15-.46,0-.89-.08-1.31-.23-.42-.15-.78-.41-1.09-.77l.98-.95c.16.24.37.43.63.56s.53.2.82.2c.15,0,.3-.02.46-.06.15-.04.29-.1.41-.19s.22-.19.3-.32.11-.27.11-.44c0-.27-.09-.48-.26-.62s-.39-.27-.64-.37-.53-.2-.84-.28c-.3-.09-.58-.21-.84-.37s-.47-.36-.64-.62-.26-.61-.26-1.04c0-.38.08-.71.23-.98.16-.27.36-.51.61-.69s.54-.32.86-.41c.32-.09.66-.13.99-.13.39,0,.76.06,1.12.18s.69.31.98.58l-.95,1h0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.47,537.48h.2c.13,0,.21,0,.24-.02.03-.01.06-.03.08-.06.02-.03.03-.06.03-.1,0-.05-.01-.08-.04-.11-.02-.03-.06-.05-.1-.05h-.41v.34h0ZM456.2,538.25v-1.34h.57c.14,0,.25.01.31.04.06.02.12.07.16.13s.06.13.06.21c0,.1-.03.18-.09.25s-.15.11-.27.12c.06.03.11.07.14.11.04.04.09.11.15.22l.16.26h-.32l-.2-.29c-.07-.1-.12-.17-.14-.2-.03-.03-.05-.05-.08-.06s-.07-.02-.14-.02h-.05v.56h-.27,0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.73,536.48c-.64,0-1.16.52-1.16,1.16s.52,1.16,1.16,1.16,1.16-.52,1.16-1.16-.52-1.16-1.16-1.16M456.73,539.08c-.79,0-1.44-.65-1.44-1.44s.65-1.44,1.44-1.44,1.44.65,1.44,1.44-.65,1.44-1.44,1.44",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("rect", {
    x: 54.5,
    y: 567.23,
    width: 234.23,
    height: 17.37,
    rx: 8.68,
    ry: 8.68,
    fill: "url(#ap)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 54.5,
    y: 624.28,
    width: 234.23,
    height: 17.37,
    rx: 8.68,
    ry: 8.68,
    fill: "url(#aq)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 54.5,
    y: 681.32,
    width: 234.23,
    height: 17.37,
    rx: 8.68,
    ry: 8.68,
    fill: "url(#ar)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.81,759.14h211.13c8.56,0,15.51,6.95,15.51,15.51v32.49H48.3v-32.49c0-8.56,6.95-15.51,15.51-15.51Z",
    fill: "url(#as)"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "at",
    "data-name": "Layer 4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M530.11,612.92c-1.8,0-3.18-1.3-3.18-3.34s1.38-3.34,3.18-3.34,3.16,1.3,3.16,3.34-1.36,3.34-3.16,3.34M530.39,604.12c-1.46,0-2.7.5-3.54,1.52v-1.4h-2.38v14.56h2.5v-5.18c.86.98,2.06,1.44,3.42,1.44,3.12,0,5.42-2.16,5.42-5.48s-2.3-5.46-5.42-5.46M518.69,614.92h2.5v-14.84h-2.5v14.84ZM510.89,606.12c1.64,0,2.82,1.06,3.02,2.6h-6.06c.24-1.56,1.42-2.6,3.04-2.6M516.29,609.64c0-3.34-2.28-5.52-5.4-5.52s-5.52,2.28-5.52,5.46,2.32,5.48,5.9,5.48c1.84,0,3.34-.6,4.3-1.74l-1.34-1.54c-.76.78-1.7,1.16-2.9,1.16-1.86,0-3.16-1-3.46-2.56h8.38c.02-.24.04-.54.04-.74M498.51,604.12c-1.48,0-2.74.48-3.56,1.36v-5.4h-2.5v14.84h2.5v-5.4c0-2.14,1.2-3.22,2.98-3.22,1.6,0,2.54.92,2.54,2.82v5.8h2.5v-6.12c0-3.22-1.9-4.68-4.46-4.68M479.13,606.12c1.64,0,2.82,1.06,3.02,2.6h-6.06c.24-1.56,1.42-2.6,3.04-2.6M484.53,609.64c0-3.34-2.28-5.52-5.4-5.52s-5.52,2.28-5.52,5.46,2.32,5.48,5.9,5.48c1.84,0,3.34-.6,4.3-1.74l-1.34-1.54c-.76.78-1.7,1.16-2.9,1.16-1.86,0-3.16-1-3.46-2.56h8.38c.02-.24.04-.54.04-.74M470.85,604.24l-2.9,7.92-2.88-7.92h-2.1l-2.94,7.88-2.82-7.88h-2.36l3.92,10.68h2.4l2.8-7.36,2.76,7.36h2.4l3.94-10.68h-2.22ZM443.25,604.12c-1.56,0-2.86.52-3.68,1.5v-1.38h-2.38v10.68h2.5v-5.4c0-2.14,1.2-3.22,2.98-3.22,1.6,0,2.54.92,2.54,2.82v5.8h2.5v-6.12c0-3.22-1.9-4.68-4.46-4.68M428.79,613.24c-1.28,0-2.04-.58-2.04-1.48,0-.78.46-1.42,2.16-1.42h2.58v1.24c-.42,1.1-1.48,1.66-2.7,1.66M429.13,604.12c-1.72,0-3.38.44-4.52,1.32l.98,1.82c.8-.66,2.04-1.06,3.24-1.06,1.78,0,2.66.86,2.66,2.32v.16h-2.76c-3.24,0-4.44,1.4-4.44,3.18s1.54,3.2,3.98,3.2c1.6,0,2.76-.52,3.36-1.44v1.3h2.36v-6.26c0-3.08-1.78-4.54-4.86-4.54M418.33,615.06c2.08,0,3.74-.9,4.56-2.5l-1.92-1.12c-.64,1.02-1.6,1.48-2.66,1.48-1.84,0-3.24-1.26-3.24-3.34s1.4-3.34,3.24-3.34c1.06,0,2.02.46,2.66,1.48l1.92-1.12c-.82-1.62-2.48-2.48-4.56-2.48-3.38,0-5.78,2.26-5.78,5.46s2.4,5.48,5.78,5.48M403.97,604.24l-2.9,7.92-2.88-7.92h-2.1l-2.94,7.88-2.82-7.88h-2.36l3.92,10.68h2.4l2.8-7.36,2.76,7.36h2.4l3.94-10.68h-2.22ZM381.73,612.92c-1.8,0-3.16-1.3-3.16-3.34s1.36-3.34,3.16-3.34,3.18,1.3,3.18,3.34-1.36,3.34-3.18,3.34M381.73,615.06c3.32,0,5.7-2.28,5.7-5.48s-2.38-5.46-5.7-5.46-5.68,2.26-5.68,5.46,2.4,5.48,5.68,5.48M370.81,600.92v5.78h-7.24v-5.78h-2.6v14h2.6v-6h7.24v6h2.6v-14h-2.6Z",
    fill: "#0e3a5a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.84,662.76v-.9h-.93v5.39h.98v-2.69c0-1.18.65-1.82,1.7-1.82.07,0,.14,0,.22.01v-.94c-.95,0-1.62.32-1.96.96M458.88,662.62c.95,0,1.63.64,1.73,1.55h-3.46c.1-.92.79-1.55,1.73-1.55M461.55,664.58c0-1.66-1.11-2.78-2.67-2.78s-2.71,1.15-2.71,2.75,1.16,2.76,2.9,2.76c.9,0,1.64-.31,2.13-.87l-.54-.63c-.4.44-.93.65-1.56.65-1.07,0-1.83-.63-1.96-1.58h4.38c.01-.09.02-.21.02-.29M452,666.17c-1.09,0-1.86-.72-1.86-1.76s.77-1.75,1.86-1.75,1.85.7,1.85,1.75-.77,1.76-1.85,1.76M453.88,661.85v.83c-.46-.59-1.19-.88-2-.88-1.56,0-2.74,1.05-2.74,2.61s1.18,2.62,2.74,2.62c.77,0,1.48-.27,1.95-.83v.43c0,1.22-.58,1.81-1.85,1.81-.79,0-1.58-.28-2.08-.7l-.47.75c.59.53,1.59.8,2.58.8,1.83,0,2.8-.86,2.8-2.77v-4.66h-.93ZM445.27,666.56c-.74,0-1.19-.34-1.19-.88,0-.46.28-.83,1.24-.83h1.51v.75c-.24.62-.82.96-1.56.96M445.5,661.8c-.87,0-1.67.24-2.23.69l.41.73c.42-.36,1.07-.58,1.71-.58.97,0,1.45.48,1.45,1.3v.19h-1.55c-1.61,0-2.17.71-2.17,1.58,0,.94.77,1.59,2,1.59.84,0,1.45-.28,1.77-.77v.71h.92v-3.26c0-1.48-.83-2.19-2.31-2.19M439.48,661.8c-.85,0-1.55.32-1.94.86v-.81h-.93v5.39h.98v-2.78c0-1.17.67-1.79,1.71-1.79.93,0,1.46.52,1.46,1.58v2.99h.98v-3.11c0-1.59-.92-2.34-2.24-2.34M432.25,666.56c-.74,0-1.19-.34-1.19-.88,0-.46.28-.83,1.24-.83h1.51v.75c-.25.62-.83.96-1.56.96M432.48,661.8c-.87,0-1.67.24-2.23.69l.41.73c.42-.36,1.07-.58,1.71-.58.97,0,1.45.48,1.45,1.3v.19h-1.55c-1.61,0-2.17.71-2.17,1.58,0,.94.77,1.59,1.99,1.59.85,0,1.45-.28,1.77-.77v.71h.93v-3.26c0-1.48-.83-2.19-2.31-2.19M428.52,667.25v-7.12h-.84l-2.93,5.01-2.98-5.01h-.83v7.12h.98v-5.16l2.58,4.3h.47l2.58-4.33v5.19h.99-.02Z",
    fill: "#0e3a5a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.81,654.01c-.2.16-.48.25-.76.25-.54,0-.85-.33-.85-.91v-2.92h1.55v-.8h-1.55v-1.18h-.98v1.18h-.92v.8h.92v2.96c0,1.09.62,1.69,1.71,1.69.44,0,.89-.12,1.18-.38l-.31-.7h0ZM514.03,649.59c-.86,0-1.55.32-1.95.86v-.81h-.93v5.39h.98v-2.78c0-1.17.67-1.79,1.71-1.79.93,0,1.46.52,1.46,1.58v2.99h.98v-3.1c0-1.59-.93-2.34-2.24-2.34M507.13,650.41c.95,0,1.63.64,1.73,1.55h-3.46c.1-.92.79-1.55,1.73-1.55M509.79,652.36c0-1.66-1.11-2.78-2.67-2.78s-2.71,1.15-2.71,2.75,1.16,2.76,2.9,2.76c.9,0,1.64-.31,2.13-.88l-.54-.63c-.4.44-.93.65-1.56.65-1.07,0-1.83-.63-1.96-1.58h4.38c.01-.09.02-.21.02-.29M500.88,649.59c-.92,0-1.67.39-2.08,1-.36-.67-1.05-1-1.87-1s-1.48.3-1.86.85v-.8h-.94v5.39h.98v-2.78c0-1.17.64-1.79,1.62-1.79.89,0,1.4.52,1.4,1.58v2.99h.98v-2.78c0-1.17.64-1.79,1.62-1.79.89,0,1.4.52,1.4,1.58v2.99h.98v-3.1c0-1.59-.89-2.34-2.21-2.34M490.11,650.41c.95,0,1.63.64,1.73,1.55h-3.46c.1-.92.8-1.55,1.73-1.55M492.77,652.36c0-1.66-1.11-2.78-2.67-2.78s-2.71,1.15-2.71,2.75,1.16,2.76,2.9,2.76c.9,0,1.64-.31,2.13-.88l-.54-.63c-.4.44-.93.65-1.56.65-1.07,0-1.83-.63-1.96-1.58h4.38c0-.09.02-.21.02-.29M483.22,653.95c-1.09,0-1.86-.72-1.86-1.76s.77-1.75,1.86-1.75,1.85.7,1.85,1.75-.77,1.76-1.85,1.76M485.11,649.64v.83c-.46-.59-1.19-.88-2-.88-1.56,0-2.74,1.05-2.74,2.61s1.18,2.62,2.74,2.62c.77,0,1.48-.28,1.94-.83v.43c0,1.22-.58,1.81-1.85,1.81-.79,0-1.58-.28-2.08-.7l-.47.75c.59.53,1.59.8,2.58.8,1.83,0,2.8-.86,2.8-2.77v-4.66h-.93.01ZM476.49,654.34c-.74,0-1.19-.34-1.19-.88,0-.46.28-.83,1.24-.83h1.51v.75c-.24.62-.82.96-1.56.96M476.72,649.59c-.87,0-1.67.24-2.23.69l.41.73c.42-.36,1.07-.58,1.71-.58.97,0,1.45.48,1.45,1.3v.19h-1.55c-1.61,0-2.17.71-2.17,1.58,0,.94.77,1.59,1.99,1.59.85,0,1.45-.29,1.77-.77v.71h.92v-3.26c0-1.48-.83-2.19-2.31-2.19M470.08,653.95c-1.09,0-1.86-.72-1.86-1.76s.77-1.75,1.86-1.75,1.85.7,1.85,1.75-.77,1.76-1.85,1.76M471.97,649.64v.83c-.46-.59-1.19-.88-2-.88-1.56,0-2.74,1.05-2.74,2.61s1.18,2.62,2.74,2.62c.77,0,1.48-.28,1.94-.83v.43c0,1.22-.58,1.81-1.85,1.81-.79,0-1.58-.28-2.08-.7l-.47.75c.59.53,1.59.8,2.57.8,1.83,0,2.8-.86,2.8-2.77v-4.66h-.92.01ZM463.65,649.59c-.85,0-1.55.32-1.94.86v-.81h-.94v5.39h.98v-2.78c0-1.17.67-1.79,1.71-1.79.93,0,1.46.52,1.46,1.58v2.99h.98v-3.1c0-1.59-.93-2.34-2.24-2.34M455.11,654.15v-2.3h3.57v-.86h-3.57v-2.19h4.01v-.88h-5.03v7.12h5.17v-.89h-4.15ZM449.72,654.01c-.2.16-.48.25-.76.25-.54,0-.85-.33-.85-.91v-2.92h1.55v-.8h-1.55v-1.18h-.98v1.18h-.92v.8h.92v2.96c0,1.09.62,1.69,1.71,1.69.44,0,.89-.12,1.18-.38l-.31-.7h.01ZM442.94,649.59c-.86,0-1.55.32-1.94.86v-.81h-.94v5.39h.98v-2.78c0-1.17.67-1.79,1.71-1.79.93,0,1.46.52,1.46,1.58v2.99h.98v-3.1c0-1.59-.93-2.34-2.24-2.34M436.04,650.41c.95,0,1.63.64,1.73,1.55h-3.46c.1-.92.79-1.55,1.73-1.55M438.71,652.36c0-1.66-1.11-2.78-2.67-2.78s-2.71,1.15-2.71,2.75,1.16,2.76,2.9,2.76c.9,0,1.64-.31,2.13-.88l-.54-.63c-.4.44-.93.65-1.56.65-1.07,0-1.83-.63-1.96-1.58h4.38c.01-.09.02-.21.02-.29M430.99,655.03h.98v-5.39h-.98v5.39ZM431.48,648.6c.39,0,.66-.29.66-.65s-.28-.62-.66-.62-.66.28-.66.64.28.63.66.63M428.15,655.03h.98v-7.55h-.98v7.55ZM424.12,655.11c1.11,0,2.07-.39,2.72-1.12l-.66-.64c-.55.58-1.22.86-2.01.86-1.61,0-2.8-1.16-2.8-2.74s1.19-2.74,2.8-2.74c.78,0,1.46.27,2.01.85l.66-.64c-.65-.73-1.61-1.11-2.71-1.11-2.17,0-3.77,1.54-3.77,3.64s1.61,3.64,3.76,3.64",
    fill: "#0e3a5a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.97,642.81h2.02v-9.6h-2.02v9.6ZM489.01,637.27c.91,0,1.57.57,1.71,1.45h-3.43c.14-.89.8-1.45,1.72-1.45M492.62,639.36c0-2.24-1.58-3.61-3.62-3.61s-3.71,1.5-3.71,3.58,1.57,3.58,3.97,3.58c1.25,0,2.23-.39,2.87-1.12l-1.08-1.17c-.48.45-1.01.67-1.75.67-1.06,0-1.8-.53-1.99-1.4h5.27c.01-.17.04-.39.04-.54M481.73,633.75v5.5l-4.51-5.5h-1.73v9.06h2.07v-5.5l4.52,5.5h1.72v-9.06h-2.07,0ZM467.15,642.92c2.08,0,3.29-.92,3.29-2.21,0-2.74-4.21-1.59-4.21-2.78,0-.36.39-.65,1.3-.65.64,0,1.32.13,2.01.52l.67-1.44c-.66-.39-1.72-.61-2.68-.61-2.03,0-3.22.93-3.22,2.25,0,2.78,4.21,1.62,4.21,2.76,0,.39-.35.64-1.28.64-.86,0-1.8-.27-2.42-.67l-.67,1.45c.65.43,1.84.75,3.01.75M459.85,637.27c.91,0,1.57.57,1.71,1.45h-3.43c.14-.89.8-1.45,1.72-1.45M463.46,639.36c0-2.24-1.58-3.61-3.62-3.61s-3.71,1.5-3.71,3.58,1.57,3.58,3.97,3.58c1.26,0,2.23-.39,2.87-1.12l-1.07-1.17c-.48.45-1.01.67-1.75.67-1.06,0-1.8-.53-1.99-1.4h5.27c.01-.17.04-.39.04-.54M452.74,642.81h2.02v-9.6h-2.02v9.6ZM449.14,636.77v-.92h-1.93v6.96h2.02v-3.29c0-1.33.74-1.94,1.85-1.94.16,0,.29.01.45.03v-1.86c-1.07,0-1.9.35-2.39,1.02M441.88,641.56c-.71,0-1.14-.34-1.14-.84,0-.47.3-.82,1.24-.82h1.39v.71c-.23.64-.82.95-1.49.95M442.04,635.75c-1.11,0-2.24.3-3,.84l.72,1.41c.5-.4,1.27-.65,2.01-.65,1.09,0,1.61.51,1.61,1.37h-1.61c-2.12,0-2.99.85-2.99,2.08s.97,2.11,2.6,2.11c1.02,0,1.75-.34,2.12-.97v.87h1.89v-3.97c0-2.11-1.23-3.09-3.35-3.09M434.52,635.75c-.89,0-1.67.29-2.21.83v-3.37h-2.02v9.6h2.02v-3.44c0-1.28.7-1.88,1.67-1.88.89,0,1.41.52,1.41,1.64v3.68h2.02v-3.99c0-2.12-1.24-3.08-2.89-3.08M425.27,642.97c1.58,0,2.89-.57,3.74-1.62l-1.35-1.24c-.61.71-1.37,1.07-2.28,1.07-1.7,0-2.9-1.19-2.9-2.9s1.2-2.9,2.9-2.9c.91,0,1.67.36,2.28,1.06l1.35-1.24c-.85-1.04-2.16-1.61-3.73-1.61-2.82,0-4.92,1.95-4.92,4.69s2.1,4.68,4.9,4.68",
    fill: "#0e3a5a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.92,726.28l-1.86,4.32-1.88-4.32h-1.02l2.38,5.39-.17.38c-.26.62-.56.84-1.03.84-.37,0-.7-.14-.97-.4l-.42.73c.33.33.86.5,1.38.5.82,0,1.44-.36,1.92-1.5l2.62-5.93h-.96,0ZM483.72,730.66c-.2.16-.48.25-.76.25-.54,0-.85-.33-.85-.91v-2.92h1.55v-.8h-1.55v-1.18h-.98v1.18h-.92v.8h.92v2.96c0,1.09.62,1.69,1.71,1.69.44,0,.89-.12,1.18-.38l-.31-.7h.01ZM478.15,731.68h.98v-5.39h-.98v5.39ZM478.64,725.24c.39,0,.66-.29.66-.65s-.29-.62-.66-.62-.66.28-.66.64.28.63.66.63M475.31,731.68h.98v-7.55h-.98v7.55ZM472.47,731.68h.98v-5.39h-.98v5.39ZM472.96,725.24c.39,0,.66-.29.66-.65s-.28-.62-.66-.62-.66.28-.66.64.29.63.66.63M468.31,730.88c-1.03,0-1.81-.75-1.81-1.91s.78-1.89,1.81-1.89,1.82.74,1.82,1.89-.79,1.91-1.82,1.91M468.39,726.23c-.76,0-1.44.28-1.88.86v-2.97h-.98v7.55h.94v-.85c.44.61,1.13.92,1.92.92,1.58,0,2.73-1.11,2.73-2.76s-1.15-2.75-2.73-2.75M461.18,730.99c-.74,0-1.19-.34-1.19-.88,0-.46.28-.84,1.24-.84h1.51v.75c-.24.62-.82.96-1.56.96M461.41,726.23c-.87,0-1.67.24-2.23.69l.41.73c.42-.36,1.07-.58,1.71-.58.97,0,1.45.48,1.45,1.3v.19h-1.55c-1.61,0-2.17.71-2.17,1.58,0,.94.77,1.59,2,1.59.85,0,1.45-.28,1.77-.77v.71h.92v-3.26c0-1.48-.83-2.19-2.31-2.19M455.39,726.23c-.85,0-1.55.32-1.94.86v-.81h-.94v5.39h.98v-2.78c0-1.17.67-1.79,1.71-1.79.93,0,1.46.52,1.46,1.58v2.99h.98v-3.11c0-1.59-.92-2.34-2.24-2.34M449.67,731.68h.98v-5.39h-.98v5.39ZM450.16,725.24c.39,0,.66-.29.66-.65s-.28-.62-.66-.62-.66.28-.66.64.29.63.66.63M445.32,730.99c-.74,0-1.19-.34-1.19-.88,0-.46.28-.84,1.24-.84h1.51v.75c-.25.62-.83.96-1.56.96M445.55,726.23c-.87,0-1.67.24-2.23.69l.41.73c.42-.36,1.07-.58,1.71-.58.97,0,1.45.48,1.45,1.3v.19h-1.55c-1.61,0-2.17.71-2.17,1.58,0,.94.77,1.59,1.99,1.59.85,0,1.45-.28,1.77-.77v.71h.92v-3.26c0-1.48-.83-2.19-2.31-2.19M442.09,730.66c-.2.16-.48.25-.76.25-.54,0-.85-.33-.85-.91v-2.92h1.55v-.8h-1.55v-1.18h-.98v1.18h-.92v.8h.92v2.96c0,1.09.62,1.69,1.71,1.69.44,0,.89-.12,1.18-.38l-.31-.7h.01ZM435.81,731.74c1.43,0,2.33-.62,2.33-1.6,0-2.1-3.42-1.06-3.42-2.33,0-.43.42-.74,1.27-.74.53,0,1.07.11,1.56.43l.42-.77c-.47-.3-1.26-.49-1.96-.49-1.39,0-2.25.65-2.25,1.62,0,2.15,3.41,1.1,3.41,2.31,0,.46-.38.73-1.28.73-.7,0-1.44-.23-1.89-.56l-.41.77c.45.36,1.33.63,2.23.63M431.43,726.28v2.79c0,1.16-.65,1.79-1.67,1.79-.93,0-1.46-.53-1.46-1.59v-2.99h-.98v3.1c0,1.59.92,2.35,2.32,2.35.76,0,1.44-.31,1.83-.87v.81h.92v-5.39h-.98.02ZM423.27,731.76c1.88,0,2.76-.94,2.76-2.02,0-2.61-4.32-1.53-4.32-3.27,0-.62.52-1.13,1.73-1.13.63,0,1.33.18,1.95.58l.33-.82c-.59-.41-1.45-.63-2.29-.63-1.87,0-2.73.94-2.73,2.04,0,2.65,4.32,1.55,4.32,3.29,0,.62-.53,1.1-1.76,1.1-.92,0-1.82-.35-2.35-.82l-.38.79c.57.53,1.64.89,2.73.89",
    fill: "#0e3a5a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.14,714.97v-.9h-.94v5.39h.98v-2.69c0-1.18.65-1.82,1.7-1.82.07,0,.14,0,.22.01v-.95c-.95,0-1.62.33-1.96.96M502.19,714.84c.95,0,1.63.64,1.73,1.55h-3.46c.1-.92.79-1.55,1.73-1.55M504.85,716.79c0-1.66-1.11-2.78-2.67-2.78s-2.71,1.15-2.71,2.75,1.16,2.76,2.9,2.76c.9,0,1.64-.31,2.13-.88l-.54-.63c-.4.44-.93.65-1.56.65-1.07,0-1.83-.63-1.96-1.58h4.38c.01-.09.02-.21.02-.3M495.31,718.38c-1.09,0-1.86-.72-1.86-1.76s.77-1.75,1.86-1.75,1.85.7,1.85,1.75-.77,1.76-1.85,1.76M497.19,714.07v.83c-.46-.59-1.19-.89-2-.89-1.56,0-2.74,1.05-2.74,2.61s1.18,2.62,2.74,2.62c.77,0,1.48-.27,1.95-.83v.43c0,1.22-.58,1.81-1.85,1.81-.79,0-1.58-.27-2.08-.7l-.47.75c.59.53,1.59.8,2.58.8,1.83,0,2.8-.86,2.8-2.77v-4.66h-.93ZM488.58,718.77c-.74,0-1.19-.34-1.19-.88,0-.46.28-.84,1.24-.84h1.51v.75c-.24.62-.83.96-1.56.96M488.8,714.02c-.87,0-1.67.24-2.23.69l.41.73c.42-.36,1.07-.58,1.71-.58.97,0,1.45.48,1.45,1.3v.19h-1.55c-1.61,0-2.17.71-2.17,1.58,0,.94.77,1.59,1.99,1.59.85,0,1.45-.29,1.77-.77v.71h.92v-3.26c0-1.48-.83-2.19-2.31-2.19M482.78,714.02c-.86,0-1.55.32-1.95.86v-.81h-.93v5.39h.98v-2.78c0-1.17.67-1.79,1.71-1.79.93,0,1.46.52,1.46,1.58v2.99h.98v-3.1c0-1.59-.92-2.34-2.24-2.34M475.56,718.77c-.74,0-1.19-.34-1.19-.88,0-.46.27-.84,1.24-.84h1.51v.75c-.25.62-.83.96-1.56.96M475.78,714.02c-.87,0-1.67.24-2.23.69l.41.73c.42-.36,1.07-.58,1.71-.58.97,0,1.45.48,1.45,1.3v.19h-1.55c-1.61,0-2.17.71-2.17,1.58,0,.94.77,1.59,1.99,1.59.85,0,1.45-.29,1.77-.77v.71h.93v-3.26c0-1.48-.83-2.19-2.31-2.19M471.82,719.46v-7.12h-.84l-2.93,5.01-2.98-5.01h-.83v7.12h.98v-5.16l2.58,4.3h.47l2.58-4.33v5.19h.99-.02ZM458.52,719.46h.98v-7.55h-.98v7.55ZM454.17,718.77c-.74,0-1.19-.34-1.19-.88,0-.46.27-.84,1.24-.84h1.51v.75c-.24.62-.83.96-1.56.96M454.39,714.02c-.87,0-1.67.24-2.23.69l.41.73c.42-.36,1.07-.58,1.71-.58.97,0,1.45.48,1.45,1.3v.19h-1.55c-1.61,0-2.17.71-2.17,1.58,0,.94.77,1.59,2,1.59.84,0,1.45-.29,1.77-.77v.71h.93v-3.26c0-1.48-.83-2.19-2.31-2.19M449.27,714.97v-.9h-.94v5.39h.98v-2.69c0-1.18.65-1.82,1.7-1.82.07,0,.14,0,.22.01v-.95c-.95,0-1.62.33-1.96.96M444.31,714.84c.95,0,1.63.64,1.73,1.55h-3.46c.1-.92.8-1.55,1.73-1.55M446.98,716.79c0-1.66-1.11-2.78-2.67-2.78s-2.71,1.15-2.71,2.75,1.16,2.76,2.9,2.76c.9,0,1.64-.31,2.13-.88l-.54-.63c-.4.44-.93.65-1.56.65-1.07,0-1.83-.63-1.96-1.58h4.38c.01-.09.02-.21.02-.3M438.02,714.02c-.86,0-1.55.32-1.94.86v-.81h-.94v5.39h.98v-2.78c0-1.17.67-1.79,1.71-1.79.93,0,1.46.52,1.46,1.58v2.99h.98v-3.1c0-1.59-.92-2.34-2.24-2.34M431.12,714.84c.95,0,1.63.64,1.73,1.55h-3.46c.1-.92.8-1.55,1.73-1.55M433.79,716.79c0-1.66-1.11-2.78-2.67-2.78s-2.71,1.15-2.71,2.75,1.16,2.76,2.9,2.76c.9,0,1.64-.31,2.13-.88l-.54-.63c-.4.44-.93.65-1.56.65-1.07,0-1.83-.63-1.96-1.58h4.38c0-.09.02-.21.02-.3M426.13,718.18c-.51.33-1.07.46-1.67.46-1.64,0-2.83-1.17-2.83-2.74s1.19-2.74,2.84-2.74c.8,0,1.48.26,2.07.83l.63-.63c-.65-.72-1.61-1.1-2.74-1.1-2.21,0-3.82,1.54-3.82,3.64s1.61,3.64,3.8,3.64c1,0,1.99-.31,2.7-.9v-2.78h-.98v2.32h0Z",
    fill: "#0e3a5a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.65,700.28l-1.97,4.73-1.95-4.73h-2.08l3.01,7.02-.03.07c-.27.62-.58.87-1.14.87-.4,0-.83-.17-1.14-.44l-.74,1.44c.45.4,1.23.63,1.94.63,1.26,0,2.21-.5,2.89-2.19l3.14-7.39h-1.94,0ZM501.83,701.2v-.92h-1.93v6.96h2.02v-3.29c0-1.33.74-1.94,1.85-1.94.15,0,.29.01.45.03v-1.86c-1.07,0-1.9.35-2.39,1.02M494.95,701.7c.91,0,1.57.57,1.71,1.45h-3.43c.14-.89.8-1.45,1.72-1.45M498.56,703.79c0-2.24-1.58-3.61-3.62-3.61s-3.71,1.5-3.71,3.59,1.57,3.58,3.97,3.58c1.26,0,2.23-.39,2.87-1.12l-1.07-1.17c-.48.45-1.01.67-1.75.67-1.06,0-1.8-.53-1.99-1.4h5.27c.01-.17.04-.39.04-.54M487.84,700.28v3.44c0,1.28-.67,1.88-1.61,1.88s-1.41-.52-1.41-1.68v-3.64h-2.02v3.94c0,2.15,1.23,3.13,2.98,3.13.86,0,1.63-.32,2.16-.93v.83h1.92v-6.96h-2.02ZM477.23,705.69c-1.01,0-1.79-.73-1.79-1.93s.78-1.93,1.79-1.93,1.77.72,1.77,1.93-.78,1.93-1.77,1.93M479.05,700.28v.8c-.51-.61-1.24-.91-2.18-.91-1.97,0-3.48,1.4-3.48,3.59s1.51,3.58,3.48,3.58c.86,0,1.58-.27,2.09-.84v3.25h2.02v-9.47h-1.93ZM469.72,707.35c1.46,0,2.61-.65,3.12-1.76l-1.57-.85c-.38.67-.93.96-1.57.96-1.02,0-1.82-.71-1.82-1.93s.8-1.93,1.82-1.93c.63,0,1.19.3,1.57.96l1.57-.84c-.5-1.14-1.66-1.77-3.12-1.77-2.26,0-3.88,1.49-3.88,3.59s1.62,3.58,3.88,3.58M462.46,707.24h2.02v-6.96h-2.02v6.96ZM463.46,699.31c.75,0,1.25-.49,1.25-1.16,0-.62-.5-1.09-1.25-1.09s-1.25.49-1.25,1.13.5,1.12,1.25,1.12M459.63,698.18l-2.79,6.47-2.76-6.47h-2.26l3.91,9.06h2.07l3.92-9.06h-2.09ZM443.87,705.99c-.71,0-1.14-.34-1.14-.84,0-.47.3-.82,1.24-.82h1.39v.71c-.23.64-.82.95-1.49.95M444.02,700.18c-1.11,0-2.24.3-3,.84l.72,1.41c.5-.4,1.27-.65,2.01-.65,1.09,0,1.61.51,1.61,1.37h-1.61c-2.12,0-2.99.85-2.99,2.08s.97,2.11,2.6,2.11c1.02,0,1.75-.34,2.12-.97v.87h1.89v-3.97c0-2.11-1.23-3.09-3.35-3.09M437.32,707.24h2.02v-9.6h-2.02v9.6ZM433.42,707.24h2.02v-6.96h-2.02v6.96ZM434.43,699.31c.75,0,1.26-.49,1.26-1.16,0-.62-.51-1.09-1.26-1.09s-1.25.49-1.25,1.13.5,1.12,1.25,1.12M431.41,707.24l-.03-9.06h-1.72l-3.34,5.63-3.39-5.63h-1.73v9.06h1.97v-5.32l2.65,4.36h.94l2.67-4.48v5.44h1.98Z",
    fill: "#0e3a5a"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M380.17,652.33v1.27h-1.18v1.09h2.36v-1.18h1.27v1.27h-1.18v7.16h-1.27v-1.18h-2.45v-1.27h1.18v-2.36h-1.18v-2.36h-1.18v-1.27h1.18v-1.18h-1.18v-2.36h-2.31v-2.45h1.18v-1.06s-.06-.07-.05-.11h-2.31l-.05,2.45h-1.11l-.07.07v1.02h1.18v2.45h1.22v-1.27h1.22v2.54h-1.22v1.09h1.22v3.63h-1.22v-1.18h-1.31v-1.18h-1.09v2.36h1.18v1.27h-1.18v1.18h-1.18v1.18h-1.13v1.09h2.31v3.72h-2.31v1.11l-.07.07h-3.56v2.36h1.02l.07-.07v-1.2h2.54v1.2l-.07.07h-2.42v1.27h-1.13v1.11l-.07.07h-2.38v-2.45h1.11l.07-.07v-2.38h1.11l.07-.07v-2.2h-2.36v-1.27h1.11l.07-.07v-1.11h-1.18v-1.18h-1.09v1.11l-.07.07h-1.2v-1.27h1.18v-1.09h-1.18v-2.45h1.18v-1.27h1.11l.07-.07v-4.53s-.06-.07-.05-.11h-1.04v1.27h-1.27v-2.54h1.18v-1.18h3.63v1.18h2.36v-1.18h2.36v-1.18h1.13v-1.09h-1.13l-.05-1.27h-2.31v1.18h1.27v1.27h-1.27v-1.11l-.07-.07h-1.09l-.07.07v1.11h-1.22v-3.56l-.07-.07h-1.02v2.45h-1.27v-1.16s-.06-.07-.05-.11h-1.13v-1.18h-1.18v-1.27h1.27v1.18h2.27v-2.36h1.27v2.36h1.09v-1.18h1.27v-1.18h1.27v1.18h1.13v2.45h2.27v-3.53h-1.18v-1.18h-1.13v-4.89h1.22v1.18h1.09v-1.11l.07-.07h3.56v-1.09h-1.13v-1.11l-.07-.07h-1.04l-.07.07v1.11h-3.63v-2.45h2.4v1.18h1.22v-1.18h2.4v1.18h1.18v2.36h1.09v-2.29l.07-.07h3.56v-1.11l.07-.07h1.2v3.53h1.09v-1.18h1.27v-1.09h-1.27v-1.27h2.54v1.18h1.09v-1.18h1.27v1.18h1.18v2.36h1.18v-1.18h1.18v-1.09h-1.18v-1.27h7.25v1.27h-1.27v4.62h1.27v1.27h1.18v2.45h-1.27v-2.45h-1.18v2.45h-2.36v1.09h1.18v1.18h2.36v-1.18h3.53v-1.18h3.72v1.18h1.09v-1.18h2.45v2.45h-1.18v1.18h1.18v1.27h-1.18v2.27h1.18v2.45h-2.45v-1.18h-2.27v1.18h1.18v1.27h-1.27v-1.27h-1.18v2.36h2.45v2.36h1.09v-3.53h2.45v2.45h-1.18v2.36h1.18v1.27h-1.18v2.27h1.18v1.2l-.07.07h-1.11v1.18h1.18v1.27h-2.45v-2.54h1.18v-1.09h-2.36v-2.45h1.18v-1.18h-1.18v-1.18h-1.09v1.18h-1.27v2.36h1.27v1.27h-2.45v1.18h-1.18v1.18h1.18v1.18h1.18v-1.18h1.18v-1.27h1.27v1.27h-1.18v2.45h-1.27v2.36h-1.27v-3.53h-1.18v-1.27h-1.09v3.63h-1.18v1.09h1.18v1.27h1.18v1.18h2.36v-1.18h1.18v-1.27h1.27v1.27h-1.18v3.53h1.18v1.18h2.36v1.27h1.18v1.2l-.07.07h-2.29v1.18h-2.36v1.09h1.18v2.4h-7.25v-1.18h-2.36v1.18h-1.27v-2.36h-1.18v-1.22h1.18v-1.09h-4.71v1.02l.07.07h1.11v1.18h1.27v2.4h-1.27v-1.18h-1.11l-.07.07v1.11h-1.27v-2.4h1.18v-1.09h-1.18v-1.18h-1.09v1.18h-1.2l-.07-.07v-2.42h-3.47l-.07.07v1.25h-1.18v1.02l.07.07h2.2v-1.18h1.27v1.27h-1.18v1.02l.07.07h1.11v1.11l.07.07h1.2v1.22h-1.27v-1.18h-1.27v-1.18h-2.36v-1.13h-1.09v3.49h-2.54v-1.18h-1.02l-.07.07v1.11h-1.27v-1.18h-1.02l-.07.07v1.11h-2.54v-1.18h-1.18v-2.31h-1.13v-1.27h1.13v-3.53h-1.13v-1.18h-2.36v-1.27h3.49v-1.18h-1.13v-1.27h1.13v-1.18h1.27v1.27h-1.18v1.11l.07.07h1.11v1.27h-1.18v2.2l.07.07h2.27l.07-.07v-4.74h1.11l.07-.07v-4.64h1.22v1.11l.07.07h1.11v1.27h-1.18v2.36h-1.18v4.8h-1.22v1.02l.07.07h1.16v1.2l.07.07h1.11v1.27h-1.18v2.2l.07.07h3.47v1.11l.07.07h1.11v-3.44h-2.38l-.07-.07v-1.2h1.18v-1.18h-2.29l-.07-.07v-2.38h2.45v2.29l.07.07h4.64v-1.09h-2.29l-.07-.07v-2.29h-1.11l-.07-.07v-2.38h-1.18v2.45h-1.2l-.07-.07v-3.65h2.45v1.13s.1.05.11.05h2.24v-2.27h-1.11l-.07-.07v-1.11h-1.18v1.18h-1.2l-.07-.07v-1.2h1.27v-1.18c-.34,0-.8.04-1.11,0-.07,0-.12,0-.16-.07v-1.2h1.27v1.27h1.18v-1.27h1.18v-1.18h1.18v-1.18h1.18v-2.36h-2.36v-1.27h1.18v-1.18h3.63v-1.09h-3.63v-1.27h1.18v-2.36h-1.18v-1.18h-1.18v-1.18h-4.8v-1.18h-2.2l-.07.07v1.02h1.18v1.18h1.18v1.18h1.09v-1.18h2.54v2.45h-1.27v-1.18h-1.18v1.18h1.18v-.05ZM389.69,634.48h-1.02l-.07.07v2.2h1.09v-2.27ZM396.85,634.48h-2.2l-.07.07v1.02h1.18v1.18h1.09v-2.27h0ZM381.35,635.66h-1.06s-.07.06-.11.05v1.04h1.18v-1.09h-.01ZM380.17,636.84h-1.11l-.07.07v2.2h2.45v2.45h1.09v-1.11l.07-.07h1.2v1.18h1.09v-2.36h-1.18v-2.36h-2.2l-.07.07v1.11h-1.27v-1.18h0ZM388.51,636.84h-3.47l-.07.07v1.02h1.18v1.18h1.27v1.27h1.09v-3.53h0ZM390.87,636.84h-1.02l-.07.07v3.47h1.18v1.27h-1.27v-1.27h-1.09v2.45h-1.18v1.09h2.27v-1.18h1.27v2.36h1.18v-5.98h1.18v-2.27h-1.18v1.18h-1.27v-1.18h0ZM374.24,640.37c0-.66.08-1.57,0-2.2,0-.07,0-.12-.07-.16h-1.09l-.07.07v1.11h-1.11l-.07.07v2.29h1.09v-1.11c.04-.06.09-.06.16-.07.33-.04.81,0,1.16,0v1.18h1.18v-1.06s-.05-.11-.08-.12h-1.1ZM376.55,639.19h-1.02l-.07.07v1.11h1.09v-1.18ZM396.85,639.19h-1.09v2.36h1.09v-2.36ZM377.73,640.37h-1.04l-.05,1.27h-1.11l-.07.07v2.2h1.09v-1.18h1.27v1.18h1.09v-1.18h1.27v2.36h1.27v1.27h1.09v-2.45h1.27v1.18h1.09v-1.18h1.27v-1.09h-2.45v-1.18h-1.02l-.07.07v1.11h-1.27v-1.18h-1.18v-1.27h-1.13s-.05.1-.05.11v1.16h-1.27v-1.27h0ZM387.33,640.37h-1.06l-.11.11v1.06h1.18v-1.18h-.01ZM394.49,640.37h-1.09v1.18h1.09v-1.18ZM395.67,641.64h-1.09v1.09h1.09v-1.09ZM369.43,645.08v-1.02l-.07-.07h-1.11v1.09h1.18ZM375.42,645.08v-1.02l-.07-.07h-1.11v1.09h1.18ZM387.33,644h-1.18v1.18h-1.18v1.18h1.18v1.18h1.27v1.18h1.09v-2.36h-1.18v-2.36h0ZM394.49,644h-1.09v2.36h-2.45v2.45h-1.18v1.09h1.18v1.27h-2.36v2.36h1.09v-1.18h4.8v-1.18h-1.18v-1.18h-1.18v-1.27h2.36v-1.18h2.36v-1.18h-1.18v-1.18h-1.18v-1.18h.01ZM405.28,644h-2.36v2.36h1.18v-1.27h1.18v-1.09h0ZM378.9,645.17h-1.02l-.07.07v1.11h1.09v-1.18ZM390.87,645.17h-1.09v1.18h1.09v-1.18ZM400.47,645.17h-1.09v1.18h-1.27v1.18h1.27v1.27h-1.27v-1.18h-1.18v2.27h1.18v1.18h1.18v-1.18h1.18v-4.71h0ZM383.71,646.35h-1.04s-.05.1-.05.11v2.24h2.36v2.36h1.18v2.45h1.18v-4.71h-1.18v-1.18h-2.45v-1.27h0ZM406.46,646.35h-1.09v1.18h1.09v-1.18ZM405.28,647.62h-3.53v1.09h1.18v1.18h1.18v1.18h1.18v-1.18h2.36v-2.27h-1.09v1.18h-1.27v-1.18h0ZM395.67,648.8h-1.09v1.09h1.09v-1.09ZM401.65,649.98h-1.09v1.18h-1.18v1.18h1.18v1.27h-2.45v2.27h1.27v1.27h-1.27v2.36h1.18v-1.18h2.36v-4.8h1.18v-1.18h-1.18v-2.36h0ZM365.81,651.15h-2.27v1.18h1.18v2.36h1.18v1.18h1.02l.07-.07v-1.11h2.54v1.27h-1.27v1.09h2.29l.07-.07v-1.11h1.13v-2.36h1.18v-1.18h-1.18v-1.18h-1.09v1.18h-1.13v1.27h-1.27v-1.16s-.06-.07-.05-.11h-1.13s-.05.1-.05.11v1.16h-1.22v-2.45h0ZM369.43,651.15h-1.18v1.18h1.18v-1.18ZM398.12,652.33h-1.18v1.18h1.18v-1.18ZM394.49,653.6h-2.36v2.27h2.45v1.18h1.09v-1.18h1.18v-2.27h-1.09v1.18h-1.27v-1.18h0ZM390.87,654.78h-2.27v1.09h2.27v-1.09ZM404.1,654.78h-1.18v1.09h1.18v-1.09ZM365.81,655.96h-1.09v1.18h-1.18v1.18h1.18v1.27h-2.36v1.09h3.38l.07-.07v-2.29h1.18v-1.18h-1.18v-1.18h0ZM380.17,655.96h-1.18v1.02l.07.07h1.11v-1.09ZM388.51,655.96h-1.09v1.09h1.09v-1.09ZM405.28,655.96h-1.18v1.09h1.18v-1.09ZM387.33,657.14h-2.36v1.18h1.18v2.36h1.18v-1.18h1.27v2.45h-4.8v1.09h7.07v-1.09h-1.18v-1.27h1.27v1.18h2.36v-1.09h-1.18v-2.45h-1.18v1.27h-1.27v-1.27h1.18v-1.18h-2.27v1.18h-1.27v-1.18h0ZM394.49,657.14h-1.09v3.53h2.36v1.18h1.09v-1.18h1.27v-1.09h-2.45v-1.27h-1.18v-1.18h0ZM370.61,658.31h-2.36v1.18h2.29l.07-.07v-1.11h0ZM400.47,659.58h-1.09v2.27h1.18v1.18h1.09v-1.18h1.18v-2.27h-1.09v1.18h-1.27v-1.18h0ZM369.43,660.76h-2.4v1.18h-1.13v1.09h1.13v2.38l.07.07h1.09l.07-.07v-1.11h1.11l.07-.07v-1.11h-1.18v-1.27h1.11l.07-.07v-1.02h-.01ZM392.14,664.3h1.27v1.18h1.18v1.18h1.09v-4.71h-2.27v1.18h-1.27v1.18h-1.18v1.18h1.18v-1.18h0ZM398.12,664.3v-2.36h-1.18v2.36h1.18v2.45h-1.18v1.09h2.36v-3.53h-1.18ZM400.47,663.12h-1.09v1.18h1.09v-1.18ZM384.89,664.3h-1.09v3.53h1.09v-1.18h1.27v1.18h1.18v-1.18h1.18v-1.18h1.18v-1.18h-2.27v1.27h-2.54v-1.27h0ZM369.43,665.56h-1.18v1.09h1.11l.07-.07v-1.02ZM394.49,666.74h-2.36v1.09h2.36v-1.09ZM392.14,670.28h-1.27v-1.27h1.27v-1.09h-2.36v1.18h-1.27v-1.18h-1.09v3.53h1.18v2.45h-2.45v1.02l.07.07h1.2v1.2l.07.07h1.02v-1.27h1.18v-1.18h1.18v-1.09h-1.18v-1.27h1.27v1.11l.07.07h2.38v1.27h-2.45v1.02l.07.07h1.11v1.27h1.18v-1.27h2.36v-1.09h-1.18v-2.36h-2.36v-1.27h3.53v-1.27h1.18v-1.09h-2.27v1.18h-2.45v1.18h.01ZM386.16,669.1h-1.18v1.18h1.18v-1.18ZM365.81,670.28h-1.09v1.18h1.02l.07-.07v-1.11ZM398.12,670.28h-1.18v1.27h-1.18v2.27h1.18v2.4h-1.18v1.22h1.18v1.18h1.18v-1.18h1.18v-3.53h-1.18v-3.63h0ZM386.16,671.55h-3.53v1.02l.07.07h1.11v1.11l.07.07h2.29v-2.27h-.01ZM404.1,672.72h-3.53v3.53h3.53v-3.53ZM374.24,675.08h-1.22v2.29l.07.07h2.27l.07-.07v-1.09l-.07-.07h-1.11v-1.13h-.01ZM406.46,675.08h-1.09v2.36h2.2l.07-.07v-1.09l-.07-.07h-1.11v-1.13h0ZM382.53,676.21h-2.24s-.07.06-.11.05v1.13s.1.05.11.05h2.24v-1.22h0ZM390.87,676.21h-1.02l-.07.07v1.09l.07.07h1.02v-1.22h0ZM372.92,677.53h-1.09v1.02l.07.07h1.02v-1.09h0ZM404.1,677.53h-1.18v1.18h-2.36v2.27h1.02l.07-.07v-1.11h2.45v-2.27h0ZM396.85,678.71h-1.09v1.09h1.09v-1.09ZM404.1,680.97h1.11l.07-.07v-1l-.07-.07h-1.11v1.13h0Z",
    fill: "#0e3a5a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.08,641.64h-8.43v-8.43h8.36l.07.07v8.36ZM408.81,640.37v-5.82l-.07-.07h-5.82v5.89h5.89Z",
    fill: "#0e3a5a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.52,641.64h-8.43v-8.43h8.36l.07.07v8.36ZM368.26,640.37v-5.82l-.07-.07h-5.82v5.89h5.89Z",
    fill: "#0e3a5a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.52,673.81v8.38h-8.43v-8.38h8.43ZM368.26,675.08h-5.89v5.89h5.82l.07-.07v-5.82h0Z",
    fill: "#0e3a5a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.08,666.65v7.18l-.07.07h-2.38v-1.18h-1.18v-1.27h1.18v-2.45h1.11l.07-.07v-1.02h-1.18v-1.27h2.45ZM408.81,671.55h-1.09v1.09h1.02l.07-.07v-1.02h0Z",
    fill: "#0e3a5a"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "375.46 659.49 375.46 660.6 375.53 660.67 376.64 660.67 376.64 661.94 375.46 661.94 375.46 663.12 374.24 663.12 374.24 666.67 374.17 666.74 372.99 666.74 372.92 666.67 372.92 663.03 374.17 663.03 374.24 662.96 374.24 661.94 372.92 661.94 372.92 660.67 374.17 660.67 374.24 660.6 374.24 659.49 375.46 659.49",
    fill: "#0e3a5a"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "410.08 678.61 410.08 679.84 408.9 679.84 408.9 682.19 407.63 682.19 407.63 679.79 408.74 679.79 408.81 679.73 408.81 678.61 410.08 678.61",
    fill: "#0e3a5a"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 361.1,
    y: 664.3,
    width: 1.27,
    height: 1.27,
    fill: "#0e3a5a"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "362.37 671.46 362.37 672.66 362.3 672.72 361.1 672.72 361.1 671.46 362.37 671.46",
    fill: "#0e3a5a"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "362.37 666.65 362.37 667.85 362.3 667.92 361.1 667.92 361.1 666.65 362.37 666.65",
    fill: "#0e3a5a"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "362.37 669.01 362.37 670.21 362.3 670.28 361.1 670.28 361.1 669.01 362.37 669.01",
    fill: "#0e3a5a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.14,670.28v1.27h2.36v2.36h1.18v1.09h-2.36v1.27h-1.18v-1.27h-1.11l-.07-.07v-1.02h2.45v-1.27h-2.38l-.07-.07v-1.11h-1.27v1.27h1.18v1.09h-1.18v1.18h-1.18v1.27h-1.02l-.07-.07v-1.2h-1.2l-.07-.07v-1.02h2.45v-2.45h-1.18v-3.53h1.09v1.18h1.27v-1.18h2.36v1.09h-1.27v1.27h1.27v-1.18h2.45v-1.18h2.27v1.09h-1.18v1.27h-3.54Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "394.49 644 394.49 645.17 395.67 645.17 395.67 646.35 396.85 646.35 396.85 647.53 394.49 647.53 394.49 648.71 392.14 648.71 392.14 649.98 393.31 649.98 393.31 651.15 394.49 651.15 394.49 652.33 389.69 652.33 389.69 653.51 388.6 653.51 388.6 651.15 390.96 651.15 390.96 649.89 389.78 649.89 389.78 648.8 390.96 648.8 390.96 646.35 393.41 646.35 393.41 644 394.49 644",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "387.33 657.14 387.33 658.31 388.6 658.31 388.6 657.14 390.87 657.14 390.87 658.31 389.69 658.31 389.69 659.58 390.96 659.58 390.96 658.31 392.14 658.31 392.14 660.76 393.31 660.76 393.31 661.85 390.96 661.85 390.96 660.67 389.69 660.67 389.69 661.94 390.87 661.94 390.87 663.03 383.8 663.03 383.8 661.94 388.6 661.94 388.6 659.49 387.33 659.49 387.33 660.67 386.16 660.67 386.16 658.31 384.98 658.31 384.98 657.14 387.33 657.14",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.81,651.15v2.45h1.22v-1.16s.06-.07.05-.11h1.13s.05.1.05.11v1.16h1.27v-1.27h1.13v-1.18h1.09v1.18h1.18v1.18h-1.18v2.36h-1.13v1.11l-.07.07h-2.29v-1.09h1.27v-1.27h-2.54v1.11l-.07.07h-1.02v-1.18h-1.18v-2.36h-1.18v-1.18h2.27Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.73,640.37v1.27h1.27v-1.16s.06-.07.05-.11h1.13v1.27h1.18v1.18h1.27v-1.11l.07-.07h1.02v1.18h2.45v1.09h-1.27v1.18h-1.09v-1.18h-1.27v2.45h-1.09v-1.27h-1.27v-2.36h-1.27v1.18h-1.09v-1.18h-1.27v1.18h-1.09v-2.2l.07-.07h1.11l.05-1.27h1.04,0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "401.65 649.98 401.65 652.33 402.83 652.33 402.83 653.51 401.65 653.51 401.65 658.31 399.3 658.31 399.3 659.49 398.12 659.49 398.12 657.14 399.39 657.14 399.39 655.87 398.12 655.87 398.12 653.6 400.56 653.6 400.56 652.33 399.39 652.33 399.39 651.15 400.56 651.15 400.56 649.98 401.65 649.98",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "390.87 636.84 390.87 638.01 392.14 638.01 392.14 636.84 393.31 636.84 393.31 639.1 392.14 639.1 392.14 645.08 390.96 645.08 390.96 642.73 389.69 642.73 389.69 643.9 387.42 643.9 387.42 642.82 388.6 642.82 388.6 640.37 389.69 640.37 389.69 641.64 390.96 641.64 390.96 640.37 389.78 640.37 389.78 636.9 389.85 636.84 390.87 636.84",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "398.12 670.28 398.12 673.9 399.3 673.9 399.3 677.44 398.12 677.44 398.12 678.61 396.94 678.61 396.94 677.44 395.76 677.44 395.76 676.21 396.94 676.21 396.94 673.81 395.76 673.81 395.76 671.55 396.94 671.55 396.94 670.28 398.12 670.28",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "380.17 636.84 380.17 638.01 381.44 638.01 381.44 636.9 381.51 636.84 383.71 636.84 383.71 639.19 384.89 639.19 384.89 641.55 383.8 641.55 383.8 640.37 382.6 640.37 382.53 640.44 382.53 641.55 381.44 641.55 381.44 639.1 379 639.1 379 636.9 379.06 636.84 380.17 636.84",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.71,646.35v1.27h2.45v1.18h1.18v4.71h-1.18v-2.45h-1.18v-2.36h-2.36v-2.24s.06-.07.05-.11h1.04,0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "400.47 645.17 400.47 649.89 399.3 649.89 399.3 651.06 398.12 651.06 398.12 649.89 396.94 649.89 396.94 647.62 398.12 647.62 398.12 648.8 399.39 648.8 399.39 647.53 398.12 647.53 398.12 646.35 399.39 646.35 399.39 645.17 400.47 645.17",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "384.89 664.3 384.89 665.56 387.42 665.56 387.42 664.3 389.69 664.3 389.69 665.47 388.51 665.47 388.51 666.65 387.33 666.65 387.33 667.83 386.16 667.83 386.16 666.65 384.89 666.65 384.89 667.83 383.8 667.83 383.8 664.3 384.89 664.3",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "405.28 647.62 405.28 648.8 406.55 648.8 406.55 647.62 407.63 647.62 407.63 649.89 405.28 649.89 405.28 651.06 404.1 651.06 404.1 649.89 402.92 649.89 402.92 648.71 401.74 648.71 401.74 647.62 405.28 647.62",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.1,672.72v3.53h-3.53v-3.53h3.53ZM402.92,673.81h-1.27v1.27h1.27v-1.27Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.14,664.3v-1.18h1.27v-1.18h2.27v4.71h-1.09v-1.18h-1.18v-1.18h-1.27v1.18h-1.18v-1.18h1.18Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "394.49 657.14 394.49 658.31 395.67 658.31 395.67 659.58 398.12 659.58 398.12 660.67 396.85 660.67 396.85 661.85 395.76 661.85 395.76 660.67 393.41 660.67 393.41 657.14 394.49 657.14",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "394.49 653.6 394.49 654.78 395.76 654.78 395.76 653.6 396.85 653.6 396.85 655.87 395.67 655.87 395.67 657.05 394.58 657.05 394.58 655.87 392.14 655.87 392.14 653.6 394.49 653.6",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "365.81 655.96 365.81 657.14 366.99 657.14 366.99 658.31 365.81 658.31 365.81 660.6 365.74 660.67 362.37 660.67 362.37 659.58 364.72 659.58 364.72 658.31 363.54 658.31 363.54 657.14 364.72 657.14 364.72 655.96 365.81 655.96",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "369.43 660.76 369.43 661.78 369.37 661.85 368.26 661.85 368.26 663.12 369.43 663.12 369.43 664.23 369.37 664.3 368.26 664.3 368.26 665.41 368.19 665.47 367.1 665.47 367.03 665.41 367.03 663.03 365.9 663.03 365.9 661.94 367.03 661.94 367.03 660.76 369.43 660.76",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "387.33 644 387.33 646.35 388.51 646.35 388.51 648.71 387.42 648.71 387.42 647.53 386.16 647.53 386.16 646.35 384.98 646.35 384.98 645.17 386.16 645.17 386.16 644 387.33 644",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "388.51 636.84 388.51 640.37 387.42 640.37 387.42 639.1 386.16 639.1 386.16 637.92 384.98 637.92 384.98 636.9 385.04 636.84 388.51 636.84",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "400.47 659.58 400.47 660.76 401.74 660.76 401.74 659.58 402.83 659.58 402.83 661.85 401.65 661.85 401.65 663.03 400.56 663.03 400.56 661.85 399.39 661.85 399.39 659.58 400.47 659.58",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "386.16 671.55 386.16 673.81 383.87 673.81 383.8 673.74 383.8 672.63 382.69 672.63 382.62 672.57 382.62 671.55 386.16 671.55",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "404.1 677.53 404.1 679.79 401.65 679.79 401.65 680.9 401.58 680.97 400.56 680.97 400.56 678.71 402.92 678.71 402.92 677.53 404.1 677.53",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.24,640.37h1.1s.08.1.08.12v1.06h-1.18v-1.18c-.35,0-.83-.04-1.16,0-.07,0-.12,0-.16.07v1.11h-1.09v-2.29l.07-.07h1.11v-1.11l.07-.07h1.09c.06.04.06.09.07.16.07.62,0,1.54,0,2.2h0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.12,664.3h-1.18v-2.36h1.18v2.36h1.18v3.53h-2.36v-1.09h1.18v-2.45h0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "374.24 675.08 374.24 676.21 375.35 676.21 375.42 676.28 375.42 677.37 375.35 677.44 373.08 677.44 373.01 677.37 373.01 675.08 374.24 675.08",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "405.28 644 405.28 645.08 404.1 645.08 404.1 646.35 402.92 646.35 402.92 644 405.28 644",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "406.46 675.08 406.46 676.21 407.57 676.21 407.63 676.28 407.63 677.37 407.57 677.44 405.37 677.44 405.37 675.08 406.46 675.08",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "396.85 634.48 396.85 636.75 395.76 636.75 395.76 635.57 394.58 635.57 394.58 634.55 394.65 634.48 396.85 634.48",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.53,676.21v1.22h-2.24s-.07-.06-.11-.05v-1.13s.1-.05.11-.05h2.24Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "370.61 658.31 370.61 659.42 370.54 659.49 368.26 659.49 368.26 658.31 370.61 658.31",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 395.76,
    y: 639.19,
    width: 1.09,
    height: 2.36,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 392.14,
    y: 666.74,
    width: 2.36,
    height: 1.09,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 388.6,
    y: 654.78,
    width: 2.27,
    height: 1.09,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "389.69 634.48 389.69 636.75 388.6 636.75 388.6 634.55 388.67 634.48 389.69 634.48",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.94,
    y: 652.33,
    width: 1.18,
    height: 1.18,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 368.26,
    y: 651.15,
    width: 1.18,
    height: 1.18,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 384.98,
    y: 669.1,
    width: 1.18,
    height: 1.18,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.33,640.37v1.18h-1.18v-1.06l.11-.11h1.07Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "404.1 680.97 404.1 679.84 405.21 679.84 405.28 679.91 405.28 680.9 405.21 680.97 404.1 680.97",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "390.87 676.21 390.87 677.44 389.85 677.44 389.78 677.37 389.78 676.28 389.85 676.21 390.87 676.21",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 404.1,
    y: 655.96,
    width: 1.18,
    height: 1.09,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 399.39,
    y: 663.12,
    width: 1.09,
    height: 1.18,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 393.41,
    y: 640.37,
    width: 1.09,
    height: 1.18,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 389.78,
    y: 645.17,
    width: 1.09,
    height: 1.18,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 402.92,
    y: 654.78,
    width: 1.18,
    height: 1.09,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 405.37,
    y: 646.35,
    width: 1.09,
    height: 1.18,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "365.81 670.28 365.81 671.39 365.74 671.46 364.72 671.46 364.72 670.28 365.81 670.28",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "376.55 639.19 376.55 640.37 375.46 640.37 375.46 639.26 375.53 639.19 376.55 639.19",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "369.43 645.08 368.26 645.08 368.26 644 369.37 644 369.43 644.06 369.43 645.08",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "375.42 645.08 374.24 645.08 374.24 644 375.35 644 375.42 644.06 375.42 645.08",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "380.17 655.96 380.17 657.05 379.06 657.05 379 656.98 379 655.96 380.17 655.96",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "378.9 645.17 378.9 646.35 377.82 646.35 377.82 645.24 377.89 645.17 378.9 645.17",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "369.43 665.56 369.43 666.58 369.37 666.65 368.26 666.65 368.26 665.56 369.43 665.56",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.35,635.66v1.09h-1.18v-1.04s.1-.05.11-.05h1.07Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 394.58,
    y: 641.64,
    width: 1.09,
    height: 1.09,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 387.42,
    y: 655.96,
    width: 1.09,
    height: 1.09,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 394.58,
    y: 648.8,
    width: 1.09,
    height: 1.09,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 395.76,
    y: 678.71,
    width: 1.09,
    height: 1.09,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "372.92 677.53 372.92 678.61 371.9 678.61 371.84 678.55 371.84 677.53 372.92 677.53",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.81,640.37h-5.89v-5.89h5.82l.07.07v5.82ZM407.72,635.57h-3.63v3.63h3.63v-3.63Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.26,640.37h-5.89v-5.89h5.82l.07.07v5.82ZM367.03,635.57h-3.58v3.63h3.58v-3.63Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.26,675.08v5.82l-.07.07h-5.82v-5.89h5.89ZM367.03,676.26h-3.58v3.58h3.58v-3.58Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "408.81 671.55 408.81 672.57 408.74 672.63 407.72 672.63 407.72 671.55 408.81 671.55",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 401.65,
    y: 673.81,
    width: 1.27,
    height: 1.27,
    fill: "#0e3a5a"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 404.1,
    y: 635.57,
    width: 3.63,
    height: 3.63,
    fill: "#0e3a5a"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 363.45,
    y: 635.57,
    width: 3.58,
    height: 3.63,
    fill: "#0e3a5a"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 363.45,
    y: 676.26,
    width: 3.58,
    height: 3.58,
    fill: "#0e3a5a"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M365.71,734.52v1.2h-1.2v-1.2h1.2Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.33,728.63v1.2h-1.15v-1.2h1.15Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.1,718.96v1.2c-.3,0-.81.05-1.07,0-.06-.01-.09-.02-.12-.07v-1.12h1.2-.01Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.2,720.16h1.15v-1.2h1.2v1.2h1.2v1.15h1.15v-1.15h1.2v1.2h-1.15v1.15h1.15v1.2h-1.2v-1.2h-1.15v1.4h1.2v.92l-.07.07h-1.12v1.35h1.12l.07.07v2.32h1.15v1.2h-1.12l-.07-.07v-1.12h-2.34v1.15h1.12l.07.07v1.12h1.2v1.2h1.15v-1.2h2.39v1.12c-.04.07-.1.07-.17.08-.62.07-1.56,0-2.22,0v1.15h2.54v-1.15h2.19v2.34h-7.08v-1.15h-2.32l-.07-.07v-1.12h-2.34v-1.2h-1.2v-1.12l.07-.07h3.47v-2.34h1.2v-1.4h-1.2v-3.47c.04-.07.1-.07.17-.08.62-.07,1.56,0,2.22,0v-1.15h-3.54v1.15h-1.4v2.39h-1v-1.2h-2.34v-2.39h1.15v-1.15h1v1.15h2.59v-1.15h-.02ZM388.54,730.98h-1.15v1.2h1.15v-1.2Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.18,716.62v-1.2h1.15v1.2h-1.15Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.72,704.6v3.54h-1.2v3.54h-1.2v-1.2h-1.15v1.4h1.15v1h-1.15v1.15h-2.39v-.92l.07-.07h1.12v-2.54h1.2v-2.34h1.15v-2.39h1.2v-1.15h1.2v-.02Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.72,704.6v-1.2h1.2v1.2h1.15v1.15h1.4v-1.15h1v1.15h1.15v1.2h-1.15v3.54h-1v-2.34h-1.4v-1.2h-1.2v-2.34h-1.15Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.33,704.6v-1.2h1.2v1.2h-1.2Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.18,704.6h-1.2v-3.59h1.2v-1.15h1.15v2.14h-1.15v2.59h1.15v1.15h-1.15v-1.15h0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.1,718.96h2.54v2.32l.07.07h.92v-3.54h2.59v2.27l-.07.07h-1.12v2.34h1.12c.07.04.07.1.08.17.02.2.03.92,0,1.1-.01.06-.02.09-.07.12h-1.12v1h1.2v2.54h-1.4v-1.2h-2.34v-2.54h1.15v-1.2h-1.15v-1.12l-.07-.07h-1.12v-1.15h-1.2v-1.2h0v.02Z",
    fill: "#0e3a5a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.2,720.16v-1.2h-1.4v-1.2h-2.34v-2.54h1.35v1.4h3.54v1.12l.07.07h2.32v1.15h2.34v1.2h-1.2v1.15h-1.15v-1.15h-1.2v-1.2h-1.2v1.2h-1.15.02Z",
    fill: "#0e3a5a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.18,728.63v1.2h1.15v-1.2h1.2v1.2h1.2v1.15h-4.94v-2.34h1.4-.01Z",
    fill: "#0e3a5a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.74,716.62h4.56l.17-.08v-1.12h-2.39v-2.54h2.32l.07-.07v-1.12h2.34v-1.2h-1.2v-1.2h-1.15v-1.15h-2.32l-.07-.07v-1.12h-1.15v-1.2h1.15v-1.15h1.2v-2.59h1.2v-2.14h-1v1.15h-1.32l-.07.07v2.32h-1.15v-2.54h1.15v-1.2h1.2v-1h-1.2v-1.35h2.54v2.27l.07.07h1.12v1.12l.07.07h.92v-2.19h-1.2v-1.35h3.74v1.15h1.2v1.4h-1.15v-1.2h-1.2v4.54h1.15v1.4h-1.15v2.34h-2.39v1.2h1.2v1.2h2.34v1.15h-1.15v1.2h1.15v1.35h-1.15v-1.15h-1.2v1.15h-2.32l-.07.07v.92h2.39v3.74h-1.12l-.07.07v2.32h1v-1.2h1.4v2.39h1.15v1.15h-1.15v1.2h1.2v-1.2h2.34v-4.69h1.12l.07-.07v-1.12h-1.2v-2.39h-1.2v1.2h-1.2v1.12l.07.07h1.12v1.15h-2.34v-2.54h1.2v-1.2h1.15v-1.15h1.12l.07-.07v-1.12h1.2c0-.27.01-.55,0-.82,0-.08-.1-.37.02-.37h1.12v-1.15h1.2v-1.2h-2.34v-1.2h3.69v1.12l.07.07h.92v-1.2h2.59v2.34h-1.2v1.2h-1.2v1.4h-1.2v1.15h-1.35v-1.15h-2.39v1.15h-1.15v1h2.34v1.2h1.2v-1.2h2.34v-1.15h1.2v-1.2h1.4v1.35h-1.2v1h1.12l.07.07v2.44l-.07.07h-2.44l-.07-.07v-1.12h-2.14v1.2h1.15v1.15h-1.35v-1.15h-1.2v2.34h-1.2v1.12s.07.06.12.07c.26.05.77,0,1.07,0v1.15h-1.12l-.07.07v2.52h-1.15v1.15h-1.2v-1.15h-1.2v2.14h1.2v1.2h1.2v-1.2h1.15v1.4h-1.15v2.34h-1.2v2.39h1.2v1.15h-1.2v-1.15h-1.15v-3.54h1.15v-1.2h-1.2v1.2h-1.15v-2.39h-1.2v2.39h1.2v2.34h-1.2v1.2h2.34v1.12l.07.07h1.12v1.15h1.12l.07.07v1.12h2.34v-1.12l.07-.07h1.12v-1.15h1.35v1.15h-1.15v3.54h1.15v1.2h2.39v1.4h1.2v1.15h-2.59v-1.15h-1.15v-1.2h-1v2.39h1.15v2.34h-2.54v-2.39h-1.12l-.07.07v1.12h-2.34v2.39h1.12l.07-.07v-1.12h2.34c0,.3-.05.81,0,1.07.01.06.02.09.07.12h1.32v1.15h-6.08v-1.12l-.07-.07h-2.32v1.2h-1.4v-2.34h-1.15v-1.2h1.15v-1.2h-2.14v1.2h-1.4v-1.15h1.2v-2.59h1.2v-2.34h1.35v1.15h1.2v2.59h-1.2v1.12l.07.07h1.12v1.15h1.2v-1.15h1.12c.07-.04.07-.1.08-.17.08-.66.08-2.59,0-3.25,0-.07,0-.13-.08-.17h-1.12v-1.12l-.07-.07h-1.32v-1.15h-3.34v1.15h-1.32l-.07.07v1.12h-1.12l-.07.07v.92h1.2v1.4h-3.54v-1.4h1.2v-1h-1.2v-3.74h-1.12l-.07.07v6.06h-1.15v-3.52l-.07-.07h-2.24l-.07.07v.92h1.2v2.59h-1.2v1.15h-2.34v1.2h1.15v1.2h-1.15v1.2h2.34v1.15h-4.89v-1.15h1.15v-3.54h1.2v-1.2h-3.54v-1.2h-1.2v-1.4h1.12l.07.07v1.12h1.2v-2.34h1.15v1.15h1.32l.07.07v1.12h1v-2.12l-.07-.07h-1.12v-1.15h-2.34v-1.4h1.15v-1.15h1.2v-1.2h-1.12l-.07-.07v-1.12h1.2v-3.74h1.35v1.32l.07.07h.92v-1.4h1.4v1.4h1.2v-2.39h-2.59v-1.2h-2.14v1.2h-1.4v-1.2h-1.12l-.07.07v2.12h1.2v2.54h-1.15v-2.34h-1.2v-1.2h-2.39v2.39h-1.15v-1.2h-1.4v-1.2h-3.34v1.2h-1.4v-1.32l.07-.07h1.12v-.92l-.07-.07h-2.24l-.07.07v3.52h-1.15v-2.39h-1.2v2.39h-1.2v1.15h-1.15v-1.15h1.15v-3.59h-1.12l-.07.07v1.12h-1.15v-2.54h1.2v-2.34h3.54v1.15h-1.2v1.2h2.39v-2.32l-.07-.07h-1.12v-1.15h1.12l.07-.07v-3.47h2.34v-1.2h-1.2v-1.32l.07-.07h2.32v-1.15h1.15v-2.39h-3.47l-.07.07v1.12h1.4v1.35h-2.54v-2.54h1.15v-1.15h2.32l.07-.07v-1.12h1.35v2.34h1v-2.34h1.4v2.34h-1.2v2.54h-1.12l-.07.07v.92h2.39v-1.15h1.15v-1h-1.15v-1.4h1.15v1.2h1.2v-3.54h1.2v-3.54h1.15v2.34h1.2v1.2h-1.2v1.15h-1.15v1.2h1.12c.13,0,.02.29.02.37,0,.27.01.55,0,.82h1.2v1.35h-2.34v1h2.34v3.74h-1.15v-2.34h-2.39v1.2h-1.2v-1.2h-1.15v1.2h-1.2v1.2h1.2v1.15h1.15v-1.15h1.2v1.15h-1.2v3.54h-1.15v1.2h1.15v1.2h1.2v-1.2h1.2v-2.32l-.07-.07h-1.12v-1.15h1.2v-1.2h1.15v1.12l.07.07h1.12v-2.34h1.4v2.34h.92l.07-.07v-1.12h1.35v1.2h2.39v1.15h-2.59v-1.15h-1v1.15h-1.15v2.39h2.34v1.2h1v-2.39h1.4v-1.15h3.54v1.15c-.66,0-1.6-.07-2.22,0-.07,0-.13,0-.17.08v3.47h1.2v1.4h-1.2v2.34h-3.47l-.07.07v1.12h1.2v1.2h2.34v1.12l.07.07h2.32v1.15h7.08v-2.34h-2.19v1.15h-2.54v-1.15c.66,0,1.6.07,2.22,0,.07,0,.13,0,.17-.08v-1.12h-2.39v1.2h-1.15v-1.2h-1.2v-1.12l-.07-.07h-1.12v-1.15h2.34v1.12l.07.07h1.12v-1.2h-1.15v-2.32l-.07-.07h-1.12v-1.35h1.12l.07-.07v-.92h-1.2v-1.4h1.15v1.2h1.2v-1.2h-1.15v-1.15h1.15v-1.2h1.4v4.74h2.34v1.15h1v-1.15h1.4v-1h-2.52l-.07-.07v-1.32h-1.15v-1.15h1.15v-1.2h-1.15v-2.32l-.07-.07h-4.66v-1.15h-1.2v-1.2h-2.34v-1.2h-1.4v-1.35h1.32l.07-.07v-.92h-1.4v-1.4h1.32l.07.07v1.12h1.15v1.12l.07.07h3.47v1.35h-2.34v1h1.2v1.4h0v.05ZM396.82,703.41h-1v2.34h1v-2.34ZM394.47,704.6h-1v1.15h1v-1.15ZM395.62,705.75h-.92l-.07.07v1.12h1v-1.2h0ZM408.83,708.14h-1v1.12l.07.07h.92v-1.2h0ZM406.49,710.49h-1v1.2h1v-1.2ZM377.72,711.88h-1.2v1h1.12l.07-.07v-.92h.01ZM376.53,714.23h-1.2v1h1.2v-1ZM372.79,715.42h-2.19v1.12l.07.07h2.12v-1.2h0ZM370.44,716.62h-1v1.2h.92l.07-.07v-1.12h0ZM395.62,716.62h-1v1.12l.07.07h.92v-1.2h0ZM369.25,718.96v-1.12c-.34-.16-.83-.06-1.2-.02v1.15h1.2ZM372.79,717.77h-2.12l-.07.07v1.12h1.2v4.94h-1.2v.92l.07.07h3.52v-1h-1.4v-2.54h1.32l.07-.07v-1.12h-1.4v-2.39h0ZM370.44,720.16h-2.39v1.15c.13,0,.25.04.37.05.47.03,1.4.05,1.85,0,.07,0,.13,0,.17-.08v-1.12h0ZM380.07,721.31h-1.12l-.07.07v1.12h1.2v-1.2h-.01ZM369.25,722.5h-.97s-.12.05-.16.06c-.01.01-.06.15-.06.16v.97h1.2v-1.2h-.01ZM364.51,723.9h-1.2v1h1.2v-1ZM392.08,725.04h-1.12l-.07.07v.92h1.2v-1h-.01ZM395.62,726.24h-3.54v1h1.4v2.59h1.15v1.15h1v-4.74h0ZM382.46,730.98h-1v1.2h.92l.07-.07v-1.12h0ZM383.61,733.32h-.92l-.07.07v1.12h1v-1.2h0ZM386.2,735.71v-2.32l-.07-.07h-1.12v1.2h-1.2v1.2h2.39ZM390.93,738.06v-.92l-.07-.07h-1.12v1h1.2-.01ZM404.1,737.06h-3.54v3.59h3.54v-3.59ZM396.82,742.99h-1v1.2h1v-1.2Z",
    fill: "#0e3a5a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.33,716.62v1.15h-1.15v-1.15h1.15Z",
    fill: "#0e3a5a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.18,708.14v-1.2h-2.59v-1.2h-1.15v-4.89h1.15v-1h-1.15v-2.54h1.35v2.34h2.39v-1.2h1.15v-1.15h2.39v2.34h1.12l.07-.07v-1.12h1.15v-1.15h1.4v3.54h.92l.07-.07v-1.12h1.35v2.34h3.59v-.92l-.07-.07h-2.52v-1.35h1.4v-1h-2.59v-1.35h2.59v1.15h1.2v-1.15h1.15v1.35h-1.2v2.12l.07.07h1.12v-1.2h1.2v-2.34h1.15v2.54h-1.15v1.15h-1.2v1h1.12c.07.04.07.1.08.17.08.69,0,1.69,0,2.42h1.15v1.15h-1.15v-1.15h-1.2v1.15h-1.15v-1.15h1.15v-2.39h-1.12l-.07.07v1.12h-1.15v3.54h1.15v1.2h-2.34v1.15h-1.12l-.07.07v1.12h-1.15c0,.13-.04.25-.05.37-.03.47-.05,1.4,0,1.85,0,.07,0,.13.08.17h1.12v1.35h-2.54v-3.74h-2.34v-1.15h1.15v-1.2h1.4v2.34h1v-3.54h1.15v-1.2h-1.15v-1.15h-1v1.15h-1.4v-1.15h-1.15v-1.2h-1.2v1.2h-1.2v-1.2h-1.2v1.2h-1.15v-2.59h1.15v-2.14h-1.15v1.15h-1.2v3.59h1.2v1.15h1.15v2.39h-1.15v.03ZM376.53,698.67h-1.2v1h1.2v-1ZM380.07,701.01h-1.12l-.07.07v2.12h3.59v-.92l-.07-.07h-2.32v-1.2h0ZM384.8,703.41h-2.19v1.12l.07.07h1.12v1.15h1v-2.34ZM372.79,704.6h-1v1.15h1v-1.15ZM384.8,706.95h-1v1.2h1v-1.2Z",
    fill: "#0e3a5a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.53,704.6v1.15h-1.2v-1.15h1.2Z",
    fill: "#0e3a5a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.51,734.52v-2.34h2.34v1.15h-1.15v1.2h-1.2.01Z",
    fill: "#0e3a5a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.51,734.52v1.2h1.2v-1.2h1.15v1.2h3.74v1.12l.07.07h3.52v-1.2h3.54v1.35h-3.54v1.2h-1.2v2.39h1.2v-1.4h1.15v1.4h1.2v1.15h-1.2v-1.15h-1.15v1.2h1.15v2.34h1.2v1.15h-1.12l-.07.07v1.12h-3.74v-1.15h1.2v-1.2h-1.12l-.07-.07v-1.12h-1.15v-1.15h1.15v-3.59h-1.15v-1.12l-.07-.07h-3.47v-1.15h-1.2v1.15h-2.39v-2.47s.07-.06.12-.07c.26-.05.77,0,1.07,0h-.02Z",
    fill: "#0e3a5a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.45,746.53h-8.48v-8.48h8.4l.07.07v8.4h.01ZM368.05,739.45h-5.93v5.86l.07.07h5.86v-5.93Z",
    fill: "#0e3a5a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.23,697.32v8.43h-8.48v-8.43h8.48ZM408.83,698.67h-5.93v5.86l.07.07h5.86v-5.93Z",
    fill: "#0e3a5a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.45,697.32v8.43h-8.48v-8.43h8.48ZM368.05,698.67h-5.93v5.86l.07.07h5.86v-5.93Z",
    fill: "#0e3a5a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.05,729.83v-1.2h1.4v1.2h.92l.07-.07v-2.52h1.35v2.54h-1.12l-.07.07v2.32h-3.69v-1.2h-2.39v-1.15c1.18-.02,2.36.03,3.54,0v1.15h1.2v-1.12c-.34-.18-.83-.03-1.2-.02h-.01Z",
    fill: "#0e3a5a"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "362.12 709.34 362.12 712.8 362.19 712.88 363.31 712.88 363.31 711.68 364.51 711.68 364.51 713.03 363.39 713.03 363.31 713.1 363.31 714.03 365.63 714.03 365.71 714.1 365.71 715.42 363.31 715.42 363.31 714.23 362.19 714.23 362.12 714.3 362.12 716.62 360.97 716.62 360.97 709.34 362.12 709.34",
    fill: "#0e3a5a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.23,732.17v6.08h-2.59v-1.2h-1.15v-1.35h1.15v-2.34h1.2v-1.2h1.4-.01ZM408.83,735.91h-1v1h1v-1Z",
    fill: "#0e3a5a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.2,744.19v1.2h2.34v1.15h-3.74v-2.34h-1.12c-.07-.04-.07-.1-.08-.17-.02-.17-.02-.75,0-.9.01-.06.02-.09.07-.12h1.12v-1.15h3.74v2.34h-2.34v-1.2h-1.2v1.2h1.21Z",
    fill: "#0e3a5a"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "406.64 727.24 406.64 728.63 405.49 728.63 405.49 730.98 404.1 730.98 404.1 733.32 402.95 733.32 402.95 730.98 401.75 730.98 401.75 729.83 404.1 729.83 404.1 728.63 405.29 728.63 405.29 727.24 406.64 727.24",
    fill: "#0e3a5a"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "365.71 706.95 365.71 710.49 363.31 710.49 363.31 709.34 364.51 709.34 364.51 706.95 365.71 706.95",
    fill: "#0e3a5a"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "402.9 708.14 402.9 710.49 401.75 710.49 401.75 709.36 401.68 709.29 399.41 709.29 399.41 708.14 402.9 708.14",
    fill: "#0e3a5a"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "372.99 732.17 372.99 733.32 371.86 733.32 371.79 733.4 371.79 734.52 372.99 734.52 372.99 735.91 371.59 735.91 371.59 734.52 370.44 734.52 370.44 733.37 371.59 733.37 371.59 732.17 372.99 732.17",
    fill: "#0e3a5a"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "409.03 744.19 409.03 746.53 407.64 746.53 407.64 744.19 408.83 744.19 408.83 742.99 410.16 742.99 410.23 743.07 410.23 744.12 410.16 744.19 409.03 744.19",
    fill: "#0e3a5a"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "410.23 728.63 410.23 730.98 408.83 730.98 408.83 729.78 407.64 729.78 407.64 728.63 410.23 728.63",
    fill: "#0e3a5a"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "362.12 729.83 362.12 730.98 363.31 730.98 363.31 732.17 360.97 732.17 360.97 729.83 362.12 729.83",
    fill: "#0e3a5a"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "388.54 708.14 388.54 709.34 389.74 709.34 389.74 710.49 387.39 710.49 387.39 708.14 388.54 708.14",
    fill: "#0e3a5a"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 390.93,
    y: 709.34,
    width: 2.54,
    height: 1.15,
    fill: "#0e3a5a"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 363.31,
    y: 716.62,
    width: 2.39,
    height: 1.15,
    fill: "#0e3a5a"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 389.74,
    y: 744.19,
    width: 1.15,
    height: 2.34,
    fill: "#0e3a5a"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 374.18,
    y: 733.37,
    width: 2.34,
    height: 1.15,
    fill: "#0e3a5a"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 399.41,
    y: 704.6,
    width: 1.15,
    height: 2.34,
    fill: "#0e3a5a"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 376.53,
    y: 732.17,
    width: 2.34,
    height: 1.15,
    fill: "#0e3a5a"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 377.72,
    y: 742.99,
    width: 1.15,
    height: 2.34,
    fill: "#0e3a5a"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "369.45 706.95 369.45 708.07 369.37 708.14 368.12 708.14 368.05 708.07 368.05 706.95 369.45 706.95",
    fill: "#0e3a5a"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 368.05,
    y: 733.37,
    width: 1.4,
    height: 1.15,
    fill: "#0e3a5a"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360.97,
    y: 727.24,
    width: 1.15,
    height: 1.4,
    fill: "#0e3a5a"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360.97,
    y: 735.71,
    width: 1.15,
    height: 1.35,
    fill: "#0e3a5a"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 399.41,
    y: 720.16,
    width: 1.15,
    height: 1.15,
    fill: "#0e3a5a"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360.97,
    y: 733.37,
    width: 1.15,
    height: 1.15,
    fill: "#0e3a5a"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 389.74,
    y: 708.14,
    width: 1.15,
    height: 1.15,
    fill: "#0e3a5a"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 389.74,
    y: 741.85,
    width: 1.15,
    height: 1.15,
    fill: "#0e3a5a"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "372.79 717.77 372.79 720.16 374.18 720.16 374.18 721.28 374.11 721.36 372.79 721.36 372.79 723.9 374.18 723.9 374.18 724.9 370.67 724.9 370.59 724.82 370.59 723.9 371.79 723.9 371.79 718.96 370.59 718.96 370.59 717.84 370.67 717.77 372.79 717.77",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.1,737.06v3.59h-3.54v-3.59h3.54ZM402.9,738.06h-1.15v1.4h1.15v-1.4Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "395.62 726.24 395.62 730.98 394.62 730.98 394.62 729.83 393.48 729.83 393.48 727.24 392.08 727.24 392.08 726.24 395.62 726.24",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "386.2 735.71 383.8 735.71 383.8 734.52 385 734.52 385 733.32 386.12 733.32 386.2 733.4 386.2 735.71",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.44,720.16v1.12c-.04.07-.1.07-.17.08-.45.05-1.38.03-1.85,0-.13,0-.25-.06-.37-.05v-1.15h2.39Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "372.79 715.42 372.79 716.62 370.67 716.62 370.59 716.54 370.59 715.42 372.79 715.42",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 395.82,
    y: 703.41,
    width: 1,
    height: 2.34,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "380.07 721.31 380.07 722.5 378.87 722.5 378.87 721.38 378.94 721.31 380.07 721.31",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.25,718.96h-1.2v-1.15c.37-.03.86-.14,1.2.02v1.12h0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.25,722.5v1.2h-1.2v-.97s.05-.15.06-.16c.04-.01.13-.06.16-.06h.98Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 363.31,
    y: 723.9,
    width: 1.2,
    height: 1,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 375.33,
    y: 714.23,
    width: 1.2,
    height: 1,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 405.49,
    y: 710.49,
    width: 1,
    height: 1.2,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 395.82,
    y: 742.99,
    width: 1,
    height: 1.2,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "395.62 716.62 395.62 717.82 394.7 717.82 394.62 717.74 394.62 716.62 395.62 716.62",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "370.44 716.62 370.44 717.74 370.37 717.82 369.45 717.82 369.45 716.62 370.44 716.62",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "392.08 725.04 392.08 726.04 390.89 726.04 390.89 725.12 390.96 725.04 392.08 725.04",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "383.61 733.32 383.61 734.52 382.61 734.52 382.61 733.4 382.68 733.32 383.61 733.32",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "390.93 738.06 389.74 738.06 389.74 737.06 390.86 737.06 390.93 737.14 390.93 738.06",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "377.72 711.88 377.72 712.8 377.65 712.88 376.53 712.88 376.53 711.88 377.72 711.88",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "408.83 708.14 408.83 709.34 407.91 709.34 407.84 709.26 407.84 708.14 408.83 708.14",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "395.62 705.75 395.62 706.95 394.62 706.95 394.62 705.82 394.7 705.75 395.62 705.75",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "382.46 730.98 382.46 732.1 382.38 732.17 381.46 732.17 381.46 730.98 382.46 730.98",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 393.48,
    y: 704.6,
    width: 1,
    height: 1.15,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "380.07 701.01 380.07 702.21 382.38 702.21 382.46 702.28 382.46 703.21 378.87 703.21 378.87 701.09 378.94 701.01 380.07 701.01",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "384.8 703.41 384.8 705.75 383.81 705.75 383.81 704.6 382.68 704.6 382.61 704.53 382.61 703.41 384.8 703.41",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 383.81,
    y: 706.95,
    width: 1,
    height: 1.2,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 375.33,
    y: 698.67,
    width: 1.2,
    height: 1,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 371.79,
    y: 704.6,
    width: 1,
    height: 1.15,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.05,739.45v5.93h-5.86l-.07-.07v-5.86h5.93ZM366.85,740.65h-3.54v3.47l.07.07h3.47v-3.54h0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.83,698.67v5.93h-5.86l-.07-.07v-5.86h5.93ZM407.84,699.67h-3.74v3.74h3.74v-3.74Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.05,698.67v5.93h-5.86l-.07-.07v-5.86h5.93ZM366.85,699.67h-3.54v3.74h3.54v-3.74Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 407.84,
    y: 735.91,
    width: 1,
    height: 1,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 387.39,
    y: 730.98,
    width: 1.15,
    height: 1.2,
    fill: "#0e3a5a"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 401.75,
    y: 738.06,
    width: 1.15,
    height: 1.4,
    fill: "#0e3a5a"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "366.85 740.65 366.85 744.19 363.39 744.19 363.31 744.12 363.31 740.65 366.85 740.65",
    fill: "#0e3a5a"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 404.1,
    y: 699.67,
    width: 3.74,
    height: 3.74,
    fill: "#0e3a5a"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 363.31,
    y: 699.67,
    width: 3.54,
    height: 3.74,
    fill: "#0e3a5a"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M61.64,557.5v1.32h-8.08v-10.6h7.85v1.32h-6.26v3.25h5.58v1.29h-5.58v3.42h6.49Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.99,554.2v4.62h-1.53v-4.45c0-1.57-.83-2.35-2.27-2.35-1.62,0-2.67.92-2.67,2.66v4.13h-1.53v-8.02h1.46v1.21c.62-.82,1.7-1.29,3.04-1.29,2.05,0,3.5,1.12,3.5,3.48Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.12,550.79l-3.69,8.02h-1.56l-3.69-8.02h1.59l2.89,6.43,2.96-6.43h1.49Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.29,548.31c0-.53.44-.95,1.03-.95s1.03.41,1.03.92c0,.54-.43.97-1.03.97s-1.03-.41-1.03-.94ZM83.56,550.79h1.53v8.02h-1.53v-8.02Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.52,550.72v1.41c-.13-.01-.24-.01-.35-.01-1.64,0-2.66.95-2.66,2.71v4h-1.53v-8.02h1.46v1.35c.54-.94,1.59-1.42,3.07-1.42Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.54,554.8c0-2.39,1.86-4.09,4.39-4.09s4.37,1.7,4.37,4.09-1.84,4.1-4.37,4.1-4.39-1.71-4.39-4.1ZM100.76,554.8c0-1.71-1.21-2.81-2.83-2.81s-2.85,1.1-2.85,2.81,1.22,2.83,2.85,2.83,2.83-1.12,2.83-2.83Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.41,554.2v4.62h-1.53v-4.45c0-1.57-.83-2.35-2.27-2.35-1.62,0-2.67.92-2.67,2.66v4.13h-1.53v-8.02h1.46v1.21c.62-.82,1.7-1.29,3.04-1.29,2.05,0,3.5,1.12,3.5,3.48Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.24,554.2v4.62h-1.53v-4.45c0-1.57-.79-2.35-2.18-2.35-1.53,0-2.53.92-2.53,2.66v4.13h-1.53v-4.45c0-1.57-.79-2.35-2.18-2.35-1.53,0-2.53.92-2.53,2.66v4.13h-1.53v-8.02h1.46v1.2c.6-.82,1.64-1.27,2.91-1.27s2.37.48,2.93,1.48c.64-.91,1.81-1.48,3.24-1.48,2.05,0,3.45,1.12,3.45,3.48Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.68,555.29h-6.84c.19,1.41,1.38,2.35,3.05,2.35.99,0,1.81-.32,2.43-.97l.84.94c-.76.85-1.92,1.3-3.32,1.3-2.72,0-4.53-1.71-4.53-4.1s1.8-4.09,4.23-4.09,4.17,1.66,4.17,4.13c0,.12-.02.3-.03.44ZM132.85,554.24h5.41c-.16-1.35-1.22-2.3-2.7-2.3s-2.54.94-2.7,2.3Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.83,554.2v4.62h-1.53v-4.45c0-1.57-.83-2.35-2.27-2.35-1.62,0-2.67.92-2.67,2.66v4.13h-1.53v-8.02h1.46v1.21c.62-.82,1.7-1.29,3.04-1.29,2.05,0,3.5,1.12,3.5,3.48Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.4,558.34c-.46.38-1.16.56-1.84.56-1.7,0-2.67-.89-2.67-2.51v-4.4h-1.43v-1.2h1.43v-1.76h1.53v1.76h2.42v1.2h-2.42v4.34c0,.86.48,1.35,1.32,1.35.45,0,.87-.14,1.19-.38l.48,1.04Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.92,553.97v4.84h-1.45v-1.06c-.51.73-1.45,1.15-2.77,1.15-1.91,0-3.12-.97-3.12-2.36,0-1.29.87-2.35,3.39-2.35h2.42v-.29c0-1.23-.75-1.94-2.26-1.94-1,0-2.02.33-2.67.86l-.64-1.09c.87-.67,2.13-1.03,3.48-1.03,2.31,0,3.61,1.06,3.61,3.25ZM164.39,556.36v-1.12h-2.35c-1.51,0-1.94.56-1.94,1.24,0,.8.7,1.3,1.86,1.3s2.05-.5,2.43-1.42Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.75,547.58h1.53v11.23h-1.53v-11.23Z",
    fill: "#fff"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M94.91,779.11l-3.56,9.54h-1.66l-2.75-7.24-2.79,7.24h-1.66l-3.55-9.54h1.64l2.77,7.6,2.88-7.6h1.46l2.83,7.63,2.84-7.63h1.55Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.55,779.11l-3.56,9.54h-1.66l-2.75-7.24-2.79,7.24h-1.66l-3.55-9.54h1.64l2.77,7.6,2.88-7.6h1.46l2.83,7.63,2.84-7.63h1.55Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.19,779.11l-3.56,9.54h-1.66l-2.75-7.24-2.79,7.24h-1.66l-3.55-9.54h1.64l2.77,7.6,2.88-7.6h1.46l2.83,7.63,2.84-7.63h1.55Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.69,787.52c0-.72.56-1.22,1.22-1.22s1.19.5,1.19,1.22-.54,1.24-1.19,1.24-1.22-.52-1.22-1.24Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.26,787.65l.72-1.37c.81.58,2.11.99,3.35.99,1.6,0,2.27-.49,2.27-1.3,0-2.14-6.03-.29-6.03-4.09,0-1.71,1.53-2.86,3.98-2.86,1.24,0,2.65.32,3.48.86l-.74,1.37c-.86-.56-1.82-.76-2.75-.76-1.51,0-2.25.56-2.25,1.31,0,2.25,6.05.41,6.05,4.12,0,1.73-1.58,2.83-4.12,2.83-1.58,0-3.15-.49-3.94-1.12Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.64,779.11l-4.63,10.5c-.85,2.02-1.94,2.65-3.4,2.65-.92,0-1.85-.31-2.45-.88l.74-1.3c.47.45,1.06.7,1.71.7.83,0,1.35-.38,1.82-1.48l.31-.67-4.21-9.53h1.8l3.33,7.63,3.29-7.63h1.69Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.19,783.17v5.49h-1.73v-5.29c0-1.87-.94-2.79-2.57-2.79-1.84,0-3.02,1.1-3.02,3.17v4.92h-1.73v-9.54h1.66v1.44c.7-.97,1.93-1.53,3.44-1.53,2.32,0,3.96,1.33,3.96,4.14Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.64,788.1c-.52.45-1.31.67-2.09.67-1.93,0-3.02-1.06-3.02-2.99v-5.24h-1.62v-1.42h1.62v-2.09h1.73v2.09h2.74v1.42h-2.74v5.17c0,1.03.54,1.6,1.49,1.6.5,0,.99-.16,1.35-.45l.54,1.24Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.94,776.16c0-.63.5-1.13,1.17-1.13s1.17.49,1.17,1.1c0,.65-.49,1.15-1.17,1.15s-1.17-.49-1.17-1.12ZM178.25,779.11h1.73v9.54h-1.73v-9.54Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.56,779.02v1.67c-.14-.02-.27-.02-.4-.02-1.85,0-3.01,1.13-3.01,3.22v4.75h-1.73v-9.54h1.66v1.6c.61-1.12,1.8-1.69,3.48-1.69Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.6,783.89c0-2.84,2.11-4.86,4.97-4.86s4.95,2.02,4.95,4.86-2.09,4.88-4.95,4.88-4.97-2.04-4.97-4.88ZM198.77,783.89c0-2.03-1.37-3.35-3.21-3.35s-3.22,1.31-3.22,3.35,1.39,3.37,3.22,3.37,3.21-1.33,3.21-3.37Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.76,787.52c0-.72.56-1.22,1.22-1.22s1.19.5,1.19,1.22-.54,1.24-1.19,1.24-1.22-.52-1.22-1.24Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.44,783.89c0-2.84,2.11-4.86,5.04-4.86,1.71,0,3.13.7,3.89,2.03l-1.31.85c-.61-.94-1.55-1.37-2.59-1.37-1.87,0-3.28,1.31-3.28,3.35s1.4,3.37,3.28,3.37c1.04,0,1.98-.43,2.59-1.37l1.31.83c-.76,1.33-2.18,2.05-3.89,2.05-2.94,0-5.04-2.04-5.04-4.88Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.46,783.89c0-2.84,2.11-4.86,4.97-4.86s4.95,2.02,4.95,4.86-2.09,4.88-4.95,4.88-4.97-2.04-4.97-4.88ZM226.63,783.89c0-2.03-1.37-3.35-3.21-3.35s-3.22,1.31-3.22,3.35,1.39,3.37,3.22,3.37,3.21-1.33,3.21-3.37Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.63,787.52c0-.72.56-1.22,1.22-1.22s1.19.5,1.19,1.22-.54,1.24-1.19,1.24-1.22-.52-1.22-1.24Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.48,787.23v1.42h-7.99v-1.12l5.64-7h-5.53v-1.42h7.74v1.13l-5.64,6.99h5.78Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.23,782.9v5.76h-1.64v-1.26c-.58.86-1.64,1.37-3.13,1.37-2.16,0-3.53-1.15-3.53-2.81,0-1.53.99-2.79,3.83-2.79h2.74v-.34c0-1.46-.85-2.3-2.56-2.3-1.13,0-2.29.4-3.02,1.03l-.72-1.3c.99-.79,2.41-1.22,3.94-1.22,2.61,0,4.09,1.26,4.09,3.87ZM252.5,785.74v-1.33h-2.66c-1.71,0-2.2.67-2.2,1.48,0,.95.79,1.55,2.11,1.55s2.32-.59,2.75-1.69Z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGaugeBackgroundRevNew);
export default __webpack_public_path__ + "static/media/gauge_background_rev_new.964d781585b87e46936505cc5356b4c8.svg";
export { ForwardRef as ReactComponent };